import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Avatar as Avatar$1, Checkbox as Checkbox$1, Tooltip as Tooltip$1, RadioGroup as RadioGroup$1, ScrollArea as ScrollArea$1, Switch, Tabs as Tabs$1, Collapsible, DropdownMenu as DropdownMenu$1 } from "radix-ui";
import * as React from "react";
import React__default, { forwardRef, useCallback, useRef, createElement as createElement$1, useState, useEffect, useId as useId$1, useMemo, useLayoutEffect, useContext, createContext, Fragment as Fragment$1, isValidElement, cloneElement, useReducer, useSyncExternalStore } from "react";
import { SSRBase, UserIcon, MinusIcon, CheckIcon, QuestionIcon, ArrowRightIcon, CopyIcon, CheckCircleIcon, WarningIcon, ArrowSquareOutIcon, CaretDownIcon, CaretRightIcon, XIcon, MagnifyingGlassIcon, CaretUpIcon } from "@phosphor-icons/react/ssr";
import { motion } from "framer-motion";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal, flushSync } from "react-dom";
function r$5(e2) {
  var t2, f2, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2) n2 += e2;
  else if ("object" == typeof e2) if (Array.isArray(e2)) for (t2 = 0; t2 < e2.length; t2++) e2[t2] && (f2 = r$5(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
  else for (t2 in e2) e2[t2] && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function clsx() {
  for (var e2, t2, f2 = 0, n2 = ""; f2 < arguments.length; ) (e2 = arguments[f2++]) && (t2 = r$5(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
SSRBase.defaultProps = {
  weight: "bold"
};
const sizeClassNames$9 = {
  "xs": clsx("ui:w-6 ui:border ui:text-paragraph-100-medium"),
  "sm": clsx("ui:w-8 ui:border ui:text-paragraph-200-medium"),
  "md": clsx("ui:w-10 ui:border-[1.5px] ui:text-paragraph-300-medium"),
  "lg": clsx("ui:w-12 ui:border-2 ui:text-heading-h4"),
  "xl": clsx("ui:w-14 ui:border-2 ui:text-heading-h3"),
  "2xl": clsx("ui:w-16 ui:border-2 ui:text-heading-h2")
};
const avatarClassName = clsx(
  "ui:flex ui:aspect-square ui:items-center ui:justify-center ui:select-none",
  "ui:rounded-full ui:border-transparent ui:bg-subtle ui:text-secondary ui:outline-hidden ui:transition",
  "ui:hover:border-brand ui:hover:text-brand",
  "ui:aria-current-page:border-brand ui:aria-current-page:text-brand",
  "ui:focus-visible:shadow-focus"
);
const imageClassName = clsx("ui:flex-1 ui:rounded-full");
const polyRef$8 = forwardRef;
const Avatar = polyRef$8(
  ({
    as: Component = "button",
    className,
    size: size2 = "md",
    imageUrl,
    initials,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(Avatar$1.Root, { asChild: true, children: /* @__PURE__ */ jsxs(
      Component,
      {
        ...props,
        ref,
        className: clsx(className, sizeClassNames$9[size2], avatarClassName),
        children: [
          imageUrl ? /* @__PURE__ */ jsx(
            Avatar$1.Image,
            {
              src: imageUrl,
              alt: initials || "",
              className: imageClassName
            }
          ) : null,
          /* @__PURE__ */ jsx(Avatar$1.Fallback, { delayMs: imageUrl ? 600 : 0, children: initials || /* @__PURE__ */ jsx(UserIcon, { size: "1.33em" }) })
        ]
      }
    ) });
  }
);
const cardBorderClassName = clsx(
  "ui:group ui:relative ui:isolate ui:flex ui:flex-col ui:outline-hidden",
  "ui:rounded-lg ui:border ui:border-primary ui:bg-card"
);
const interactiveCardBorderClassName = clsx(
  "ui:transition ui:hover:border-card-hover ui:hover:shadow-card-hover",
  "ui:focus-visible:shadow-focus"
);
const polyRef$7 = forwardRef;
const Card = polyRef$7(
  ({ as: Component = "div", children, className, interactive, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Component,
      {
        ref,
        ...props,
        className: clsx(cardBorderClassName, className, {
          [interactiveCardBorderClassName]: interactive
        }),
        children
      }
    );
  }
);
const sizeClassNames$8 = {
  sm: clsx("ui:h-4 ui:w-4 ui:rounded ui:text-xs"),
  md: clsx("ui:h-5 ui:w-5 ui:rounded-md ui:text-sm")
};
const checkboxClassName = clsx(
  "ui:group ui:relative ui:flex ui:items-center ui:justify-center ui:overflow-hidden",
  "ui:border ui:border-primary ui:bg-primary ui:text-brand ui:transition ui:dark:border-gray-700",
  "ui:data-hovered:border-brand ui:data-hovered:bg-input-hover",
  "ui:outline-hidden ui:focus:border-brand ui:focus:shadow-focus",
  "ui:aria-checked:border-brand ui:aria-checked:bg-brand-subtle",
  "ui:data-[state=indeterminate]:border-brand ui:data-[state=indeterminate]:bg-brand-subtle ui:data-[state=indeterminate]:data-[disabled=true]:border-disabled",
  "ui:data-[disabled=true]:border-disabled ui:data-[disabled=true]:bg-disabled ui:data-[disabled=true]:text-disabled"
);
const checkIconClassName = clsx(
  "ui:absolute ui:opacity-0 ui:transition",
  "ui:group-aria-checked:opacity-100"
);
const indeterminateIconClassName = clsx(
  "ui:absolute ui:opacity-0 ui:transition",
  "ui:group-aria-checked:opacity-0 ui:group-data-[state=indeterminate]:opacity-100"
);
const Checkbox = ({
  as: Component = "button",
  className,
  size: size2 = "md",
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Checkbox$1.Root,
    {
      ...props,
      "data-disabled": props.disabled,
      asChild: true,
      className: clsx(className, sizeClassNames$8[size2], checkboxClassName),
      children: /* @__PURE__ */ jsxs(Component, { children: [
        /* @__PURE__ */ jsx(MinusIcon, { className: indeterminateIconClassName, "aria-hidden": "true" }),
        /* @__PURE__ */ jsx(CheckIcon, { className: checkIconClassName, "aria-hidden": "true" })
      ] })
    }
  );
};
const buttonClassName$3 = clsx(
  "ui:whitespace-nowrap ui:outline-hidden ui:transition"
);
const backgroundClassName = {
  none: clsx(
    "ui:focus-visible:shadow-focus ui:dark:focus-visible:shadow-focus-dark"
  ),
  light: clsx(
    "ui:focus-visible:shadow-focus ui:enabled:hover:bg-subtle ui:enabled:active:bg-secondary"
  ),
  dark: clsx(
    "ui:focus-visible:shadow-focus-dark ui:enabled:hover:opacity-70 ui:enabled:active:opacity-50 ui:disabled:opacity-60"
  )
};
const polyRef$6 = forwardRef;
const Command = polyRef$6(
  ({
    as: Component = "button",
    children,
    className,
    background = "light",
    type = "button",
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(
      Component,
      {
        ref,
        ...props,
        type,
        className: clsx(
          buttonClassName$3,
          backgroundClassName[background],
          className
        ),
        children
      }
    );
  }
);
const containerClassName$1 = clsx(
  "ui:flex ui:flex-col ui:items-center ui:gap-2 ui:text-center"
);
const iconClassName$4 = clsx("ui:text-heading-h2 ui:text-warning");
const titleClassName$6 = clsx("ui:text-heading-h4 ui:text-primary");
const messageClassName = clsx(
  "ui:line-clamp-2 ui:text-paragraph-200-regular ui:text-secondary"
);
const buttonClassName$2 = clsx(
  "ui:text-paragraph-200-medium ui:text-critical ui:underline ui:underline-offset-2 ui:transition",
  "ui:hover:no-underline",
  "ui:active:text-critical"
);
const ErrorView = ({ title, message, onRetry }) => {
  return /* @__PURE__ */ jsxs("div", { className: containerClassName$1, children: [
    /* @__PURE__ */ jsx("div", { className: iconClassName$4, children: "👀" }),
    title ? /* @__PURE__ */ jsx("div", { className: titleClassName$6, children: title }) : null,
    message ? /* @__PURE__ */ jsx("div", { className: messageClassName, children: message }) : null,
    onRetry ? /* @__PURE__ */ jsx("button", { className: buttonClassName$2, onClick: onRetry, children: "Refresh" }) : null
  ] });
};
const infoTextClassName = clsx(
  "ui:mt-1 ui:text-paragraph-100-regular",
  "ui:text-tertiary ui:aria-invalid:text-critical"
);
const FieldInfo = ({
  errorMessage,
  description,
  className,
  ...props
}) => {
  if (!errorMessage && !description) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "span",
    {
      ...props,
      "aria-invalid": !!errorMessage,
      className: clsx(className, infoTextClassName),
      children: errorMessage || description
    }
  );
};
const inputRowClassName = clsx("ui:flex");
const inputHolderClassName = clsx(
  "ui:relative ui:flex ui:grow ui:border ui:border-primary ui:bg-input ui:transition",
  "ui:h-[38px] ui:text-paragraph-200-regular",
  "ui:data-[disabled=true]:bg-secondary",
  "ui:hover:border-input-hover ui:hover:bg-input-hover",
  "ui:focus-within:border-brand ui:focus-within:bg-input-hover ui:focus-within:shadow-none ui:focus-within:hover:border-brand",
  "ui:data-[invalid=true]:border-critical",
  "ui:first:rounded-l-lg ui:last:rounded-r-lg"
);
const inputClassName$1 = clsx(
  "ui:block ui:w-full ui:bg-transparent ui:px-3 ui:text-ellipsis ui:text-secondary ui:outline-hidden",
  "ui:placeholder:text-tertiary",
  "ui:disabled:text-tertiary",
  "ui:[font-variant-ligatures:none]"
  // necessary to prevent asterisk rendering bug
);
const inputSlotClassName = clsx(
  "ui:relative ui:self-center ui:text-icon-secondary",
  "ui:first:-mr-1 ui:first:pl-2",
  "ui:last:-ml-1 ui:last:pr-2"
);
const inputTextClassName = clsx(
  "ui:flex ui:items-center ui:px-3 ui:text-paragraph-200-regular ui:whitespace-nowrap ui:text-tertiary",
  "ui:border ui:border-primary ui:bg-subtle",
  "ui:first:rounded-l-lg ui:first:border-r-0 ui:last:rounded-r-lg ui:last:border-l-0"
);
const FieldInput = forwardRef(
  ({
    leadingSlot,
    leadingElement,
    leadingText,
    leadingTextClassName,
    trailingSlot,
    trailingElement,
    trailingText,
    className,
    inputContainerClassName,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsxs("div", { className: clsx(className, inputRowClassName), children: [
      leadingText ? /* @__PURE__ */ jsx("div", { className: clsx(inputTextClassName, leadingTextClassName), children: leadingText }) : null,
      /* @__PURE__ */ jsxs(
        "div",
        {
          "data-disabled": props.disabled,
          "data-invalid": props["aria-invalid"],
          className: clsx(inputHolderClassName, inputContainerClassName),
          children: [
            leadingElement ? leadingElement : leadingSlot ? /* @__PURE__ */ jsx("div", { className: inputSlotClassName, children: leadingSlot }) : null,
            /* @__PURE__ */ jsx("input", { ref, className: inputClassName$1, ...props }),
            trailingElement ? trailingElement : trailingSlot ? /* @__PURE__ */ jsx("div", { className: inputSlotClassName, children: trailingSlot }) : null
          ]
        }
      ),
      trailingText ? /* @__PURE__ */ jsx("div", { className: inputTextClassName, children: trailingText }) : null
    ] });
  }
);
const tooltipClassName = clsx(
  "ui:z-30 ui:rounded-lg ui:px-3 ui:py-2 ui:font-sans ui:text-paragraph-100-regular ui:shadow-gray-lg",
  "ui:bg-tooltip ui:text-invert ui:dark:text-on-light"
);
const secondaryContentClassName = clsx(
  "ui:mt-1 ui:text-invert ui:opacity-80",
  "ui:dark:text-tertiary ui:dark:opacity-100"
);
const anchorClassName = clsx("ui:outline-hidden");
const titleClassName$5 = clsx("ui:mb-1 ui:text-label-100");
const arrowClassName$1 = clsx("ui:fill-tooltip");
const Tooltip = ({
  className,
  children,
  title,
  content,
  withArrow,
  side,
  align,
  open,
  sideOffset = 4,
  theme: theme2,
  disabled
}) => {
  return /* @__PURE__ */ jsx(Tooltip$1.Provider, { children: /* @__PURE__ */ jsxs(Tooltip$1.Root, { open: disabled ? false : open, delayDuration: 150, children: [
    /* @__PURE__ */ jsx(Tooltip$1.Trigger, { asChild: true, className: anchorClassName, children }),
    /* @__PURE__ */ jsx(Tooltip$1.Portal, { children: /* @__PURE__ */ jsxs(
      Tooltip$1.Content,
      {
        className: clsx(className, tooltipClassName, theme2),
        side,
        align,
        collisionPadding: 8,
        arrowPadding: 10,
        sideOffset,
        style: {
          maxWidth: "min(320px, var(--radix-popper-available-width))"
        },
        children: [
          title ? /* @__PURE__ */ jsx("div", { className: titleClassName$5, children: title }) : null,
          title ? /* @__PURE__ */ jsx("div", { className: secondaryContentClassName, children: content }) : content,
          withArrow ? /* @__PURE__ */ jsx(Tooltip$1.Arrow, { className: arrowClassName$1 }) : null
        ]
      }
    ) })
  ] }) });
};
const labelClassName = clsx(
  "ui:mb-2 ui:block ui:text-label-200 ui:text-primary"
);
const FieldLabel = forwardRef(
  ({ className, label, tooltip, ...props }, ref) => {
    if (!label) {
      return null;
    }
    return /* @__PURE__ */ jsxs("label", { ref, ...props, className: clsx(className, labelClassName), children: [
      label,
      (tooltip == null ? void 0 : tooltip.content) ? /* @__PURE__ */ jsx(Tooltip, { content: tooltip.content, title: tooltip.title, withArrow: true, children: /* @__PURE__ */ jsx(QuestionIcon, { className: "ui:-my-0.5 ui:ml-1 ui:inline-block ui:align-baseline ui:text-icon-interactive ui:hover:text-icon-brand" }) }) : null
    ] });
  }
);
const variantClassNames$2 = {
  code: clsx("ui:bg-secondary ui:text-primary"),
  destination: clsx("ui:bg-accent-purple ui:text-accent-purple-contrast")
};
const InlineSnippet = ({
  variant = "code",
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "code",
    {
      ...props,
      className: clsx(
        "ui:inline-block ui:rounded-sm ui:px-1.5 ui:py-0.5 ui:text-code-100",
        variantClassNames$2[variant],
        className
      )
    }
  );
};
const themeCircleClassName = {
  light: clsx("ui:animate-[loading-light_800ms_0ms_ease-out_infinite_both]"),
  dark: clsx("ui:animate-[loading-dark_800ms_0ms_ease-out_infinite_both]")
};
const Loading = ({ theme: theme2 = "dark", ...props }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "200ms" },
            className: themeCircleClassName[theme2],
            cx: "4",
            cy: "24",
            r: "4"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "600ms" },
            className: themeCircleClassName[theme2],
            cx: "44",
            cy: "24",
            r: "4"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "400ms" },
            className: themeCircleClassName[theme2],
            cx: "24",
            cy: "4",
            r: "4"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "0ms" },
            className: themeCircleClassName[theme2],
            cx: "24",
            cy: "44",
            r: "4"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "500ms" },
            className: themeCircleClassName[theme2],
            cx: "38.1421",
            cy: "9.85784",
            r: "4",
            transform: "rotate(45 38.1421 9.85784)"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "100ms" },
            className: themeCircleClassName[theme2],
            cx: "9.85791",
            cy: "38.1421",
            r: "4",
            transform: "rotate(45 9.85791 38.1421)"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "700ms" },
            className: themeCircleClassName[theme2],
            cx: "38.142",
            cy: "38.1421",
            r: "4",
            transform: "rotate(135 38.142 38.1421)"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            style: { animationDelay: "300ms" },
            className: themeCircleClassName[theme2],
            cx: "9.85779",
            cy: "9.85785",
            r: "4",
            transform: "rotate(135 9.85779 9.85785)"
          }
        )
      ]
    }
  );
};
const sizeClassNames$7 = {
  sm: clsx("ui:h-4 ui:w-4 ui:p-1"),
  md: clsx("ui:h-5 ui:w-5 ui:p-[5px]")
};
const radioClassName = clsx(
  "ui:group ui:peer ui:shrink-0 ui:rounded-full ui:border ui:border-primary ui:bg-primary ui:transition ui:dark:border-gray-700",
  "ui:hover:border-brand ui:hover:bg-input-hover",
  "ui:enabled:aria-checked:border-brand ui:enabled:aria-checked:bg-brand-subtle",
  "ui:outline-hidden ui:focus-visible:shadow-focus",
  "ui:disabled:border-disabled ui:disabled:bg-disabled"
);
const indicatorClassName$1 = clsx(
  "ui:block ui:h-full ui:w-full ui:rounded-full ui:bg-brand",
  "ui:group-disabled:bg-contrast-light"
);
const radioItemClassName = clsx("ui:flex ui:items-center ui:gap-2");
const radioLabelClassName = clsx(
  "ui:text-paragraph-200-regular ui:text-primary",
  "ui:peer-aria-checked:peer-enabled:text-paragraph-200-medium"
);
const RadioGroup = ({ ...props }) => {
  return /* @__PURE__ */ jsx(RadioGroup$1.RadioGroup, { ...props });
};
const RadioItem = ({
  className,
  children,
  size: size2 = "md",
  ...props
}) => {
  return /* @__PURE__ */ jsxs("label", { className: clsx(radioItemClassName, className), children: [
    /* @__PURE__ */ jsx(
      RadioGroup$1.Item,
      {
        className: clsx(sizeClassNames$7[size2], radioClassName),
        ...props,
        children: /* @__PURE__ */ jsx(RadioGroup$1.Indicator, { className: indicatorClassName$1 })
      }
    ),
    /* @__PURE__ */ jsx("span", { className: radioLabelClassName, children })
  ] });
};
const Radio = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Group: RadioGroup,
  Item: RadioItem
}, Symbol.toStringTag, { value: "Module" }));
const rootClassName$2 = clsx("ui:flex ui:min-w-0 ui:flex-1 ui:flex-col");
const barClassName = clsx("ui:z-20 ui:flex ui:touch-none ui:select-none");
const verticalBarClassName = clsx("ui:flex-col ui:py-0.5");
const horizontalBarClassName = clsx("ui:px-0.5");
const thumbClassName = clsx("ui:relative ui:rounded ui:transition-colors");
const verticalBarSizesClassNames = {
  sm: clsx("ui:w-2 ui:px-0.5"),
  md: clsx("ui:w-3.5 ui:px-1")
};
const horizontalBarSizesClassNames = {
  sm: clsx("ui:h-2 ui:py-0.5"),
  md: clsx("ui:h-3.5 ui:py-1")
};
const thumbThemeClassNames = {
  dark: clsx("ui:bg-scrollbar-thumb ui:hover:bg-scrollbar-thumb-hover"),
  light: clsx("ui:bg-scrollbar-thumb ui:hover:bg-scrollbar-thumb-hover")
};
const ScrollArea = forwardRef(
  ({
    className,
    scrollBarClassName: scrollBarClassName2,
    viewportClassName,
    children,
    size: size2 = "md",
    theme: theme2 = "dark",
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsxs(
      ScrollArea$1.Root,
      {
        ...props,
        className: clsx(rootClassName$2, className),
        type: "auto",
        children: [
          /* @__PURE__ */ jsx(ScrollArea$1.Viewport, { ref, className: viewportClassName, children }),
          /* @__PURE__ */ jsx(
            ScrollArea$1.Scrollbar,
            {
              forceMount: true,
              orientation: "vertical",
              className: clsx(
                barClassName,
                verticalBarClassName,
                scrollBarClassName2,
                verticalBarSizesClassNames[size2]
              ),
              children: /* @__PURE__ */ jsx(
                ScrollArea$1.Thumb,
                {
                  className: clsx(thumbClassName, thumbThemeClassNames[theme2])
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            ScrollArea$1.Scrollbar,
            {
              forceMount: true,
              orientation: "horizontal",
              className: clsx(
                barClassName,
                horizontalBarClassName,
                scrollBarClassName2,
                horizontalBarSizesClassNames[size2]
              ),
              children: /* @__PURE__ */ jsx(
                ScrollArea$1.Thumb,
                {
                  className: clsx(thumbClassName, thumbThemeClassNames[theme2])
                }
              )
            }
          )
        ]
      }
    );
  }
);
const skeletonClassName = clsx("ui:animate-pulse ui:bg-gradient-linear-gray");
const Skeleton = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx("span", { ...props, className: clsx(skeletonClassName, className) });
};
const sizeClassNames$6 = {
  sm: clsx("ui:h-4 ui:w-[26px]"),
  md: clsx("ui:h-5 ui:w-[34px]"),
  lg: clsx("ui:h-7 ui:w-[50px]")
};
const toggleClassName = clsx(
  "ui:group ui:flex ui:rounded-full ui:p-0.5 ui:transition",
  "ui:cursor-pointer ui:disabled:cursor-not-allowed",
  "ui:bg-contrast-light ui:disabled:bg-disabled ui:aria-checked:bg-brand ui:disabled:aria-checked:bg-brand-light"
);
const indicatorClassName = clsx(
  "ui:aspect-square ui:h-full ui:rounded-full ui:bg-toggle-thumb ui:transition ui:group-aria-checked:translate-x-[calc(100%-2px)]"
);
const Toggle = forwardRef(
  ({ className, size: size2 = "md", ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Switch.Root,
      {
        ...props,
        ref,
        className: clsx(className, sizeClassNames$6[size2], toggleClassName),
        children: /* @__PURE__ */ jsx(Switch.Thumb, { className: indicatorClassName })
      }
    );
  }
);
const headerClassName$1 = clsx(
  "ui:flex ui:w-full ui:flex-row ui:flex-wrap ui:items-center ui:justify-center ui:gap-2 ui:rounded-t-[7px] ui:border-b-1 ui:border-primary ui:bg-card ui:p-6 ui:empty:hidden"
);
const footerClassName = clsx(
  "ui:flex ui:flex-col ui:items-center ui:empty:hidden"
);
const arrowIconClassName = clsx(
  "ui:ml-auto ui:shrink-0 ui:text-tertiary ui:transition",
  "ui:group-hover:translate-x-[2px] ui:group-hover:text-brand",
  "ui:group-active:text-primary"
);
const cardClassName$2 = clsx("ui:flex ui:h-full ui:flex-1 ui:flex-col");
const contentClassName$5 = clsx("ui:flex-1");
const titleClassName$4 = clsx("ui:w-auto ui:flex-shrink-0 ui:text-heading-h4");
const filtersContainerClassName = clsx(
  "ui:ml-auto ui:flex ui:w-auto ui:flex-wrap-reverse ui:items-center ui:gap-x-2"
);
const legendClassName = clsx(
  "ui:flex ui:flex-wrap ui:justify-center ui:gap-x-6 ui:gap-y-1 ui:p-4"
);
const legendItemClassName = clsx("ui:flex ui:items-center ui:gap-1");
const legendLabelClassName = clsx(
  "ui:text-paragraph-100-regular ui:text-secondary"
);
const overlayClassName = clsx(
  "ui:absolute ui:inset-0 ui:z-20 ui:flex ui:items-center ui:justify-center ui:rounded-[7px] ui:bg-card ui:p-5"
);
const errorCardClassName = clsx("ui:border-critical");
const AnalyticsCard = ({
  className,
  as,
  interactive,
  title,
  filters,
  filtersContainerClassName: _filtersContainerClassName,
  legendContainerClassName: _legendContainerClassName,
  footerClassName: _footerClassName,
  headerClassName: _headerClassName,
  titleClassName: _titleClassName,
  contentClassName: _contentClassName,
  legend,
  legendPosition = "bottom",
  children,
  showLoading,
  error: error2,
  isEmpty,
  emptyMessage,
  emptyCta,
  ...props
}) => {
  const Legend = () => {
    return !isEmpty && legend && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("ul", { className: clsx(legendClassName, _legendContainerClassName), children: legend.map((item, index2) => /* @__PURE__ */ jsxs("li", { className: legendItemClassName, children: [
        /* @__PURE__ */ jsx(
          "svg",
          {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            className: item.colorClassName,
            color: item.color,
            children: item.outlined ? /* @__PURE__ */ jsx(
              "circle",
              {
                cx: "6",
                cy: "6",
                r: "5.25",
                fill: "none",
                stroke: "currentColor",
                strokeDasharray: "3 3",
                pathLength: "30"
              }
            ) : /* @__PURE__ */ jsx("circle", { cx: "6", cy: "6", r: "5", fill: "currentColor" })
          }
        ),
        /* @__PURE__ */ jsx("span", { className: legendLabelClassName, children: item.label }),
        item.tooltip && /* @__PURE__ */ jsx(
          Tooltip,
          {
            withArrow: true,
            side: "right",
            title: item.tooltip.title,
            content: item.tooltip.content,
            children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(QuestionIcon, { className: "ui:ml-1 ui:text-tertiary" }) })
          }
        )
      ] }, index2)) }),
      interactive && /* @__PURE__ */ jsx("span", { className: "ui:ml-auto ui:p-4", children: /* @__PURE__ */ jsx(ArrowRightIcon, { className: arrowIconClassName }) })
    ] });
  };
  return /* @__PURE__ */ jsx(
    Card,
    {
      ...props,
      as: showLoading || error2 || isEmpty ? "div" : as,
      interactive: interactive && !showLoading && !error2 && !isEmpty,
      className: clsx("ui:relative ui:hover:z-10", className, {
        [errorCardClassName]: error2 && !showLoading
      }),
      children: /* @__PURE__ */ jsxs("div", { className: cardClassName$2, children: [
        /* @__PURE__ */ jsxs("header", { className: clsx(headerClassName$1, _headerClassName), children: [
          title && /* @__PURE__ */ jsx("div", { className: clsx(titleClassName$4, _titleClassName), children: title }),
          !!(filters == null ? void 0 : filters.length) && /* @__PURE__ */ jsx(
            "div",
            {
              className: clsx(
                filtersContainerClassName,
                _filtersContainerClassName
              ),
              children: filters == null ? void 0 : filters.map((filter, index2) => /* @__PURE__ */ jsx("span", { children: filter }, index2))
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: clsx(
              "ui:relative ui:flex ui:flex-1 ui:flex-col",
              _contentClassName
            ),
            children: [
              legend && legendPosition === "top" && /* @__PURE__ */ jsx(Legend, {}),
              /* @__PURE__ */ jsxs("div", { className: clsx("ui:flex ui:flex-1 ui:flex-col"), children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: clsx(
                      contentClassName$5,
                      isEmpty && "ui:relative ui:z-10"
                    ),
                    children
                  }
                ),
                /* @__PURE__ */ jsx("footer", { className: clsx(footerClassName, _footerClassName), children: legend && legendPosition === "bottom" && /* @__PURE__ */ jsx(Legend, {}) })
              ] }),
              isEmpty && /* @__PURE__ */ jsxs("div", { className: "ui:pointer-events-none ui:absolute ui:inset-0 ui:z-20 ui:flex ui:flex-col ui:items-center ui:justify-center ui:gap-4", children: [
                /* @__PURE__ */ jsx("div", { className: "ui:text-paragraph-200-regular ui:text-secondary", children: emptyMessage || "No data to display" }),
                emptyCta && /* @__PURE__ */ jsx("div", { className: "ui:pointer-events-auto", children: emptyCta })
              ] }),
              showLoading ? /* @__PURE__ */ jsx("div", { className: overlayClassName, children: /* @__PURE__ */ jsx(Loading, {}) }) : null,
              error2 && !showLoading ? /* @__PURE__ */ jsx("div", { className: overlayClassName, children: /* @__PURE__ */ jsx(ErrorView, { ...error2 }) }) : null
            ]
          }
        )
      ] })
    }
  );
};
const sizeClassNames$5 = {
  lg: clsx("ui:px-3 ui:py-2"),
  md: clsx("ui:px-2 ui:py-1"),
  sm: clsx("ui:px-2 ui:py-px")
};
const variantClassNames$1 = {
  "outlined": clsx(
    "ui:bg-primary ui:text-primary ui:shadow-border ui:shadow-primary"
  ),
  "primary": clsx(
    "ui:bg-brand-subtle ui:text-brand ui:shadow-border ui:shadow-brand"
  ),
  "primary-solid": clsx("ui:bg-brand ui:text-invert"),
  "gray": clsx(
    "ui:bg-secondary ui:text-primary ui:shadow-border ui:shadow-primary",
    "ui:dark:bg-contrast-medium"
  ),
  "purple": clsx("ui:bg-accent-purple ui:text-accent-purple-contrast"),
  "critical": clsx(
    "ui:bg-critical-subtle ui:text-critical ui:shadow-border ui:shadow-critical"
  ),
  "critical-solid": clsx("ui:bg-critical-dark ui:text-invert"),
  "warning": clsx(
    "ui:bg-warning-subtle ui:text-warning ui:shadow-border ui:shadow-warning"
  ),
  "warning-solid": clsx("ui:bg-warning-dark ui:text-invert"),
  "success": clsx(
    "ui:bg-success-subtle ui:text-success ui:shadow-border ui:shadow-success"
  ),
  "success-solid": clsx("ui:bg-success-dark ui:text-invert")
};
const badgeClassName = clsx(
  "ui:inline-flex ui:gap-1 ui:rounded-full ui:text-label-100"
);
const Badge = forwardRef(
  ({
    children,
    className,
    size: size2 = "md",
    variant = "outlined",
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        ...props,
        ref,
        className: clsx(
          className,
          badgeClassName,
          sizeClassNames$5[size2],
          variantClassNames$1[variant]
        ),
        children
      }
    );
  }
);
const intentClassNames$1 = {
  primary: clsx(
    "ui:border-transparent ui:bg-brand ui:text-invert",
    "ui:hover:bg-button-primary-hover",
    "ui:active:bg-button-primary-active",
    "ui:focus-visible:shadow-focus-offset"
  ),
  secondary: clsx(
    "ui:border-transparent ui:bg-contrast-dark ui:text-invert",
    "ui:hover:bg-contrast-medium",
    "ui:active:bg-contrast-darkest",
    "ui:focus-visible:shadow-focus"
  ),
  tertiary: clsx(
    "ui:border-primary ui:bg-button-tertiary ui:text-secondary",
    "ui:hover:border-button-tertiary-hover ui:hover:bg-button-tertiary-hover",
    "ui:active:bg-secondary",
    "ui:focus-visible:shadow-focus"
  ),
  critical: clsx(
    "ui:border-critical ui:bg-primary ui:text-critical",
    "ui:hover:bg-critical-light",
    "ui:active:bg-critical-medium",
    "ui:focus-visible:shadow-focus"
  ),
  warning: clsx(
    "ui:border-warning ui:bg-primary ui:text-warning",
    "ui:hover:bg-warning-light",
    "ui:active:bg-warning-medium",
    "ui:focus-visible:shadow-focus"
  )
};
const sizeClassNames$4 = {
  sm: clsx("ui:h-8 ui:px-2.5 ui:text-label-100"),
  md: clsx("ui:h-[38px] ui:px-2.5 ui:text-label-200"),
  lg: clsx("ui:h-11 ui:px-3 ui:text-label-300")
};
const loadingIconSizeClassName = {
  sm: clsx("ui:size-4"),
  md: clsx("ui:size-5"),
  lg: clsx("ui:size-6")
};
const baseButtonClassName$1 = clsx(
  "ui:flex ui:items-center ui:justify-center ui:gap-1.5 ui:text-start",
  "ui:rounded-lg ui:border ui:whitespace-nowrap ui:outline-hidden ui:transition",
  "ui:disabled:border-transparent ui:disabled:bg-disabled ui:disabled:text-disabled"
);
const iconClassName$3 = clsx("ui:only:-mx-px");
const polyRef$5 = forwardRef;
const Button = polyRef$5(
  ({
    as: Component = "button",
    size: size2 = "md",
    intent = "primary",
    children,
    icon,
    loading,
    disabled,
    leadingIcon,
    trailingIcon,
    className,
    type = "button",
    ...props
  }, ref) => {
    const loadingIcon = loading ? /* @__PURE__ */ jsx(Loading, { className: loadingIconSizeClassName[size2] }) : null;
    return /* @__PURE__ */ jsxs(
      Component,
      {
        ...props,
        type,
        disabled: disabled || loading,
        "aria-busy": loading || void 0,
        ref,
        className: clsx(
          sizeClassNames$4[size2],
          intentClassNames$1[intent],
          baseButtonClassName$1,
          className
        ),
        children: [
          loadingIcon || leadingIcon || icon ? /* @__PURE__ */ jsx("span", { className: iconClassName$3, children: loadingIcon || leadingIcon || icon }) : null,
          children ? /* @__PURE__ */ jsx("span", { className: "ui:min-w-0 ui:truncate", children }) : null,
          trailingIcon ? /* @__PURE__ */ jsx("span", { className: iconClassName$3, children: trailingIcon }) : null
        ]
      }
    );
  }
);
const sizeClassNames$3 = {
  sm: clsx("ui:h-8 ui:px-2 ui:text-label-200"),
  md: clsx("ui:h-10 ui:px-3.5 ui:text-label-300")
};
const structuralClassName = clsx(
  "ui:flex ui:items-center ui:gap-1.5 ui:rounded-lg ui:border ui:text-left ui:outline-hidden ui:transition",
  "ui:group/copy",
  "ui:focus-visible:shadow-focus"
);
const colorClassNames = {
  inherit: clsx(
    "ui:border-primary ui:bg-button-tertiary ui:text-secondary",
    "ui:hover:border-button-tertiary-hover ui:hover:bg-button-tertiary-hover",
    "ui:active:bg-secondary",
    "ui:aria-pressed:border-success ui:aria-pressed:bg-success-medium ui:aria-pressed:text-success",
    "ui:disabled:border-disabled ui:disabled:text-disabled"
  ),
  invert: clsx(
    "ui:border-contrast-dark ui:bg-contrast-dark ui:text-invert",
    "ui:hover:bg-contrast-darkest",
    "ui:aria-pressed:border-success ui:aria-pressed:bg-success-dark ui:aria-pressed:text-invert",
    "ui:disabled:border-contrast-dark ui:disabled:text-icon-disabled",
    "ui:dark:border-primary ui:dark:bg-button-tertiary ui:dark:text-secondary",
    "ui:dark:hover:border-button-tertiary-hover ui:dark:hover:bg-button-tertiary-hover",
    "ui:dark:aria-pressed:border-success ui:dark:aria-pressed:bg-success-medium ui:dark:aria-pressed:text-success",
    "ui:dark:disabled:border-disabled ui:dark:disabled:text-disabled"
  )
};
const CopyTextButton = ({
  value,
  theme: theme2 = "inherit",
  size: size2 = "md",
  className,
  children = "Copy",
  onClick,
  ...props
}) => {
  const { isCopiedToClipboard, handleCopyToClipboard } = useCopyToClipboard();
  const handleCopy = useCallback(
    (event) => {
      handleCopyToClipboard(value);
      onClick == null ? void 0 : onClick(event);
    },
    [value, handleCopyToClipboard, onClick]
  );
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      ...props,
      className: clsx(
        structuralClassName,
        sizeClassNames$3[size2],
        colorClassNames[theme2],
        className
      ),
      onClick: handleCopy,
      "aria-pressed": isCopiedToClipboard,
      children: [
        /* @__PURE__ */ jsxs("span", { className: "ui:relative", children: [
          /* @__PURE__ */ jsx(
            CopyIcon,
            {
              className: clsx(
                "ui:group-disabled/copy:text-icon-disabled ui:first:absolute",
                theme2 === "invert" ? clsx("ui:text-icon-invert", "ui:dark:text-icon-secondary") : "ui:text-icon-secondary"
              ),
              style: { opacity: isCopiedToClipboard ? 0 : 1 }
            }
          ),
          /* @__PURE__ */ jsx(
            CheckCircleIcon,
            {
              className: clsx(
                "ui:group-disabled/copy:text-icon-disabled",
                theme2 === "invert" ? clsx("ui:text-icon-success", "ui:dark:text-icon-success") : "ui:text-icon-success"
              ),
              style: { opacity: isCopiedToClipboard ? 1 : 0 }
            }
          )
        ] }),
        isCopiedToClipboard ? "Copied" : children
      ]
    }
  );
};
const listClassName = clsx(
  "ui:z-10 ui:flex ui:shrink-0 ui:gap-8",
  "ui:focus-visible-within:shadow-focus"
);
const lineClassName = clsx(
  "ui:absolute ui:inset-x-0 ui:bottom-0 ui:border-b-2 ui:border-primary"
);
const TabsList = forwardRef(({ children, className, ...props }, ref) => {
  return /* @__PURE__ */ jsxs("div", { className: clsx("ui:relative", className), ref, ...props, children: [
    /* @__PURE__ */ jsx("div", { className: lineClassName, "aria-hidden": "true" }),
    /* @__PURE__ */ jsx(ScrollArea, { scrollBarClassName: "ui:hidden", className: "ui:relative", children: /* @__PURE__ */ jsx("div", { className: listClassName, children }) })
  ] });
});
const triggerClassName = clsx(
  "ui:text-tertiary ui:hover:text-primary",
  "ui:relative ui:flex ui:h-8 ui:items-center ui:gap-2 ui:whitespace-nowrap",
  "ui:outline-hidden ui:focus-visible:shadow-focus",
  "ui:border-b-2 ui:border-transparent",
  "ui:aria-selected:border-interactive ui:aria-selected:text-primary",
  "ui:aria-current-page:border-interactive ui:aria-current-page:text-primary"
);
const triggerSizeClassNames = {
  sm: clsx("ui:text-label-100"),
  md: clsx("ui:text-label-200")
};
const polyRef$4 = forwardRef;
const TabsTrigger = polyRef$4(
  ({ as: Component = "button", size: size2 = "md", tab, className, ...props }, ref) => {
    return /* @__PURE__ */ jsxs(
      Component,
      {
        ref,
        className: clsx(
          triggerClassName,
          triggerSizeClassNames[size2],
          className
        ),
        ...props,
        children: [
          tab.icon,
          tab.title,
          tab.trailingIcon
        ]
      }
    );
  }
);
const rootClassName$1 = clsx("ui:relative ui:flex ui:flex-col");
const contentClassName$4 = clsx(
  "ui:min-h-0 ui:flex-1 ui:flex-col ui:py-3 ui:outline-hidden",
  "ui:data-[state=active]:flex"
);
const Tabs = ({
  className,
  tabs,
  size: size2 = "md",
  activeTab,
  onActiveTabChange
}) => {
  return /* @__PURE__ */ jsxs(
    Tabs$1.Root,
    {
      className: clsx(className, rootClassName$1),
      defaultValue: tabs[0].value,
      value: activeTab,
      onValueChange: onActiveTabChange,
      children: [
        /* @__PURE__ */ jsx(Tabs$1.List, { asChild: true, children: /* @__PURE__ */ jsx(TabsList, { children: tabs.map((tab) => /* @__PURE__ */ jsx(Tabs$1.Trigger, { asChild: true, value: tab.value, children: /* @__PURE__ */ jsx(TabsTrigger, { tab, size: size2 }) }, tab.value)) }) }),
        tabs.map((tab) => /* @__PURE__ */ jsx(
          Tabs$1.Content,
          {
            className: contentClassName$4,
            value: tab.value,
            children: tab.content
          },
          tab.value
        ))
      ]
    }
  );
};
Tabs.List = TabsList;
Tabs.Trigger = TabsTrigger;
function _objectWithoutPropertiesLoose(r2, e2) {
  if (null == r2) return {};
  var t2 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (e2.indexOf(n2) >= 0) continue;
    t2[n2] = r2[n2];
  }
  return t2;
}
function _objectWithoutProperties(e2, t2) {
  if (null == e2) return {};
  var o4, r2, i2 = _objectWithoutPropertiesLoose(e2, t2);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e2);
    for (r2 = 0; r2 < n2.length; r2++) o4 = n2[r2], t2.indexOf(o4) >= 0 || {}.propertyIsEnumerable.call(e2, o4) && (i2[o4] = e2[o4]);
  }
  return i2;
}
function _arrayLikeToArray(r2, a3) {
  (null == a3 || a3 > r2.length) && (a3 = r2.length);
  for (var e2 = 0, n2 = Array(a3); e2 < a3; e2++) n2[e2] = r2[e2];
  return n2;
}
function _arrayWithoutHoles(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray(r2);
}
function _iterableToArray(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _unsupportedIterableToArray(r2, a3) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a3);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray(r2, a3) : void 0;
  }
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r2) {
  return _arrayWithoutHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray(r2) || _nonIterableSpread();
}
function _typeof(o4) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o5) {
    return typeof o5;
  } : function(o5) {
    return o5 && "function" == typeof Symbol && o5.constructor === Symbol && o5 !== Symbol.prototype ? "symbol" : typeof o5;
  }, _typeof(o4);
}
function toPrimitive(t2, r2) {
  if ("object" != _typeof(t2) || !t2) return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t2, r2);
    if ("object" != _typeof(i2)) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function toPropertyKey(t2) {
  var i2 = toPrimitive(t2, "string");
  return "symbol" == _typeof(i2) ? i2 : i2 + "";
}
function _defineProperty(e2, r2, t2) {
  return (r2 = toPropertyKey(r2)) in e2 ? Object.defineProperty(e2, r2, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e2[r2] = t2, e2;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t2 = arguments[e2];
      for (var r2 in t2) ({}).hasOwnProperty.call(t2, r2) && (n2[r2] = t2[r2]);
    }
    return n2;
  }, _extends$1.apply(null, arguments);
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function powerSetPermutations(arr) {
  var arrLength = arr.length;
  if (arrLength === 0 || arrLength === 1) return arr;
  if (arrLength === 2) {
    return [arr[0], arr[1], "".concat(arr[0], ".").concat(arr[1]), "".concat(arr[1], ".").concat(arr[0])];
  }
  if (arrLength === 3) {
    return [arr[0], arr[1], arr[2], "".concat(arr[0], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[2]), "".concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])];
  }
  if (arrLength >= 4) {
    return [arr[0], arr[1], arr[2], arr[3], "".concat(arr[0], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[3]), "".concat(arr[3], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])];
  }
}
var classNameCombinations = {};
function getClassNameCombinations(classNames) {
  if (classNames.length === 0 || classNames.length === 1) return classNames;
  var key = classNames.join(".");
  if (!classNameCombinations[key]) {
    classNameCombinations[key] = powerSetPermutations(classNames);
  }
  return classNameCombinations[key];
}
function createStyleObject(classNames) {
  var elementStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var stylesheet = arguments.length > 2 ? arguments[2] : void 0;
  var nonTokenClassNames = classNames.filter(function(className) {
    return className !== "token";
  });
  var classNamesCombinations = getClassNameCombinations(nonTokenClassNames);
  return classNamesCombinations.reduce(function(styleObject, className) {
    return _objectSpread$1(_objectSpread$1({}, styleObject), stylesheet[className]);
  }, elementStyle);
}
function createClassNameString(classNames) {
  return classNames.join(" ");
}
function createChildren(stylesheet, useInlineStyles) {
  var childrenCount = 0;
  return function(children) {
    childrenCount += 1;
    return children.map(function(child, i2) {
      return createElement({
        node: child,
        stylesheet,
        useInlineStyles,
        key: "code-segment-".concat(childrenCount, "-").concat(i2)
      });
    });
  };
}
function createElement(_ref) {
  var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
  var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
  if (type === "text") {
    return value;
  } else if (TagName) {
    var childrenCreator = createChildren(stylesheet, useInlineStyles);
    var props;
    if (!useInlineStyles) {
      props = _objectSpread$1(_objectSpread$1({}, properties), {}, {
        className: createClassNameString(properties.className)
      });
    } else {
      var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
        selector.split(".").forEach(function(className2) {
          if (!classes.includes(className2)) classes.push(className2);
        });
        return classes;
      }, []);
      var startingClassName = properties.className && properties.className.includes("token") ? ["token"] : [];
      var className = properties.className && startingClassName.concat(properties.className.filter(function(className2) {
        return !allStylesheetSelectors.includes(className2);
      }));
      props = _objectSpread$1(_objectSpread$1({}, properties), {}, {
        className: createClassNameString(className) || void 0,
        style: createStyleObject(properties.className, Object.assign({}, properties.style, style), stylesheet)
      });
    }
    var children = childrenCreator(node.children);
    return /* @__PURE__ */ React__default.createElement(TagName, _extends$1({
      key
    }, props), children);
  }
}
const checkForListedLanguage = function(astGenerator, language) {
  var langs = astGenerator.listLanguages();
  return langs.indexOf(language) !== -1;
};
var _excluded = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var newLineRegex = /\n/g;
function getNewLines(str) {
  return str.match(newLineRegex);
}
function getAllLineNumbers(_ref) {
  var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
  return lines.map(function(_2, i2) {
    var number = i2 + startingLineNumber;
    return /* @__PURE__ */ React__default.createElement("span", {
      key: "line-".concat(i2),
      className: "react-syntax-highlighter-line-number",
      style: typeof style === "function" ? style(number) : style
    }, "".concat(number, "\n"));
  });
}
function AllLineNumbers(_ref2) {
  var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
    "float": "left",
    paddingRight: "10px"
  } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
  return /* @__PURE__ */ React__default.createElement("code", {
    style: Object.assign({}, codeStyle, containerStyle)
  }, getAllLineNumbers({
    lines: codeString.replace(/\n$/, "").split("\n"),
    style: numberStyle,
    startingLineNumber
  }));
}
function getEmWidthOfNumber(num) {
  return "".concat(num.toString().length, ".25em");
}
function getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(lineNumber),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: inlineLineNumberStyle
    },
    children: [{
      type: "text",
      value: lineNumber
    }]
  };
}
function assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
  var defaultLineNumberStyle = {
    display: "inline-block",
    minWidth: getEmWidthOfNumber(largestLineNumber),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  };
  var customLineNumberStyle = typeof lineNumberStyle === "function" ? lineNumberStyle(lineNumber) : lineNumberStyle;
  var assembledStyle = _objectSpread(_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
  return assembledStyle;
}
function createLineElement(_ref3) {
  var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines;
  var properties = typeof lineProps === "function" ? lineProps(lineNumber) : lineProps;
  properties["className"] = className;
  if (lineNumber && showInlineLineNumbers) {
    var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
    children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
  }
  if (wrapLongLines & showLineNumbers) {
    properties.style = _objectSpread(_objectSpread({}, properties.style), {}, {
      display: "flex"
    });
  }
  return {
    type: "element",
    tagName: "span",
    properties,
    children
  };
}
function flattenCodeTree(tree) {
  var className = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var newTree = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
  for (var i2 = 0; i2 < tree.length; i2++) {
    var node = tree[i2];
    if (node.type === "text") {
      newTree.push(createLineElement({
        children: [node],
        className: _toConsumableArray(new Set(className))
      }));
    } else if (node.children) {
      var classNames = className.concat(node.properties.className);
      flattenCodeTree(node.children, classNames).forEach(function(i3) {
        return newTree.push(i3);
      });
    }
  }
  return newTree;
}
function processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
  var _ref4;
  var tree = flattenCodeTree(codeTree.value);
  var newTree = [];
  var lastLineBreakIndex = -1;
  var index2 = 0;
  function createWrappedLine(children2, lineNumber2) {
    var className = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return createLineElement({
      children: children2,
      lineNumber: lineNumber2,
      lineNumberStyle,
      largestLineNumber,
      showInlineLineNumbers,
      lineProps,
      className,
      showLineNumbers,
      wrapLongLines
    });
  }
  function createUnwrappedLine(children2, lineNumber2) {
    if (showLineNumbers && lineNumber2 && showInlineLineNumbers) {
      var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber2, largestLineNumber);
      children2.unshift(getInlineLineNumber(lineNumber2, inlineLineNumberStyle));
    }
    return children2;
  }
  function createLine(children2, lineNumber2) {
    var className = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return wrapLines || className.length > 0 ? createWrappedLine(children2, lineNumber2, className) : createUnwrappedLine(children2, lineNumber2);
  }
  var _loop = function _loop2() {
    var node = tree[index2];
    var value = node.children[0].value;
    var newLines = getNewLines(value);
    if (newLines) {
      var splitValue = value.split("\n");
      splitValue.forEach(function(text, i2) {
        var lineNumber2 = showLineNumbers && newTree.length + startingLineNumber;
        var newChild = {
          type: "text",
          value: "".concat(text, "\n")
        };
        if (i2 === 0) {
          var _children = tree.slice(lastLineBreakIndex + 1, index2).concat(createLineElement({
            children: [newChild],
            className: node.properties.className
          }));
          var _line = createLine(_children, lineNumber2);
          newTree.push(_line);
        } else if (i2 === splitValue.length - 1) {
          var stringChild = tree[index2 + 1] && tree[index2 + 1].children && tree[index2 + 1].children[0];
          var lastLineInPreviousSpan = {
            type: "text",
            value: "".concat(text)
          };
          if (stringChild) {
            var newElem = createLineElement({
              children: [lastLineInPreviousSpan],
              className: node.properties.className
            });
            tree.splice(index2 + 1, 0, newElem);
          } else {
            var _children2 = [lastLineInPreviousSpan];
            var _line2 = createLine(_children2, lineNumber2, node.properties.className);
            newTree.push(_line2);
          }
        } else {
          var _children3 = [newChild];
          var _line3 = createLine(_children3, lineNumber2, node.properties.className);
          newTree.push(_line3);
        }
      });
      lastLineBreakIndex = index2;
    }
    index2++;
  };
  while (index2 < tree.length) {
    _loop();
  }
  if (lastLineBreakIndex !== tree.length - 1) {
    var children = tree.slice(lastLineBreakIndex + 1, tree.length);
    if (children && children.length) {
      var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
      var line = createLine(children, lineNumber);
      newTree.push(line);
    }
  }
  return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function defaultRenderer(_ref5) {
  var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
  return rows.map(function(node, i2) {
    return createElement({
      node,
      stylesheet,
      useInlineStyles,
      key: "code-segement".concat(i2)
    });
  });
}
function isHighlightJs(astGenerator) {
  return astGenerator && typeof astGenerator.highlightAuto !== "undefined";
}
function getCodeTree(_ref6) {
  var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
  if (isHighlightJs(astGenerator)) {
    var hasLanguage = checkForListedLanguage(astGenerator, language);
    if (language === "text") {
      return {
        value: defaultCodeValue,
        language: "text"
      };
    } else if (hasLanguage) {
      return astGenerator.highlight(language, code);
    } else {
      return astGenerator.highlightAuto(code);
    }
  }
  try {
    return language && language !== "text" ? {
      value: astGenerator.highlight(code, language)
    } : {
      value: defaultCodeValue
    };
  } catch (e2) {
    return {
      value: defaultCodeValue
    };
  }
}
function highlight(defaultAstGenerator, defaultStyle) {
  return function SyntaxHighlighter2(_ref7) {
    var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
      className: language ? "language-".concat(language) : void 0,
      style: _objectSpread(_objectSpread({}, style['code[class*="language-"]']), style['code[class*="language-'.concat(language, '"]')])
    } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? "pre" : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? "code" : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || "" : _ref7$code, astGenerator = _ref7.astGenerator, rest = _objectWithoutProperties(_ref7, _excluded);
    astGenerator = astGenerator || defaultAstGenerator;
    var allLineNumbers = showLineNumbers ? /* @__PURE__ */ React__default.createElement(AllLineNumbers, {
      containerStyle: lineNumberContainerStyle,
      codeStyle: codeTagProps.style || {},
      numberStyle: lineNumberStyle,
      startingLineNumber,
      codeString: code
    }) : null;
    var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    };
    var generatorClassName = isHighlightJs(astGenerator) ? "hljs" : "prismjs";
    var preProps = useInlineStyles ? Object.assign({}, rest, {
      style: Object.assign({}, defaultPreStyle, customStyle)
    }) : Object.assign({}, rest, {
      className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
      style: Object.assign({}, customStyle)
    });
    if (wrapLongLines) {
      codeTagProps.style = _objectSpread(_objectSpread({}, codeTagProps.style), {}, {
        whiteSpace: "pre-wrap"
      });
    } else {
      codeTagProps.style = _objectSpread(_objectSpread({}, codeTagProps.style), {}, {
        whiteSpace: "pre"
      });
    }
    if (!astGenerator) {
      return /* @__PURE__ */ React__default.createElement(PreTag, preProps, allLineNumbers, /* @__PURE__ */ React__default.createElement(CodeTag, codeTagProps, code));
    }
    if (wrapLines === void 0 && renderer || wrapLongLines) wrapLines = true;
    renderer = renderer || defaultRenderer;
    var defaultCodeValue = [{
      type: "text",
      value: code
    }];
    var codeTree = getCodeTree({
      astGenerator,
      language,
      code,
      defaultCodeValue
    });
    if (codeTree.language === null) {
      codeTree.value = defaultCodeValue;
    }
    var largestLineNumber = codeTree.value.length + startingLineNumber;
    var rows = processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
    return /* @__PURE__ */ React__default.createElement(PreTag, preProps, /* @__PURE__ */ React__default.createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
      rows,
      stylesheet: style,
      useInlineStyles
    })));
  };
}
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (Object.prototype.hasOwnProperty.call(n2, "__esModule")) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a3 = function a4() {
      if (this instanceof a4) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a3.prototype = f2.prototype;
  } else a3 = {};
  Object.defineProperty(a3, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a3, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a3;
}
var core$1 = {};
var core;
var hasRequiredCore$1;
function requireCore$1() {
  if (hasRequiredCore$1) return core;
  hasRequiredCore$1 = 1;
  function deepFreeze(obj) {
    if (obj instanceof Map) {
      obj.clear = obj.delete = obj.set = function() {
        throw new Error("map is read-only");
      };
    } else if (obj instanceof Set) {
      obj.add = obj.clear = obj.delete = function() {
        throw new Error("set is read-only");
      };
    }
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach(function(name) {
      var prop = obj[name];
      if (typeof prop == "object" && !Object.isFrozen(prop)) {
        deepFreeze(prop);
      }
    });
    return obj;
  }
  var deepFreezeEs6 = deepFreeze;
  var _default = deepFreeze;
  deepFreezeEs6.default = _default;
  class Response {
    /**
     * @param {CompiledMode} mode
     */
    constructor(mode) {
      if (mode.data === void 0) mode.data = {};
      this.data = mode.data;
      this.isMatchIgnored = false;
    }
    ignoreMatch() {
      this.isMatchIgnored = true;
    }
  }
  function escapeHTML(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
  }
  function inherit(original, ...objects) {
    const result = /* @__PURE__ */ Object.create(null);
    for (const key in original) {
      result[key] = original[key];
    }
    objects.forEach(function(obj) {
      for (const key in obj) {
        result[key] = obj[key];
      }
    });
    return (
      /** @type {T} */
      result
    );
  }
  const SPAN_CLOSE = "</span>";
  const emitsWrappingTags = (node) => {
    return !!node.kind;
  };
  class HTMLRenderer {
    /**
     * Creates a new HTMLRenderer
     *
     * @param {Tree} parseTree - the parse tree (must support `walk` API)
     * @param {{classPrefix: string}} options
     */
    constructor(parseTree, options) {
      this.buffer = "";
      this.classPrefix = options.classPrefix;
      parseTree.walk(this);
    }
    /**
     * Adds texts to the output stream
     *
     * @param {string} text */
    addText(text) {
      this.buffer += escapeHTML(text);
    }
    /**
     * Adds a node open to the output stream (if needed)
     *
     * @param {Node} node */
    openNode(node) {
      if (!emitsWrappingTags(node)) return;
      let className = node.kind;
      if (!node.sublanguage) {
        className = `${this.classPrefix}${className}`;
      }
      this.span(className);
    }
    /**
     * Adds a node close to the output stream (if needed)
     *
     * @param {Node} node */
    closeNode(node) {
      if (!emitsWrappingTags(node)) return;
      this.buffer += SPAN_CLOSE;
    }
    /**
     * returns the accumulated buffer
    */
    value() {
      return this.buffer;
    }
    // helpers
    /**
     * Builds a span element
     *
     * @param {string} className */
    span(className) {
      this.buffer += `<span class="${className}">`;
    }
  }
  class TokenTree {
    constructor() {
      this.rootNode = { children: [] };
      this.stack = [this.rootNode];
    }
    get top() {
      return this.stack[this.stack.length - 1];
    }
    get root() {
      return this.rootNode;
    }
    /** @param {Node} node */
    add(node) {
      this.top.children.push(node);
    }
    /** @param {string} kind */
    openNode(kind) {
      const node = { kind, children: [] };
      this.add(node);
      this.stack.push(node);
    }
    closeNode() {
      if (this.stack.length > 1) {
        return this.stack.pop();
      }
      return void 0;
    }
    closeAllNodes() {
      while (this.closeNode()) ;
    }
    toJSON() {
      return JSON.stringify(this.rootNode, null, 4);
    }
    /**
     * @typedef { import("./html_renderer").Renderer } Renderer
     * @param {Renderer} builder
     */
    walk(builder) {
      return this.constructor._walk(builder, this.rootNode);
    }
    /**
     * @param {Renderer} builder
     * @param {Node} node
     */
    static _walk(builder, node) {
      if (typeof node === "string") {
        builder.addText(node);
      } else if (node.children) {
        builder.openNode(node);
        node.children.forEach((child) => this._walk(builder, child));
        builder.closeNode(node);
      }
      return builder;
    }
    /**
     * @param {Node} node
     */
    static _collapse(node) {
      if (typeof node === "string") return;
      if (!node.children) return;
      if (node.children.every((el) => typeof el === "string")) {
        node.children = [node.children.join("")];
      } else {
        node.children.forEach((child) => {
          TokenTree._collapse(child);
        });
      }
    }
  }
  class TokenTreeEmitter extends TokenTree {
    /**
     * @param {*} options
     */
    constructor(options) {
      super();
      this.options = options;
    }
    /**
     * @param {string} text
     * @param {string} kind
     */
    addKeyword(text, kind) {
      if (text === "") {
        return;
      }
      this.openNode(kind);
      this.addText(text);
      this.closeNode();
    }
    /**
     * @param {string} text
     */
    addText(text) {
      if (text === "") {
        return;
      }
      this.add(text);
    }
    /**
     * @param {Emitter & {root: DataNode}} emitter
     * @param {string} name
     */
    addSublanguage(emitter, name) {
      const node = emitter.root;
      node.kind = name;
      node.sublanguage = true;
      this.add(node);
    }
    toHTML() {
      const renderer = new HTMLRenderer(this, this.options);
      return renderer.value();
    }
    finalize() {
      return true;
    }
  }
  function escape(value) {
    return new RegExp(value.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
  }
  function source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
  }
  function concat(...args) {
    const joined = args.map((x2) => source(x2)).join("");
    return joined;
  }
  function either(...args) {
    const joined = "(" + args.map((x2) => source(x2)).join("|") + ")";
    return joined;
  }
  function countMatchGroups(re) {
    return new RegExp(re.toString() + "|").exec("").length - 1;
  }
  function startsWith(re, lexeme) {
    const match = re && re.exec(lexeme);
    return match && match.index === 0;
  }
  const BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
  function join(regexps, separator = "|") {
    let numCaptures = 0;
    return regexps.map((regex) => {
      numCaptures += 1;
      const offset2 = numCaptures;
      let re = source(regex);
      let out = "";
      while (re.length > 0) {
        const match = BACKREF_RE.exec(re);
        if (!match) {
          out += re;
          break;
        }
        out += re.substring(0, match.index);
        re = re.substring(match.index + match[0].length);
        if (match[0][0] === "\\" && match[1]) {
          out += "\\" + String(Number(match[1]) + offset2);
        } else {
          out += match[0];
          if (match[0] === "(") {
            numCaptures++;
          }
        }
      }
      return out;
    }).map((re) => `(${re})`).join(separator);
  }
  const MATCH_NOTHING_RE = /\b\B/;
  const IDENT_RE = "[a-zA-Z]\\w*";
  const UNDERSCORE_IDENT_RE = "[a-zA-Z_]\\w*";
  const NUMBER_RE = "\\b\\d+(\\.\\d+)?";
  const C_NUMBER_RE = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)";
  const BINARY_NUMBER_RE = "\\b(0b[01]+)";
  const RE_STARTERS_RE = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~";
  const SHEBANG = (opts = {}) => {
    const beginShebang = /^#![ ]*\//;
    if (opts.binary) {
      opts.begin = concat(
        beginShebang,
        /.*\b/,
        opts.binary,
        /\b.*/
      );
    }
    return inherit({
      className: "meta",
      begin: beginShebang,
      end: /$/,
      relevance: 0,
      /** @type {ModeCallback} */
      "on:begin": (m2, resp) => {
        if (m2.index !== 0) resp.ignoreMatch();
      }
    }, opts);
  };
  const BACKSLASH_ESCAPE = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
  };
  const APOS_STRING_MODE = {
    className: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [BACKSLASH_ESCAPE]
  };
  const QUOTE_STRING_MODE = {
    className: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [BACKSLASH_ESCAPE]
  };
  const PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  };
  const COMMENT = function(begin, end, modeOptions = {}) {
    const mode = inherit(
      {
        className: "comment",
        begin,
        end,
        contains: []
      },
      modeOptions
    );
    mode.contains.push(PHRASAL_WORDS_MODE);
    mode.contains.push({
      className: "doctag",
      begin: "(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",
      relevance: 0
    });
    return mode;
  };
  const C_LINE_COMMENT_MODE = COMMENT("//", "$");
  const C_BLOCK_COMMENT_MODE = COMMENT("/\\*", "\\*/");
  const HASH_COMMENT_MODE = COMMENT("#", "$");
  const NUMBER_MODE = {
    className: "number",
    begin: NUMBER_RE,
    relevance: 0
  };
  const C_NUMBER_MODE = {
    className: "number",
    begin: C_NUMBER_RE,
    relevance: 0
  };
  const BINARY_NUMBER_MODE = {
    className: "number",
    begin: BINARY_NUMBER_RE,
    relevance: 0
  };
  const CSS_NUMBER_MODE = {
    className: "number",
    begin: NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  };
  const REGEXP_MODE = {
    // this outer rule makes sure we actually have a WHOLE regex and not simply
    // an expression such as:
    //
    //     3 / something
    //
    // (which will then blow up when regex's `illegal` sees the newline)
    begin: /(?=\/[^/\n]*\/)/,
    contains: [{
      className: "regexp",
      begin: /\//,
      end: /\/[gimuy]*/,
      illegal: /\n/,
      contains: [
        BACKSLASH_ESCAPE,
        {
          begin: /\[/,
          end: /\]/,
          relevance: 0,
          contains: [BACKSLASH_ESCAPE]
        }
      ]
    }]
  };
  const TITLE_MODE = {
    className: "title",
    begin: IDENT_RE,
    relevance: 0
  };
  const UNDERSCORE_TITLE_MODE = {
    className: "title",
    begin: UNDERSCORE_IDENT_RE,
    relevance: 0
  };
  const METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + UNDERSCORE_IDENT_RE,
    relevance: 0
  };
  const END_SAME_AS_BEGIN = function(mode) {
    return Object.assign(
      mode,
      {
        /** @type {ModeCallback} */
        "on:begin": (m2, resp) => {
          resp.data._beginMatch = m2[1];
        },
        /** @type {ModeCallback} */
        "on:end": (m2, resp) => {
          if (resp.data._beginMatch !== m2[1]) resp.ignoreMatch();
        }
      }
    );
  };
  var MODES = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    MATCH_NOTHING_RE,
    IDENT_RE,
    UNDERSCORE_IDENT_RE,
    NUMBER_RE,
    C_NUMBER_RE,
    BINARY_NUMBER_RE,
    RE_STARTERS_RE,
    SHEBANG,
    BACKSLASH_ESCAPE,
    APOS_STRING_MODE,
    QUOTE_STRING_MODE,
    PHRASAL_WORDS_MODE,
    COMMENT,
    C_LINE_COMMENT_MODE,
    C_BLOCK_COMMENT_MODE,
    HASH_COMMENT_MODE,
    NUMBER_MODE,
    C_NUMBER_MODE,
    BINARY_NUMBER_MODE,
    CSS_NUMBER_MODE,
    REGEXP_MODE,
    TITLE_MODE,
    UNDERSCORE_TITLE_MODE,
    METHOD_GUARD,
    END_SAME_AS_BEGIN
  });
  function skipIfhasPrecedingDot(match, response) {
    const before = match.input[match.index - 1];
    if (before === ".") {
      response.ignoreMatch();
    }
  }
  function beginKeywords(mode, parent) {
    if (!parent) return;
    if (!mode.beginKeywords) return;
    mode.begin = "\\b(" + mode.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)";
    mode.__beforeBegin = skipIfhasPrecedingDot;
    mode.keywords = mode.keywords || mode.beginKeywords;
    delete mode.beginKeywords;
    if (mode.relevance === void 0) mode.relevance = 0;
  }
  function compileIllegal(mode, _parent) {
    if (!Array.isArray(mode.illegal)) return;
    mode.illegal = either(...mode.illegal);
  }
  function compileMatch(mode, _parent) {
    if (!mode.match) return;
    if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");
    mode.begin = mode.match;
    delete mode.match;
  }
  function compileRelevance(mode, _parent) {
    if (mode.relevance === void 0) mode.relevance = 1;
  }
  const COMMON_KEYWORDS = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    // common variable name
    "list",
    // common variable name
    "value"
    // common variable name
  ];
  const DEFAULT_KEYWORD_CLASSNAME = "keyword";
  function compileKeywords(rawKeywords, caseInsensitive, className = DEFAULT_KEYWORD_CLASSNAME) {
    const compiledKeywords = {};
    if (typeof rawKeywords === "string") {
      compileList(className, rawKeywords.split(" "));
    } else if (Array.isArray(rawKeywords)) {
      compileList(className, rawKeywords);
    } else {
      Object.keys(rawKeywords).forEach(function(className2) {
        Object.assign(
          compiledKeywords,
          compileKeywords(rawKeywords[className2], caseInsensitive, className2)
        );
      });
    }
    return compiledKeywords;
    function compileList(className2, keywordList) {
      if (caseInsensitive) {
        keywordList = keywordList.map((x2) => x2.toLowerCase());
      }
      keywordList.forEach(function(keyword) {
        const pair = keyword.split("|");
        compiledKeywords[pair[0]] = [className2, scoreForKeyword(pair[0], pair[1])];
      });
    }
  }
  function scoreForKeyword(keyword, providedScore) {
    if (providedScore) {
      return Number(providedScore);
    }
    return commonKeyword(keyword) ? 0 : 1;
  }
  function commonKeyword(keyword) {
    return COMMON_KEYWORDS.includes(keyword.toLowerCase());
  }
  function compileLanguage(language, { plugins }) {
    function langRe(value, global) {
      return new RegExp(
        source(value),
        "m" + (language.case_insensitive ? "i" : "") + (global ? "g" : "")
      );
    }
    class MultiRegex {
      constructor() {
        this.matchIndexes = {};
        this.regexes = [];
        this.matchAt = 1;
        this.position = 0;
      }
      // @ts-ignore
      addRule(re, opts) {
        opts.position = this.position++;
        this.matchIndexes[this.matchAt] = opts;
        this.regexes.push([opts, re]);
        this.matchAt += countMatchGroups(re) + 1;
      }
      compile() {
        if (this.regexes.length === 0) {
          this.exec = () => null;
        }
        const terminators = this.regexes.map((el) => el[1]);
        this.matcherRe = langRe(join(terminators), true);
        this.lastIndex = 0;
      }
      /** @param {string} s */
      exec(s2) {
        this.matcherRe.lastIndex = this.lastIndex;
        const match = this.matcherRe.exec(s2);
        if (!match) {
          return null;
        }
        const i2 = match.findIndex((el, i3) => i3 > 0 && el !== void 0);
        const matchData = this.matchIndexes[i2];
        match.splice(0, i2);
        return Object.assign(match, matchData);
      }
    }
    class ResumableMultiRegex {
      constructor() {
        this.rules = [];
        this.multiRegexes = [];
        this.count = 0;
        this.lastIndex = 0;
        this.regexIndex = 0;
      }
      // @ts-ignore
      getMatcher(index2) {
        if (this.multiRegexes[index2]) return this.multiRegexes[index2];
        const matcher = new MultiRegex();
        this.rules.slice(index2).forEach(([re, opts]) => matcher.addRule(re, opts));
        matcher.compile();
        this.multiRegexes[index2] = matcher;
        return matcher;
      }
      resumingScanAtSamePosition() {
        return this.regexIndex !== 0;
      }
      considerAll() {
        this.regexIndex = 0;
      }
      // @ts-ignore
      addRule(re, opts) {
        this.rules.push([re, opts]);
        if (opts.type === "begin") this.count++;
      }
      /** @param {string} s */
      exec(s2) {
        const m2 = this.getMatcher(this.regexIndex);
        m2.lastIndex = this.lastIndex;
        let result = m2.exec(s2);
        if (this.resumingScanAtSamePosition()) {
          if (result && result.index === this.lastIndex) ;
          else {
            const m22 = this.getMatcher(0);
            m22.lastIndex = this.lastIndex + 1;
            result = m22.exec(s2);
          }
        }
        if (result) {
          this.regexIndex += result.position + 1;
          if (this.regexIndex === this.count) {
            this.considerAll();
          }
        }
        return result;
      }
    }
    function buildModeRegex(mode) {
      const mm = new ResumableMultiRegex();
      mode.contains.forEach((term) => mm.addRule(term.begin, { rule: term, type: "begin" }));
      if (mode.terminatorEnd) {
        mm.addRule(mode.terminatorEnd, { type: "end" });
      }
      if (mode.illegal) {
        mm.addRule(mode.illegal, { type: "illegal" });
      }
      return mm;
    }
    function compileMode(mode, parent) {
      const cmode = (
        /** @type CompiledMode */
        mode
      );
      if (mode.isCompiled) return cmode;
      [
        // do this early so compiler extensions generally don't have to worry about
        // the distinction between match/begin
        compileMatch
      ].forEach((ext) => ext(mode, parent));
      language.compilerExtensions.forEach((ext) => ext(mode, parent));
      mode.__beforeBegin = null;
      [
        beginKeywords,
        // do this later so compiler extensions that come earlier have access to the
        // raw array if they wanted to perhaps manipulate it, etc.
        compileIllegal,
        // default to 1 relevance if not specified
        compileRelevance
      ].forEach((ext) => ext(mode, parent));
      mode.isCompiled = true;
      let keywordPattern = null;
      if (typeof mode.keywords === "object") {
        keywordPattern = mode.keywords.$pattern;
        delete mode.keywords.$pattern;
      }
      if (mode.keywords) {
        mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
      }
      if (mode.lexemes && keywordPattern) {
        throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
      }
      keywordPattern = keywordPattern || mode.lexemes || /\w+/;
      cmode.keywordPatternRe = langRe(keywordPattern, true);
      if (parent) {
        if (!mode.begin) mode.begin = /\B|\b/;
        cmode.beginRe = langRe(mode.begin);
        if (mode.endSameAsBegin) mode.end = mode.begin;
        if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
        if (mode.end) cmode.endRe = langRe(mode.end);
        cmode.terminatorEnd = source(mode.end) || "";
        if (mode.endsWithParent && parent.terminatorEnd) {
          cmode.terminatorEnd += (mode.end ? "|" : "") + parent.terminatorEnd;
        }
      }
      if (mode.illegal) cmode.illegalRe = langRe(
        /** @type {RegExp | string} */
        mode.illegal
      );
      if (!mode.contains) mode.contains = [];
      mode.contains = [].concat(...mode.contains.map(function(c2) {
        return expandOrCloneMode(c2 === "self" ? mode : c2);
      }));
      mode.contains.forEach(function(c2) {
        compileMode(
          /** @type Mode */
          c2,
          cmode
        );
      });
      if (mode.starts) {
        compileMode(mode.starts, parent);
      }
      cmode.matcher = buildModeRegex(cmode);
      return cmode;
    }
    if (!language.compilerExtensions) language.compilerExtensions = [];
    if (language.contains && language.contains.includes("self")) {
      throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    }
    language.classNameAliases = inherit(language.classNameAliases || {});
    return compileMode(
      /** @type Mode */
      language
    );
  }
  function dependencyOnParent(mode) {
    if (!mode) return false;
    return mode.endsWithParent || dependencyOnParent(mode.starts);
  }
  function expandOrCloneMode(mode) {
    if (mode.variants && !mode.cachedVariants) {
      mode.cachedVariants = mode.variants.map(function(variant) {
        return inherit(mode, { variants: null }, variant);
      });
    }
    if (mode.cachedVariants) {
      return mode.cachedVariants;
    }
    if (dependencyOnParent(mode)) {
      return inherit(mode, { starts: mode.starts ? inherit(mode.starts) : null });
    }
    if (Object.isFrozen(mode)) {
      return inherit(mode);
    }
    return mode;
  }
  var version = "10.7.3";
  function hasValueOrEmptyAttribute(value) {
    return Boolean(value || value === "");
  }
  function BuildVuePlugin(hljs) {
    const Component = {
      props: ["language", "code", "autodetect"],
      data: function() {
        return {
          detectedLanguage: "",
          unknownLanguage: false
        };
      },
      computed: {
        className() {
          if (this.unknownLanguage) return "";
          return "hljs " + this.detectedLanguage;
        },
        highlighted() {
          if (!this.autoDetect && !hljs.getLanguage(this.language)) {
            console.warn(`The language "${this.language}" you specified could not be found.`);
            this.unknownLanguage = true;
            return escapeHTML(this.code);
          }
          let result = {};
          if (this.autoDetect) {
            result = hljs.highlightAuto(this.code);
            this.detectedLanguage = result.language;
          } else {
            result = hljs.highlight(this.language, this.code, this.ignoreIllegals);
            this.detectedLanguage = this.language;
          }
          return result.value;
        },
        autoDetect() {
          return !this.language || hasValueOrEmptyAttribute(this.autodetect);
        },
        ignoreIllegals() {
          return true;
        }
      },
      // this avoids needing to use a whole Vue compilation pipeline just
      // to build Highlight.js
      render(createElement2) {
        return createElement2("pre", {}, [
          createElement2("code", {
            class: this.className,
            domProps: { innerHTML: this.highlighted }
          })
        ]);
      }
      // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
    };
    const VuePlugin = {
      install(Vue) {
        Vue.component("highlightjs", Component);
      }
    };
    return { Component, VuePlugin };
  }
  const mergeHTMLPlugin = {
    "after:highlightElement": ({ el, result, text }) => {
      const originalStream = nodeStream(el);
      if (!originalStream.length) return;
      const resultNode = document.createElement("div");
      resultNode.innerHTML = result.value;
      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
    }
  };
  function tag(node) {
    return node.nodeName.toLowerCase();
  }
  function nodeStream(node) {
    const result = [];
    (function _nodeStream(node2, offset2) {
      for (let child = node2.firstChild; child; child = child.nextSibling) {
        if (child.nodeType === 3) {
          offset2 += child.nodeValue.length;
        } else if (child.nodeType === 1) {
          result.push({
            event: "start",
            offset: offset2,
            node: child
          });
          offset2 = _nodeStream(child, offset2);
          if (!tag(child).match(/br|hr|img|input/)) {
            result.push({
              event: "stop",
              offset: offset2,
              node: child
            });
          }
        }
      }
      return offset2;
    })(node, 0);
    return result;
  }
  function mergeStreams(original, highlighted, value) {
    let processed = 0;
    let result = "";
    const nodeStack = [];
    function selectStream() {
      if (!original.length || !highlighted.length) {
        return original.length ? original : highlighted;
      }
      if (original[0].offset !== highlighted[0].offset) {
        return original[0].offset < highlighted[0].offset ? original : highlighted;
      }
      return highlighted[0].event === "start" ? original : highlighted;
    }
    function open(node) {
      function attributeString(attr) {
        return " " + attr.nodeName + '="' + escapeHTML(attr.value) + '"';
      }
      result += "<" + tag(node) + [].map.call(node.attributes, attributeString).join("") + ">";
    }
    function close(node) {
      result += "</" + tag(node) + ">";
    }
    function render(event) {
      (event.event === "start" ? open : close)(event.node);
    }
    while (original.length || highlighted.length) {
      let stream = selectStream();
      result += escapeHTML(value.substring(processed, stream[0].offset));
      processed = stream[0].offset;
      if (stream === original) {
        nodeStack.reverse().forEach(close);
        do {
          render(stream.splice(0, 1)[0]);
          stream = selectStream();
        } while (stream === original && stream.length && stream[0].offset === processed);
        nodeStack.reverse().forEach(open);
      } else {
        if (stream[0].event === "start") {
          nodeStack.push(stream[0].node);
        } else {
          nodeStack.pop();
        }
        render(stream.splice(0, 1)[0]);
      }
    }
    return result + escapeHTML(value.substr(processed));
  }
  const seenDeprecations = {};
  const error2 = (message) => {
    console.error(message);
  };
  const warn2 = (message, ...args) => {
    console.log(`WARN: ${message}`, ...args);
  };
  const deprecated = (version2, message) => {
    if (seenDeprecations[`${version2}/${message}`]) return;
    console.log(`Deprecated as of ${version2}. ${message}`);
    seenDeprecations[`${version2}/${message}`] = true;
  };
  const escape$1 = escapeHTML;
  const inherit$1 = inherit;
  const NO_MATCH = Symbol("nomatch");
  const HLJS = function(hljs) {
    const languages = /* @__PURE__ */ Object.create(null);
    const aliases = /* @__PURE__ */ Object.create(null);
    const plugins = [];
    let SAFE_MODE = true;
    const fixMarkupRe = /(^(<[^>]+>|\t|)+|\n)/gm;
    const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
    const PLAINTEXT_LANGUAGE = { disableAutodetect: true, name: "Plain text", contains: [] };
    let options = {
      noHighlightRe: /^(no-?highlight)$/i,
      languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
      classPrefix: "hljs-",
      tabReplace: null,
      useBR: false,
      languages: null,
      // beta configuration options, subject to change, welcome to discuss
      // https://github.com/highlightjs/highlight.js/issues/1086
      __emitter: TokenTreeEmitter
    };
    function shouldNotHighlight(languageName) {
      return options.noHighlightRe.test(languageName);
    }
    function blockLanguage(block) {
      let classes = block.className + " ";
      classes += block.parentNode ? block.parentNode.className : "";
      const match = options.languageDetectRe.exec(classes);
      if (match) {
        const language = getLanguage(match[1]);
        if (!language) {
          warn2(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
          warn2("Falling back to no-highlight mode for this block.", block);
        }
        return language ? match[1] : "no-highlight";
      }
      return classes.split(/\s+/).find((_class) => shouldNotHighlight(_class) || getLanguage(_class));
    }
    function highlight3(codeOrlanguageName, optionsOrCode, ignoreIllegals, continuation) {
      let code = "";
      let languageName = "";
      if (typeof optionsOrCode === "object") {
        code = codeOrlanguageName;
        ignoreIllegals = optionsOrCode.ignoreIllegals;
        languageName = optionsOrCode.language;
        continuation = void 0;
      } else {
        deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
        deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
        languageName = codeOrlanguageName;
        code = optionsOrCode;
      }
      const context = {
        code,
        language: languageName
      };
      fire("before:highlight", context);
      const result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals, continuation);
      result.code = context.code;
      fire("after:highlight", result);
      return result;
    }
    function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
      function keywordData(mode, match) {
        const matchText = language.case_insensitive ? match[0].toLowerCase() : match[0];
        return Object.prototype.hasOwnProperty.call(mode.keywords, matchText) && mode.keywords[matchText];
      }
      function processKeywords() {
        if (!top.keywords) {
          emitter.addText(modeBuffer);
          return;
        }
        let lastIndex = 0;
        top.keywordPatternRe.lastIndex = 0;
        let match = top.keywordPatternRe.exec(modeBuffer);
        let buf = "";
        while (match) {
          buf += modeBuffer.substring(lastIndex, match.index);
          const data = keywordData(top, match);
          if (data) {
            const [kind, keywordRelevance] = data;
            emitter.addText(buf);
            buf = "";
            relevance += keywordRelevance;
            if (kind.startsWith("_")) {
              buf += match[0];
            } else {
              const cssClass = language.classNameAliases[kind] || kind;
              emitter.addKeyword(match[0], cssClass);
            }
          } else {
            buf += match[0];
          }
          lastIndex = top.keywordPatternRe.lastIndex;
          match = top.keywordPatternRe.exec(modeBuffer);
        }
        buf += modeBuffer.substr(lastIndex);
        emitter.addText(buf);
      }
      function processSubLanguage() {
        if (modeBuffer === "") return;
        let result2 = null;
        if (typeof top.subLanguage === "string") {
          if (!languages[top.subLanguage]) {
            emitter.addText(modeBuffer);
            return;
          }
          result2 = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
          continuations[top.subLanguage] = /** @type {CompiledMode} */
          result2.top;
        } else {
          result2 = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
        }
        if (top.relevance > 0) {
          relevance += result2.relevance;
        }
        emitter.addSublanguage(result2.emitter, result2.language);
      }
      function processBuffer() {
        if (top.subLanguage != null) {
          processSubLanguage();
        } else {
          processKeywords();
        }
        modeBuffer = "";
      }
      function startNewMode(mode) {
        if (mode.className) {
          emitter.openNode(language.classNameAliases[mode.className] || mode.className);
        }
        top = Object.create(mode, { parent: { value: top } });
        return top;
      }
      function endOfMode(mode, match, matchPlusRemainder) {
        let matched = startsWith(mode.endRe, matchPlusRemainder);
        if (matched) {
          if (mode["on:end"]) {
            const resp = new Response(mode);
            mode["on:end"](match, resp);
            if (resp.isMatchIgnored) matched = false;
          }
          if (matched) {
            while (mode.endsParent && mode.parent) {
              mode = mode.parent;
            }
            return mode;
          }
        }
        if (mode.endsWithParent) {
          return endOfMode(mode.parent, match, matchPlusRemainder);
        }
      }
      function doIgnore(lexeme) {
        if (top.matcher.regexIndex === 0) {
          modeBuffer += lexeme[0];
          return 1;
        } else {
          resumeScanAtSamePosition = true;
          return 0;
        }
      }
      function doBeginMatch(match) {
        const lexeme = match[0];
        const newMode = match.rule;
        const resp = new Response(newMode);
        const beforeCallbacks = [newMode.__beforeBegin, newMode["on:begin"]];
        for (const cb of beforeCallbacks) {
          if (!cb) continue;
          cb(match, resp);
          if (resp.isMatchIgnored) return doIgnore(lexeme);
        }
        if (newMode && newMode.endSameAsBegin) {
          newMode.endRe = escape(lexeme);
        }
        if (newMode.skip) {
          modeBuffer += lexeme;
        } else {
          if (newMode.excludeBegin) {
            modeBuffer += lexeme;
          }
          processBuffer();
          if (!newMode.returnBegin && !newMode.excludeBegin) {
            modeBuffer = lexeme;
          }
        }
        startNewMode(newMode);
        return newMode.returnBegin ? 0 : lexeme.length;
      }
      function doEndMatch(match) {
        const lexeme = match[0];
        const matchPlusRemainder = codeToHighlight.substr(match.index);
        const endMode = endOfMode(top, match, matchPlusRemainder);
        if (!endMode) {
          return NO_MATCH;
        }
        const origin = top;
        if (origin.skip) {
          modeBuffer += lexeme;
        } else {
          if (!(origin.returnEnd || origin.excludeEnd)) {
            modeBuffer += lexeme;
          }
          processBuffer();
          if (origin.excludeEnd) {
            modeBuffer = lexeme;
          }
        }
        do {
          if (top.className) {
            emitter.closeNode();
          }
          if (!top.skip && !top.subLanguage) {
            relevance += top.relevance;
          }
          top = top.parent;
        } while (top !== endMode.parent);
        if (endMode.starts) {
          if (endMode.endSameAsBegin) {
            endMode.starts.endRe = endMode.endRe;
          }
          startNewMode(endMode.starts);
        }
        return origin.returnEnd ? 0 : lexeme.length;
      }
      function processContinuations() {
        const list = [];
        for (let current = top; current !== language; current = current.parent) {
          if (current.className) {
            list.unshift(current.className);
          }
        }
        list.forEach((item) => emitter.openNode(item));
      }
      let lastMatch = {};
      function processLexeme(textBeforeMatch, match) {
        const lexeme = match && match[0];
        modeBuffer += textBeforeMatch;
        if (lexeme == null) {
          processBuffer();
          return 0;
        }
        if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
          modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
          if (!SAFE_MODE) {
            const err = new Error("0 width match regex");
            err.languageName = languageName;
            err.badRule = lastMatch.rule;
            throw err;
          }
          return 1;
        }
        lastMatch = match;
        if (match.type === "begin") {
          return doBeginMatch(match);
        } else if (match.type === "illegal" && !ignoreIllegals) {
          const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || "<unnamed>") + '"');
          err.mode = top;
          throw err;
        } else if (match.type === "end") {
          const processed = doEndMatch(match);
          if (processed !== NO_MATCH) {
            return processed;
          }
        }
        if (match.type === "illegal" && lexeme === "") {
          return 1;
        }
        if (iterations > 1e5 && iterations > match.index * 3) {
          const err = new Error("potential infinite loop, way more iterations than matches");
          throw err;
        }
        modeBuffer += lexeme;
        return lexeme.length;
      }
      const language = getLanguage(languageName);
      if (!language) {
        error2(LANGUAGE_NOT_FOUND.replace("{}", languageName));
        throw new Error('Unknown language: "' + languageName + '"');
      }
      const md = compileLanguage(language, { plugins });
      let result = "";
      let top = continuation || md;
      const continuations = {};
      const emitter = new options.__emitter(options);
      processContinuations();
      let modeBuffer = "";
      let relevance = 0;
      let index2 = 0;
      let iterations = 0;
      let resumeScanAtSamePosition = false;
      try {
        top.matcher.considerAll();
        for (; ; ) {
          iterations++;
          if (resumeScanAtSamePosition) {
            resumeScanAtSamePosition = false;
          } else {
            top.matcher.considerAll();
          }
          top.matcher.lastIndex = index2;
          const match = top.matcher.exec(codeToHighlight);
          if (!match) break;
          const beforeMatch = codeToHighlight.substring(index2, match.index);
          const processedCount = processLexeme(beforeMatch, match);
          index2 = match.index + processedCount;
        }
        processLexeme(codeToHighlight.substr(index2));
        emitter.closeAllNodes();
        emitter.finalize();
        result = emitter.toHTML();
        return {
          // avoid possible breakage with v10 clients expecting
          // this to always be an integer
          relevance: Math.floor(relevance),
          value: result,
          language: languageName,
          illegal: false,
          emitter,
          top
        };
      } catch (err) {
        if (err.message && err.message.includes("Illegal")) {
          return {
            illegal: true,
            illegalBy: {
              msg: err.message,
              context: codeToHighlight.slice(index2 - 100, index2 + 100),
              mode: err.mode
            },
            sofar: result,
            relevance: 0,
            value: escape$1(codeToHighlight),
            emitter
          };
        } else if (SAFE_MODE) {
          return {
            illegal: false,
            relevance: 0,
            value: escape$1(codeToHighlight),
            emitter,
            language: languageName,
            top,
            errorRaised: err
          };
        } else {
          throw err;
        }
      }
    }
    function justTextHighlightResult(code) {
      const result = {
        relevance: 0,
        emitter: new options.__emitter(options),
        value: escape$1(code),
        illegal: false,
        top: PLAINTEXT_LANGUAGE
      };
      result.emitter.addText(code);
      return result;
    }
    function highlightAuto(code, languageSubset) {
      languageSubset = languageSubset || options.languages || Object.keys(languages);
      const plaintext = justTextHighlightResult(code);
      const results = languageSubset.filter(getLanguage).filter(autoDetection).map(
        (name) => _highlight(name, code, false)
      );
      results.unshift(plaintext);
      const sorted = results.sort((a3, b2) => {
        if (a3.relevance !== b2.relevance) return b2.relevance - a3.relevance;
        if (a3.language && b2.language) {
          if (getLanguage(a3.language).supersetOf === b2.language) {
            return 1;
          } else if (getLanguage(b2.language).supersetOf === a3.language) {
            return -1;
          }
        }
        return 0;
      });
      const [best, secondBest] = sorted;
      const result = best;
      result.second_best = secondBest;
      return result;
    }
    function fixMarkup(html) {
      if (!(options.tabReplace || options.useBR)) {
        return html;
      }
      return html.replace(fixMarkupRe, (match) => {
        if (match === "\n") {
          return options.useBR ? "<br>" : match;
        } else if (options.tabReplace) {
          return match.replace(/\t/g, options.tabReplace);
        }
        return match;
      });
    }
    function updateClassName(element, currentLang, resultLang) {
      const language = currentLang ? aliases[currentLang] : resultLang;
      element.classList.add("hljs");
      if (language) element.classList.add(language);
    }
    const brPlugin = {
      "before:highlightElement": ({ el }) => {
        if (options.useBR) {
          el.innerHTML = el.innerHTML.replace(/\n/g, "").replace(/<br[ /]*>/g, "\n");
        }
      },
      "after:highlightElement": ({ result }) => {
        if (options.useBR) {
          result.value = result.value.replace(/\n/g, "<br>");
        }
      }
    };
    const TAB_REPLACE_RE = /^(<[^>]+>|\t)+/gm;
    const tabReplacePlugin = {
      "after:highlightElement": ({ result }) => {
        if (options.tabReplace) {
          result.value = result.value.replace(
            TAB_REPLACE_RE,
            (m2) => m2.replace(/\t/g, options.tabReplace)
          );
        }
      }
    };
    function highlightElement(element) {
      let node = null;
      const language = blockLanguage(element);
      if (shouldNotHighlight(language)) return;
      fire(
        "before:highlightElement",
        { el: element, language }
      );
      node = element;
      const text = node.textContent;
      const result = language ? highlight3(text, { language, ignoreIllegals: true }) : highlightAuto(text);
      fire("after:highlightElement", { el: element, result, text });
      element.innerHTML = result.value;
      updateClassName(element, language, result.language);
      element.result = {
        language: result.language,
        // TODO: remove with version 11.0
        re: result.relevance,
        relavance: result.relevance
      };
      if (result.second_best) {
        element.second_best = {
          language: result.second_best.language,
          // TODO: remove with version 11.0
          re: result.second_best.relevance,
          relavance: result.second_best.relevance
        };
      }
    }
    function configure(userOptions) {
      if (userOptions.useBR) {
        deprecated("10.3.0", "'useBR' will be removed entirely in v11.0");
        deprecated("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559");
      }
      options = inherit$1(options, userOptions);
    }
    const initHighlighting = () => {
      if (initHighlighting.called) return;
      initHighlighting.called = true;
      deprecated("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead.");
      const blocks = document.querySelectorAll("pre code");
      blocks.forEach(highlightElement);
    };
    function initHighlightingOnLoad() {
      deprecated("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead.");
      wantsHighlight = true;
    }
    let wantsHighlight = false;
    function highlightAll() {
      if (document.readyState === "loading") {
        wantsHighlight = true;
        return;
      }
      const blocks = document.querySelectorAll("pre code");
      blocks.forEach(highlightElement);
    }
    function boot() {
      if (wantsHighlight) highlightAll();
    }
    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener("DOMContentLoaded", boot, false);
    }
    function registerLanguage(languageName, languageDefinition) {
      let lang = null;
      try {
        lang = languageDefinition(hljs);
      } catch (error$1) {
        error2("Language definition for '{}' could not be registered.".replace("{}", languageName));
        if (!SAFE_MODE) {
          throw error$1;
        } else {
          error2(error$1);
        }
        lang = PLAINTEXT_LANGUAGE;
      }
      if (!lang.name) lang.name = languageName;
      languages[languageName] = lang;
      lang.rawDefinition = languageDefinition.bind(null, hljs);
      if (lang.aliases) {
        registerAliases(lang.aliases, { languageName });
      }
    }
    function unregisterLanguage(languageName) {
      delete languages[languageName];
      for (const alias of Object.keys(aliases)) {
        if (aliases[alias] === languageName) {
          delete aliases[alias];
        }
      }
    }
    function listLanguages() {
      return Object.keys(languages);
    }
    function requireLanguage(name) {
      deprecated("10.4.0", "requireLanguage will be removed entirely in v11.");
      deprecated("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
      const lang = getLanguage(name);
      if (lang) {
        return lang;
      }
      const err = new Error("The '{}' language is required, but not loaded.".replace("{}", name));
      throw err;
    }
    function getLanguage(name) {
      name = (name || "").toLowerCase();
      return languages[name] || languages[aliases[name]];
    }
    function registerAliases(aliasList, { languageName }) {
      if (typeof aliasList === "string") {
        aliasList = [aliasList];
      }
      aliasList.forEach((alias) => {
        aliases[alias.toLowerCase()] = languageName;
      });
    }
    function autoDetection(name) {
      const lang = getLanguage(name);
      return lang && !lang.disableAutodetect;
    }
    function upgradePluginAPI(plugin) {
      if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) {
        plugin["before:highlightElement"] = (data) => {
          plugin["before:highlightBlock"](
            Object.assign({ block: data.el }, data)
          );
        };
      }
      if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) {
        plugin["after:highlightElement"] = (data) => {
          plugin["after:highlightBlock"](
            Object.assign({ block: data.el }, data)
          );
        };
      }
    }
    function addPlugin(plugin) {
      upgradePluginAPI(plugin);
      plugins.push(plugin);
    }
    function fire(event, args) {
      const cb = event;
      plugins.forEach(function(plugin) {
        if (plugin[cb]) {
          plugin[cb](args);
        }
      });
    }
    function deprecateFixMarkup(arg) {
      deprecated("10.2.0", "fixMarkup will be removed entirely in v11.0");
      deprecated("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534");
      return fixMarkup(arg);
    }
    function deprecateHighlightBlock(el) {
      deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
      deprecated("10.7.0", "Please use highlightElement now.");
      return highlightElement(el);
    }
    Object.assign(hljs, {
      highlight: highlight3,
      highlightAuto,
      highlightAll,
      fixMarkup: deprecateFixMarkup,
      highlightElement,
      // TODO: Remove with v12 API
      highlightBlock: deprecateHighlightBlock,
      configure,
      initHighlighting,
      initHighlightingOnLoad,
      registerLanguage,
      unregisterLanguage,
      listLanguages,
      getLanguage,
      registerAliases,
      requireLanguage,
      autoDetection,
      inherit: inherit$1,
      addPlugin,
      // plugins for frameworks
      vuePlugin: BuildVuePlugin(hljs).VuePlugin
    });
    hljs.debugMode = function() {
      SAFE_MODE = false;
    };
    hljs.safeMode = function() {
      SAFE_MODE = true;
    };
    hljs.versionString = version;
    for (const key in MODES) {
      if (typeof MODES[key] === "object") {
        deepFreezeEs6(MODES[key]);
      }
    }
    Object.assign(hljs, MODES);
    hljs.addPlugin(brPlugin);
    hljs.addPlugin(mergeHTMLPlugin);
    hljs.addPlugin(tabReplacePlugin);
    return hljs;
  };
  var highlight2 = HLJS({});
  core = highlight2;
  return core;
}
var format = { exports: {} };
var hasRequiredFormat;
function requireFormat() {
  if (hasRequiredFormat) return format.exports;
  hasRequiredFormat = 1;
  (function(module) {
    (function() {
      var namespace;
      {
        namespace = module.exports = format2;
      }
      namespace.format = format2;
      namespace.vsprintf = vsprintf;
      if (typeof console !== "undefined" && typeof console.log === "function") {
        namespace.printf = printf;
      }
      function printf() {
        console.log(format2.apply(null, arguments));
      }
      function vsprintf(fmt, replacements) {
        return format2.apply(null, [fmt].concat(replacements));
      }
      function format2(fmt) {
        var argIndex = 1, args = [].slice.call(arguments), i2 = 0, n2 = fmt.length, result = "", c2, escaped = false, arg, tmp, leadingZero = false, precision, nextArg = function() {
          return args[argIndex++];
        }, slurpNumber = function() {
          var digits = "";
          while (/\d/.test(fmt[i2])) {
            digits += fmt[i2++];
            c2 = fmt[i2];
          }
          return digits.length > 0 ? parseInt(digits) : null;
        };
        for (; i2 < n2; ++i2) {
          c2 = fmt[i2];
          if (escaped) {
            escaped = false;
            if (c2 == ".") {
              leadingZero = false;
              c2 = fmt[++i2];
            } else if (c2 == "0" && fmt[i2 + 1] == ".") {
              leadingZero = true;
              i2 += 2;
              c2 = fmt[i2];
            } else {
              leadingZero = true;
            }
            precision = slurpNumber();
            switch (c2) {
              case "b":
                result += parseInt(nextArg(), 10).toString(2);
                break;
              case "c":
                arg = nextArg();
                if (typeof arg === "string" || arg instanceof String)
                  result += arg;
                else
                  result += String.fromCharCode(parseInt(arg, 10));
                break;
              case "d":
                result += parseInt(nextArg(), 10);
                break;
              case "f":
                tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
                result += leadingZero ? tmp : tmp.replace(/^0/, "");
                break;
              case "j":
                result += JSON.stringify(nextArg());
                break;
              case "o":
                result += "0" + parseInt(nextArg(), 10).toString(8);
                break;
              case "s":
                result += nextArg();
                break;
              case "x":
                result += "0x" + parseInt(nextArg(), 10).toString(16);
                break;
              case "X":
                result += "0x" + parseInt(nextArg(), 10).toString(16).toUpperCase();
                break;
              default:
                result += c2;
                break;
            }
          } else if (c2 === "%") {
            escaped = true;
          } else {
            result += c2;
          }
        }
        return result;
      }
    })();
  })(format);
  return format.exports;
}
var fault_1;
var hasRequiredFault;
function requireFault() {
  if (hasRequiredFault) return fault_1;
  hasRequiredFault = 1;
  var formatter = requireFormat();
  var fault = create(Error);
  fault_1 = fault;
  fault.eval = create(EvalError);
  fault.range = create(RangeError);
  fault.reference = create(ReferenceError);
  fault.syntax = create(SyntaxError);
  fault.type = create(TypeError);
  fault.uri = create(URIError);
  fault.create = create;
  function create(EConstructor) {
    FormattedError.displayName = EConstructor.displayName || EConstructor.name;
    return FormattedError;
    function FormattedError(format2) {
      if (format2) {
        format2 = formatter.apply(null, arguments);
      }
      return new EConstructor(format2);
    }
  }
  return fault_1;
}
var hasRequiredCore;
function requireCore() {
  if (hasRequiredCore) return core$1;
  hasRequiredCore = 1;
  var high = requireCore$1();
  var fault = requireFault();
  core$1.highlight = highlight2;
  core$1.highlightAuto = highlightAuto;
  core$1.registerLanguage = registerLanguage;
  core$1.listLanguages = listLanguages;
  core$1.registerAlias = registerAlias;
  Emitter.prototype.addText = text;
  Emitter.prototype.addKeyword = addKeyword;
  Emitter.prototype.addSublanguage = addSublanguage;
  Emitter.prototype.openNode = open;
  Emitter.prototype.closeNode = close;
  Emitter.prototype.closeAllNodes = noop3;
  Emitter.prototype.finalize = noop3;
  Emitter.prototype.toHTML = toHtmlNoop;
  var defaultPrefix = "hljs-";
  function highlight2(name, value, options) {
    var before = high.configure({});
    var settings = options || {};
    var prefix = settings.prefix;
    var result;
    if (typeof name !== "string") {
      throw fault("Expected `string` for name, got `%s`", name);
    }
    if (!high.getLanguage(name)) {
      throw fault("Unknown language: `%s` is not registered", name);
    }
    if (typeof value !== "string") {
      throw fault("Expected `string` for value, got `%s`", value);
    }
    if (prefix === null || prefix === void 0) {
      prefix = defaultPrefix;
    }
    high.configure({ __emitter: Emitter, classPrefix: prefix });
    result = high.highlight(value, { language: name, ignoreIllegals: true });
    high.configure(before || {});
    if (result.errorRaised) {
      throw result.errorRaised;
    }
    return {
      relevance: result.relevance,
      language: result.language,
      value: result.emitter.rootNode.children
    };
  }
  function highlightAuto(value, options) {
    var settings = options || {};
    var subset = settings.subset || high.listLanguages();
    settings.prefix;
    var length = subset.length;
    var index2 = -1;
    var result;
    var secondBest;
    var current;
    var name;
    if (typeof value !== "string") {
      throw fault("Expected `string` for value, got `%s`", value);
    }
    secondBest = { relevance: 0, language: null, value: [] };
    result = { relevance: 0, language: null, value: [] };
    while (++index2 < length) {
      name = subset[index2];
      if (!high.getLanguage(name)) {
        continue;
      }
      current = highlight2(name, value, options);
      current.language = name;
      if (current.relevance > secondBest.relevance) {
        secondBest = current;
      }
      if (current.relevance > result.relevance) {
        secondBest = result;
        result = current;
      }
    }
    if (secondBest.language) {
      result.secondBest = secondBest;
    }
    return result;
  }
  function registerLanguage(name, syntax) {
    high.registerLanguage(name, syntax);
  }
  function listLanguages() {
    return high.listLanguages();
  }
  function registerAlias(name, alias) {
    var map = name;
    var key;
    if (alias) {
      map = {};
      map[name] = alias;
    }
    for (key in map) {
      high.registerAliases(map[key], { languageName: key });
    }
  }
  function Emitter(options) {
    this.options = options;
    this.rootNode = { children: [] };
    this.stack = [this.rootNode];
  }
  function addKeyword(value, name) {
    this.openNode(name);
    this.addText(value);
    this.closeNode();
  }
  function addSublanguage(other, name) {
    var stack = this.stack;
    var current = stack[stack.length - 1];
    var results = other.rootNode.children;
    var node = name ? {
      type: "element",
      tagName: "span",
      properties: { className: [name] },
      children: results
    } : results;
    current.children = current.children.concat(node);
  }
  function text(value) {
    var stack = this.stack;
    var current;
    var tail;
    if (value === "") return;
    current = stack[stack.length - 1];
    tail = current.children[current.children.length - 1];
    if (tail && tail.type === "text") {
      tail.value += value;
    } else {
      current.children.push({ type: "text", value });
    }
  }
  function open(name) {
    var stack = this.stack;
    var className = this.options.classPrefix + name;
    var current = stack[stack.length - 1];
    var child = {
      type: "element",
      tagName: "span",
      properties: { className: [className] },
      children: []
    };
    current.children.push(child);
    stack.push(child);
  }
  function close() {
    this.stack.pop();
  }
  function toHtmlNoop() {
    return "";
  }
  function noop3() {
  }
  return core$1;
}
var bash_1;
var hasRequiredBash;
function requireBash() {
  if (hasRequiredBash) return bash_1;
  hasRequiredBash = 1;
  function source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
  }
  function concat(...args) {
    const joined = args.map((x2) => source(x2)).join("");
    return joined;
  }
  function bash2(hljs) {
    const VAR = {};
    const BRACED_VAR = {
      begin: /\$\{/,
      end: /\}/,
      contains: [
        "self",
        {
          begin: /:-/,
          contains: [VAR]
        }
        // default values
      ]
    };
    Object.assign(VAR, {
      className: "variable",
      variants: [
        { begin: concat(
          /\$[\w\d#@][\w\d_]*/,
          // negative look-ahead tries to avoid matching patterns that are not
          // Perl at all like $ident$, @ident@, etc.
          `(?![\\w\\d])(?![$])`
        ) },
        BRACED_VAR
      ]
    });
    const SUBST = {
      className: "subst",
      begin: /\$\(/,
      end: /\)/,
      contains: [hljs.BACKSLASH_ESCAPE]
    };
    const HERE_DOC = {
      begin: /<<-?\s*(?=\w+)/,
      starts: {
        contains: [
          hljs.END_SAME_AS_BEGIN({
            begin: /(\w+)/,
            end: /(\w+)/,
            className: "string"
          })
        ]
      }
    };
    const QUOTE_STRING = {
      className: "string",
      begin: /"/,
      end: /"/,
      contains: [
        hljs.BACKSLASH_ESCAPE,
        VAR,
        SUBST
      ]
    };
    SUBST.contains.push(QUOTE_STRING);
    const ESCAPED_QUOTE = {
      className: "",
      begin: /\\"/
    };
    const APOS_STRING = {
      className: "string",
      begin: /'/,
      end: /'/
    };
    const ARITHMETIC = {
      begin: /\$\(\(/,
      end: /\)\)/,
      contains: [
        { begin: /\d+#[0-9a-f]+/, className: "number" },
        hljs.NUMBER_MODE,
        VAR
      ]
    };
    const SH_LIKE_SHELLS = [
      "fish",
      "bash",
      "zsh",
      "sh",
      "csh",
      "ksh",
      "tcsh",
      "dash",
      "scsh"
    ];
    const KNOWN_SHEBANG = hljs.SHEBANG({
      binary: `(${SH_LIKE_SHELLS.join("|")})`,
      relevance: 10
    });
    const FUNCTION = {
      className: "function",
      begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
      returnBegin: true,
      contains: [hljs.inherit(hljs.TITLE_MODE, { begin: /\w[\w\d_]*/ })],
      relevance: 0
    };
    return {
      name: "Bash",
      aliases: ["sh", "zsh"],
      keywords: {
        $pattern: /\b[a-z._-]+\b/,
        keyword: "if then else elif fi for while in do done case esac function",
        literal: "true false",
        built_in: (
          // Shell built-ins
          // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
          "break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp"
        )
      },
      contains: [
        KNOWN_SHEBANG,
        // to catch known shells and boost relevancy
        hljs.SHEBANG(),
        // to catch unknown shells but still highlight the shebang
        FUNCTION,
        ARITHMETIC,
        hljs.HASH_COMMENT_MODE,
        HERE_DOC,
        QUOTE_STRING,
        ESCAPED_QUOTE,
        APOS_STRING,
        VAR
      ]
    };
  }
  bash_1 = bash2;
  return bash_1;
}
var ini_1;
var hasRequiredIni;
function requireIni() {
  if (hasRequiredIni) return ini_1;
  hasRequiredIni = 1;
  function source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
  }
  function lookahead(re) {
    return concat("(?=", re, ")");
  }
  function concat(...args) {
    const joined = args.map((x2) => source(x2)).join("");
    return joined;
  }
  function either(...args) {
    const joined = "(" + args.map((x2) => source(x2)).join("|") + ")";
    return joined;
  }
  function ini2(hljs) {
    const NUMBERS = {
      className: "number",
      relevance: 0,
      variants: [
        {
          begin: /([+-]+)?[\d]+_[\d_]+/
        },
        {
          begin: hljs.NUMBER_RE
        }
      ]
    };
    const COMMENTS = hljs.COMMENT();
    COMMENTS.variants = [
      {
        begin: /;/,
        end: /$/
      },
      {
        begin: /#/,
        end: /$/
      }
    ];
    const VARIABLES = {
      className: "variable",
      variants: [
        {
          begin: /\$[\w\d"][\w\d_]*/
        },
        {
          begin: /\$\{(.*?)\}/
        }
      ]
    };
    const LITERALS = {
      className: "literal",
      begin: /\bon|off|true|false|yes|no\b/
    };
    const STRINGS = {
      className: "string",
      contains: [hljs.BACKSLASH_ESCAPE],
      variants: [
        {
          begin: "'''",
          end: "'''",
          relevance: 10
        },
        {
          begin: '"""',
          end: '"""',
          relevance: 10
        },
        {
          begin: '"',
          end: '"'
        },
        {
          begin: "'",
          end: "'"
        }
      ]
    };
    const ARRAY = {
      begin: /\[/,
      end: /\]/,
      contains: [
        COMMENTS,
        LITERALS,
        VARIABLES,
        STRINGS,
        NUMBERS,
        "self"
      ],
      relevance: 0
    };
    const BARE_KEY = /[A-Za-z0-9_-]+/;
    const QUOTED_KEY_DOUBLE_QUOTE = /"(\\"|[^"])*"/;
    const QUOTED_KEY_SINGLE_QUOTE = /'[^']*'/;
    const ANY_KEY = either(
      BARE_KEY,
      QUOTED_KEY_DOUBLE_QUOTE,
      QUOTED_KEY_SINGLE_QUOTE
    );
    const DOTTED_KEY = concat(
      ANY_KEY,
      "(\\s*\\.\\s*",
      ANY_KEY,
      ")*",
      lookahead(/\s*=\s*[^#\s]/)
    );
    return {
      name: "TOML, also INI",
      aliases: ["toml"],
      case_insensitive: true,
      illegal: /\S/,
      contains: [
        COMMENTS,
        {
          className: "section",
          begin: /\[+/,
          end: /\]+/
        },
        {
          begin: DOTTED_KEY,
          className: "attr",
          starts: {
            end: /$/,
            contains: [
              COMMENTS,
              ARRAY,
              LITERALS,
              VARIABLES,
              STRINGS,
              NUMBERS
            ]
          }
        }
      ]
    };
  }
  ini_1 = ini2;
  return ini_1;
}
var javascript_1;
var hasRequiredJavascript;
function requireJavascript() {
  if (hasRequiredJavascript) return javascript_1;
  hasRequiredJavascript = 1;
  const IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
  const KEYWORDS = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
  ];
  const LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
  ];
  const TYPES = [
    "Intl",
    "DataView",
    "Number",
    "Math",
    "Date",
    "String",
    "RegExp",
    "Object",
    "Function",
    "Boolean",
    "Error",
    "Symbol",
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    "Proxy",
    "Reflect",
    "JSON",
    "Promise",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Float32Array",
    "Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "ArrayBuffer",
    "BigInt64Array",
    "BigUint64Array",
    "BigInt"
  ];
  const ERROR_TYPES = [
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
  ];
  const BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
  ];
  const BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "module",
    "global"
    // Node.js
  ];
  const BUILT_INS = [].concat(
    BUILT_IN_GLOBALS,
    BUILT_IN_VARIABLES,
    TYPES,
    ERROR_TYPES
  );
  function source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
  }
  function lookahead(re) {
    return concat("(?=", re, ")");
  }
  function concat(...args) {
    const joined = args.map((x2) => source(x2)).join("");
    return joined;
  }
  function javascript2(hljs) {
    const hasClosingTag = (match, { after }) => {
      const tag = "</" + match[0].slice(1);
      const pos = match.input.indexOf(tag, after);
      return pos !== -1;
    };
    const IDENT_RE$1 = IDENT_RE;
    const FRAGMENT = {
      begin: "<>",
      end: "</>"
    };
    const XML_TAG = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      /**
       * @param {RegExpMatchArray} match
       * @param {CallbackResponse} response
       */
      isTrulyOpeningTag: (match, response) => {
        const afterMatchIndex = match[0].length + match.index;
        const nextChar = match.input[afterMatchIndex];
        if (nextChar === "<") {
          response.ignoreMatch();
          return;
        }
        if (nextChar === ">") {
          if (!hasClosingTag(match, { after: afterMatchIndex })) {
            response.ignoreMatch();
          }
        }
      }
    };
    const KEYWORDS$1 = {
      $pattern: IDENT_RE,
      keyword: KEYWORDS,
      literal: LITERALS,
      built_in: BUILT_INS
    };
    const decimalDigits = "[0-9](_?[0-9])*";
    const frac = `\\.(${decimalDigits})`;
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
      className: "number",
      variants: [
        // DecimalLiteral
        { begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))[eE][+-]?(${decimalDigits})\\b` },
        { begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b` },
        // DecimalBigIntegerLiteral
        { begin: `\\b(0|[1-9](_?[0-9])*)n\\b` },
        // NonDecimalIntegerLiteral
        { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
        { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
        { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
        // LegacyOctalIntegerLiteral (does not include underscore separators)
        // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
        { begin: "\\b0[0-7]+n?\\b" }
      ],
      relevance: 0
    };
    const SUBST = {
      className: "subst",
      begin: "\\$\\{",
      end: "\\}",
      keywords: KEYWORDS$1,
      contains: []
      // defined later
    };
    const HTML_TEMPLATE = {
      begin: "html`",
      end: "",
      starts: {
        end: "`",
        returnEnd: false,
        contains: [
          hljs.BACKSLASH_ESCAPE,
          SUBST
        ],
        subLanguage: "xml"
      }
    };
    const CSS_TEMPLATE = {
      begin: "css`",
      end: "",
      starts: {
        end: "`",
        returnEnd: false,
        contains: [
          hljs.BACKSLASH_ESCAPE,
          SUBST
        ],
        subLanguage: "css"
      }
    };
    const TEMPLATE_STRING = {
      className: "string",
      begin: "`",
      end: "`",
      contains: [
        hljs.BACKSLASH_ESCAPE,
        SUBST
      ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(
      /\/\*\*(?!\/)/,
      "\\*/",
      {
        relevance: 0,
        contains: [
          {
            className: "doctag",
            begin: "@[A-Za-z]+",
            contains: [
              {
                className: "type",
                begin: "\\{",
                end: "\\}",
                relevance: 0
              },
              {
                className: "variable",
                begin: IDENT_RE$1 + "(?=\\s*(-)|$)",
                endsParent: true,
                relevance: 0
              },
              // eat spaces (not newlines) so we can find
              // types or variables
              {
                begin: /(?=[^\n])\s/,
                relevance: 0
              }
            ]
          }
        ]
      }
    );
    const COMMENT = {
      className: "comment",
      variants: [
        JSDOC_COMMENT,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.C_LINE_COMMENT_MODE
      ]
    };
    const SUBST_INTERNALS = [
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      HTML_TEMPLATE,
      CSS_TEMPLATE,
      TEMPLATE_STRING,
      NUMBER,
      hljs.REGEXP_MODE
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
      // we need to pair up {} inside our subst to prevent
      // it from ending too early by matching another }
      begin: /\{/,
      end: /\}/,
      keywords: KEYWORDS$1,
      contains: [
        "self"
      ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
      // eat recursive parens in sub expressions
      {
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS$1,
        contains: ["self"].concat(SUBST_AND_COMMENTS)
      }
    ]);
    const PARAMS = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: true,
      excludeEnd: true,
      keywords: KEYWORDS$1,
      contains: PARAMS_CONTAINS
    };
    return {
      name: "Javascript",
      aliases: ["js", "jsx", "mjs", "cjs"],
      keywords: KEYWORDS$1,
      // this will be extended by TypeScript
      exports: { PARAMS_CONTAINS },
      illegal: /#(?![$_A-z])/,
      contains: [
        hljs.SHEBANG({
          label: "shebang",
          binary: "node",
          relevance: 5
        }),
        {
          label: "use_strict",
          className: "meta",
          relevance: 10,
          begin: /^\s*['"]use (strict|asm)['"]/
        },
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        TEMPLATE_STRING,
        COMMENT,
        NUMBER,
        {
          // object attr container
          begin: concat(
            /[{,\n]\s*/,
            // we need to look ahead to make sure that we actually have an
            // attribute coming up so we don't steal a comma from a potential
            // "value" container
            //
            // NOTE: this might not work how you think.  We don't actually always
            // enter this mode and stay.  Instead it might merely match `,
            // <comments up next>` and then immediately end after the , because it
            // fails to find any actual attrs. But this still does the job because
            // it prevents the value contain rule from grabbing this instead and
            // prevening this rule from firing when we actually DO have keys.
            lookahead(concat(
              // we also need to allow for multiple possible comments inbetween
              // the first key:value pairing
              /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/,
              IDENT_RE$1 + "\\s*:"
            ))
          ),
          relevance: 0,
          contains: [
            {
              className: "attr",
              begin: IDENT_RE$1 + lookahead("\\s*:"),
              relevance: 0
            }
          ]
        },
        {
          // "value" container
          begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
          keywords: "return throw case",
          contains: [
            COMMENT,
            hljs.REGEXP_MODE,
            {
              className: "function",
              // we have to count the parens to make sure we actually have the
              // correct bounding ( ) before the =>.  There could be any number of
              // sub-expressions inside also surrounded by parens.
              begin: "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ")\\s*=>",
              returnBegin: true,
              end: "\\s*=>",
              contains: [
                {
                  className: "params",
                  variants: [
                    {
                      begin: hljs.UNDERSCORE_IDENT_RE,
                      relevance: 0
                    },
                    {
                      className: null,
                      begin: /\(\s*\)/,
                      skip: true
                    },
                    {
                      begin: /\(/,
                      end: /\)/,
                      excludeBegin: true,
                      excludeEnd: true,
                      keywords: KEYWORDS$1,
                      contains: PARAMS_CONTAINS
                    }
                  ]
                }
              ]
            },
            {
              // could be a comma delimited list of params to a function call
              begin: /,/,
              relevance: 0
            },
            {
              className: "",
              begin: /\s/,
              end: /\s*/,
              skip: true
            },
            {
              // JSX
              variants: [
                { begin: FRAGMENT.begin, end: FRAGMENT.end },
                {
                  begin: XML_TAG.begin,
                  // we carefully check the opening tag to see if it truly
                  // is a tag and not a false positive
                  "on:begin": XML_TAG.isTrulyOpeningTag,
                  end: XML_TAG.end
                }
              ],
              subLanguage: "xml",
              contains: [
                {
                  begin: XML_TAG.begin,
                  end: XML_TAG.end,
                  skip: true,
                  contains: ["self"]
                }
              ]
            }
          ],
          relevance: 0
        },
        {
          className: "function",
          beginKeywords: "function",
          end: /[{;]/,
          excludeEnd: true,
          keywords: KEYWORDS$1,
          contains: [
            "self",
            hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 }),
            PARAMS
          ],
          illegal: /%/
        },
        {
          // prevent this from getting swallowed up by function
          // since they appear "function like"
          beginKeywords: "while if switch catch for"
        },
        {
          className: "function",
          // we have to count the parens to make sure we actually have the correct
          // bounding ( ).  There could be any number of sub-expressions inside
          // also surrounded by parens.
          begin: hljs.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
          // end parens
          returnBegin: true,
          contains: [
            PARAMS,
            hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 })
          ]
        },
        // hack: prevents detection of keywords in some circumstances
        // .keyword()
        // $keyword = x
        {
          variants: [
            { begin: "\\." + IDENT_RE$1 },
            { begin: "\\$" + IDENT_RE$1 }
          ],
          relevance: 0
        },
        {
          // ES6 class
          className: "class",
          beginKeywords: "class",
          end: /[{;=]/,
          excludeEnd: true,
          illegal: /[:"[\]]/,
          contains: [
            { beginKeywords: "extends" },
            hljs.UNDERSCORE_TITLE_MODE
          ]
        },
        {
          begin: /\b(?=constructor)/,
          end: /[{;]/,
          excludeEnd: true,
          contains: [
            hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 }),
            "self",
            PARAMS
          ]
        },
        {
          begin: "(get|set)\\s+(?=" + IDENT_RE$1 + "\\()",
          end: /\{/,
          keywords: "get set",
          contains: [
            hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1 }),
            { begin: /\(\)/ },
            // eat to avoid empty params
            PARAMS
          ]
        },
        {
          begin: /\$[(.]/
          // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
        }
      ]
    };
  }
  javascript_1 = javascript2;
  return javascript_1;
}
var json_1;
var hasRequiredJson;
function requireJson() {
  if (hasRequiredJson) return json_1;
  hasRequiredJson = 1;
  function json2(hljs) {
    const LITERALS = {
      literal: "true false null"
    };
    const ALLOWED_COMMENTS = [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ];
    const TYPES = [
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE
    ];
    const VALUE_CONTAINER = {
      end: ",",
      endsWithParent: true,
      excludeEnd: true,
      contains: TYPES,
      keywords: LITERALS
    };
    const OBJECT = {
      begin: /\{/,
      end: /\}/,
      contains: [
        {
          className: "attr",
          begin: /"/,
          end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE],
          illegal: "\\n"
        },
        hljs.inherit(VALUE_CONTAINER, {
          begin: /:/
        })
      ].concat(ALLOWED_COMMENTS),
      illegal: "\\S"
    };
    const ARRAY = {
      begin: "\\[",
      end: "\\]",
      contains: [hljs.inherit(VALUE_CONTAINER)],
      // inherit is a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
      illegal: "\\S"
    };
    TYPES.push(OBJECT, ARRAY);
    ALLOWED_COMMENTS.forEach(function(rule) {
      TYPES.push(rule);
    });
    return {
      name: "JSON",
      contains: TYPES,
      keywords: LITERALS,
      illegal: "\\S"
    };
  }
  json_1 = json2;
  return json_1;
}
var python_1;
var hasRequiredPython;
function requirePython() {
  if (hasRequiredPython) return python_1;
  hasRequiredPython = 1;
  function source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
  }
  function lookahead(re) {
    return concat("(?=", re, ")");
  }
  function concat(...args) {
    const joined = args.map((x2) => source(x2)).join("");
    return joined;
  }
  function python2(hljs) {
    const RESERVED_WORDS = [
      "and",
      "as",
      "assert",
      "async",
      "await",
      "break",
      "class",
      "continue",
      "def",
      "del",
      "elif",
      "else",
      "except",
      "finally",
      "for",
      "from",
      "global",
      "if",
      "import",
      "in",
      "is",
      "lambda",
      "nonlocal|10",
      "not",
      "or",
      "pass",
      "raise",
      "return",
      "try",
      "while",
      "with",
      "yield"
    ];
    const BUILT_INS = [
      "__import__",
      "abs",
      "all",
      "any",
      "ascii",
      "bin",
      "bool",
      "breakpoint",
      "bytearray",
      "bytes",
      "callable",
      "chr",
      "classmethod",
      "compile",
      "complex",
      "delattr",
      "dict",
      "dir",
      "divmod",
      "enumerate",
      "eval",
      "exec",
      "filter",
      "float",
      "format",
      "frozenset",
      "getattr",
      "globals",
      "hasattr",
      "hash",
      "help",
      "hex",
      "id",
      "input",
      "int",
      "isinstance",
      "issubclass",
      "iter",
      "len",
      "list",
      "locals",
      "map",
      "max",
      "memoryview",
      "min",
      "next",
      "object",
      "oct",
      "open",
      "ord",
      "pow",
      "print",
      "property",
      "range",
      "repr",
      "reversed",
      "round",
      "set",
      "setattr",
      "slice",
      "sorted",
      "staticmethod",
      "str",
      "sum",
      "super",
      "tuple",
      "type",
      "vars",
      "zip"
    ];
    const LITERALS = [
      "__debug__",
      "Ellipsis",
      "False",
      "None",
      "NotImplemented",
      "True"
    ];
    const TYPES = [
      "Any",
      "Callable",
      "Coroutine",
      "Dict",
      "List",
      "Literal",
      "Generic",
      "Optional",
      "Sequence",
      "Set",
      "Tuple",
      "Type",
      "Union"
    ];
    const KEYWORDS = {
      $pattern: /[A-Za-z]\w+|__\w+__/,
      keyword: RESERVED_WORDS,
      built_in: BUILT_INS,
      literal: LITERALS,
      type: TYPES
    };
    const PROMPT = {
      className: "meta",
      begin: /^(>>>|\.\.\.) /
    };
    const SUBST = {
      className: "subst",
      begin: /\{/,
      end: /\}/,
      keywords: KEYWORDS,
      illegal: /#/
    };
    const LITERAL_BRACKET = {
      begin: /\{\{/,
      relevance: 0
    };
    const STRING = {
      className: "string",
      contains: [hljs.BACKSLASH_ESCAPE],
      variants: [
        {
          begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
          end: /'''/,
          contains: [
            hljs.BACKSLASH_ESCAPE,
            PROMPT
          ],
          relevance: 10
        },
        {
          begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
          end: /"""/,
          contains: [
            hljs.BACKSLASH_ESCAPE,
            PROMPT
          ],
          relevance: 10
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])'''/,
          end: /'''/,
          contains: [
            hljs.BACKSLASH_ESCAPE,
            PROMPT,
            LITERAL_BRACKET,
            SUBST
          ]
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])"""/,
          end: /"""/,
          contains: [
            hljs.BACKSLASH_ESCAPE,
            PROMPT,
            LITERAL_BRACKET,
            SUBST
          ]
        },
        {
          begin: /([uU]|[rR])'/,
          end: /'/,
          relevance: 10
        },
        {
          begin: /([uU]|[rR])"/,
          end: /"/,
          relevance: 10
        },
        {
          begin: /([bB]|[bB][rR]|[rR][bB])'/,
          end: /'/
        },
        {
          begin: /([bB]|[bB][rR]|[rR][bB])"/,
          end: /"/
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])'/,
          end: /'/,
          contains: [
            hljs.BACKSLASH_ESCAPE,
            LITERAL_BRACKET,
            SUBST
          ]
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])"/,
          end: /"/,
          contains: [
            hljs.BACKSLASH_ESCAPE,
            LITERAL_BRACKET,
            SUBST
          ]
        },
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE
      ]
    };
    const digitpart = "[0-9](_?[0-9])*";
    const pointfloat = `(\\b(${digitpart}))?\\.(${digitpart})|\\b(${digitpart})\\.`;
    const NUMBER = {
      className: "number",
      relevance: 0,
      variants: [
        // exponentfloat, pointfloat
        // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
        // optionally imaginary
        // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
        // Note: no leading \b because floats can start with a decimal point
        // and we don't want to mishandle e.g. `fn(.5)`,
        // no trailing \b for pointfloat because it can end with a decimal point
        // and we don't want to mishandle e.g. `0..hex()`; this should be safe
        // because both MUST contain a decimal point and so cannot be confused with
        // the interior part of an identifier
        {
          begin: `(\\b(${digitpart})|(${pointfloat}))[eE][+-]?(${digitpart})[jJ]?\\b`
        },
        {
          begin: `(${pointfloat})[jJ]?`
        },
        // decinteger, bininteger, octinteger, hexinteger
        // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
        // optionally "long" in Python 2
        // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
        // decinteger is optionally imaginary
        // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
        {
          begin: "\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?\\b"
        },
        {
          begin: "\\b0[bB](_?[01])+[lL]?\\b"
        },
        {
          begin: "\\b0[oO](_?[0-7])+[lL]?\\b"
        },
        {
          begin: "\\b0[xX](_?[0-9a-fA-F])+[lL]?\\b"
        },
        // imagnumber (digitpart-based)
        // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
        {
          begin: `\\b(${digitpart})[jJ]\\b`
        }
      ]
    };
    const COMMENT_TYPE = {
      className: "comment",
      begin: lookahead(/# type:/),
      end: /$/,
      keywords: KEYWORDS,
      contains: [
        {
          // prevent keywords from coloring `type`
          begin: /# type:/
        },
        // comment within a datatype comment includes no keywords
        {
          begin: /#/,
          end: /\b\B/,
          endsWithParent: true
        }
      ]
    };
    const PARAMS = {
      className: "params",
      variants: [
        // Exclude params in functions without params
        {
          className: "",
          begin: /\(\s*\)/,
          skip: true
        },
        {
          begin: /\(/,
          end: /\)/,
          excludeBegin: true,
          excludeEnd: true,
          keywords: KEYWORDS,
          contains: [
            "self",
            PROMPT,
            NUMBER,
            STRING,
            hljs.HASH_COMMENT_MODE
          ]
        }
      ]
    };
    SUBST.contains = [
      STRING,
      NUMBER,
      PROMPT
    ];
    return {
      name: "Python",
      aliases: [
        "py",
        "gyp",
        "ipython"
      ],
      keywords: KEYWORDS,
      illegal: /(<\/|->|\?)|=>/,
      contains: [
        PROMPT,
        NUMBER,
        {
          // very common convention
          begin: /\bself\b/
        },
        {
          // eat "if" prior to string so that it won't accidentally be
          // labeled as an f-string
          beginKeywords: "if",
          relevance: 0
        },
        STRING,
        COMMENT_TYPE,
        hljs.HASH_COMMENT_MODE,
        {
          variants: [
            {
              className: "function",
              beginKeywords: "def"
            },
            {
              className: "class",
              beginKeywords: "class"
            }
          ],
          end: /:/,
          illegal: /[${=;\n,]/,
          contains: [
            hljs.UNDERSCORE_TITLE_MODE,
            PARAMS,
            {
              begin: /->/,
              endsWithParent: true,
              keywords: KEYWORDS
            }
          ]
        },
        {
          className: "meta",
          begin: /^[\t ]*@/,
          end: /(?=#)|$/,
          contains: [
            NUMBER,
            PARAMS,
            STRING
          ]
        }
      ]
    };
  }
  python_1 = python2;
  return python_1;
}
var shell_1;
var hasRequiredShell;
function requireShell() {
  if (hasRequiredShell) return shell_1;
  hasRequiredShell = 1;
  function shell2(hljs) {
    return {
      name: "Shell Session",
      aliases: ["console"],
      contains: [
        {
          className: "meta",
          // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
          // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
          // echo /path/to/home > t.exe
          begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#]/,
          starts: {
            end: /[^\\](?=\s*$)/,
            subLanguage: "bash"
          }
        }
      ]
    };
  }
  shell_1 = shell2;
  return shell_1;
}
var coreExports = requireCore();
const lowlight = /* @__PURE__ */ getDefaultExportFromCjs(coreExports);
var SyntaxHighlighter = highlight(lowlight, {});
SyntaxHighlighter.registerLanguage = lowlight.registerLanguage;
var bashExports = requireBash();
const bash = /* @__PURE__ */ getDefaultExportFromCjs(bashExports);
var iniExports = requireIni();
const ini = /* @__PURE__ */ getDefaultExportFromCjs(iniExports);
var javascriptExports = requireJavascript();
const javascript = /* @__PURE__ */ getDefaultExportFromCjs(javascriptExports);
var jsonExports = requireJson();
const json = /* @__PURE__ */ getDefaultExportFromCjs(jsonExports);
var pythonExports = requirePython();
const python = /* @__PURE__ */ getDefaultExportFromCjs(pythonExports);
var shellExports = requireShell();
const shell = /* @__PURE__ */ getDefaultExportFromCjs(shellExports);
const theme = {
  "hljs": {
    display: "block",
    overflowX: "auto",
    color: "var(--ui-text-color-primary)"
  },
  "hljs-comment": {
    color: "var(--ui-text-color-tertiary)"
  },
  "hljs-quote": {
    color: "var(--ui-text-color-tertiary)"
  },
  "hljs-meta": {
    color: "var(--ui-text-color-tertiary)"
  },
  "hljs-keyword": {
    color: "var(--ui-text-color-accent-blue-contrast)"
  },
  "hljs-selector-tag": {
    color: "var(--ui-text-color-accent-blue-contrast)"
  },
  "hljs-tag": {
    color: "var(--ui-text-color-accent-blue-contrast)"
  },
  "hljs-name": {
    color: "var(--ui-text-color-accent-blue-contrast)"
  },
  "hljs-attribute": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-selector-id": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-string": {
    color: "var(--ui-text-color-accent-pink-contrast)"
  },
  "hljs-selector-attr": {
    color: "var(--ui-text-color-accent-pink-contrast)"
  },
  "hljs-selector-pseudo": {
    color: "var(--ui-text-color-accent-pink-contrast)"
  },
  "hljs-addition": {
    color: "var(--ui-text-color-accent-pink-contrast)"
  },
  "hljs-subst": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-regexp": {
    color: "var(--ui-text-color-accent-green-contrast)"
  },
  "hljs-link": {
    color: "var(--ui-text-color-accent-green-contrast)"
  },
  "hljs-title": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-section": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-type": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-doctag": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-symbol": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-bullet": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-variable": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-template-variable": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-literal": {
    color: "var(--ui-text-color-primary)"
  },
  "hljs-number": {
    color: "var(--ui-text-color-accent-orange)"
  },
  "hljs-deletion": {
    color: "var(--ui-text-color-accent-orange)"
  },
  "hljs-emphasis": {
    fontStyle: "italic"
  },
  "hljs-strong": {
    fontWeight: "bold"
  },
  "comment": {
    color: "var(--ui-text-color-tertiary)"
  }
};
SyntaxHighlighter.registerLanguage("javascript", javascript);
SyntaxHighlighter.registerLanguage("python", python);
SyntaxHighlighter.registerLanguage("shell", shell);
SyntaxHighlighter.registerLanguage("bash", bash);
SyntaxHighlighter.registerLanguage("cli", bash);
SyntaxHighlighter.registerLanguage("json", json);
SyntaxHighlighter.registerLanguage("ini", ini);
const CodeBoxHighlighter = ({
  language,
  code,
  wrapLongLines,
  showLineNumbers,
  renderer
}) => {
  const customRenderer = useCallback(
    (props) => {
      const lineNumberRows = renderLineNumbers(props);
      return renderer ? renderer(lineNumberRows) : lineNumberRows;
    },
    [renderer]
  );
  return /* @__PURE__ */ jsx(
    SyntaxHighlighter,
    {
      language,
      style: theme,
      customStyle: {
        padding: 0,
        background: "transparent",
        wordBreak: wrapLongLines ? "break-all" : void 0
      },
      codeTagProps: {
        style: { fontSize: "inherit", background: "transparent", padding: 0 }
      },
      wrapLongLines,
      showLineNumbers,
      renderer: customRenderer,
      children: code
    }
  );
};
const renderLineNumbers = ({
  rows,
  ...props
}) => {
  return rows.map((row, rowIndex) => {
    var _a, _b, _c;
    const children = row.children;
    if ((_c = (_b = (_a = children == null ? void 0 : children[0]) == null ? void 0 : _a.properties) == null ? void 0 : _b.className) == null ? void 0 : _c.includes("linenumber")) {
      row.children = [
        children[0],
        {
          children: children.slice(1),
          properties: { className: [] },
          tagName: "span",
          type: "element"
        }
      ];
    }
    return createElement({
      ...props,
      node: row,
      key: rowIndex
    });
  });
};
const isBoolean = (data) => {
  return typeof data === "boolean" || data instanceof Boolean;
};
const isNumber = (data) => {
  return typeof data === "number" || data instanceof Number;
};
const isBigInt = (data) => {
  return typeof data === "bigint" || data instanceof BigInt;
};
const isDate = (data) => {
  return !!data && data instanceof Date;
};
const isString = (data) => {
  return typeof data === "string" || data instanceof String;
};
const isArray = (data) => {
  return Array.isArray(data);
};
const isObject = (data) => {
  return typeof data === "object" && data !== null;
};
const isFunction = (data) => {
  return !!data && data instanceof Object && typeof data === "function";
};
function quoteString(value, quoted) {
  if (quoted === void 0) {
    quoted = false;
  }
  return !value || quoted ? `"${value}"` : value;
}
function quoteStringValue(value, quoted, stringify) {
  if (stringify) {
    return JSON.stringify(value);
  }
  return quoted ? `"${value}"` : value;
}
function ExpandableObject(_ref) {
  let {
    field,
    value,
    data,
    lastElement,
    openBracket,
    closeBracket,
    level,
    style,
    shouldExpandNode,
    clickToExpandNode,
    outerRef,
    beforeExpandChange
  } = _ref;
  const shouldExpandNodeCalledRef = useRef(false);
  const [expanded, setExpanded] = useState(() => shouldExpandNode(level, value, field));
  const expanderButtonRef = useRef(null);
  useEffect(() => {
    if (!shouldExpandNodeCalledRef.current) {
      shouldExpandNodeCalledRef.current = true;
    } else {
      setExpanded(shouldExpandNode(level, value, field));
    }
  }, [shouldExpandNode]);
  const contentsId = useId$1();
  if (data.length === 0) {
    return EmptyObject({
      field,
      openBracket,
      closeBracket,
      lastElement,
      style
    });
  }
  const expanderIconStyle = expanded ? style.collapseIcon : style.expandIcon;
  const ariaLabel = expanded ? style.ariaLables.collapseJson : style.ariaLables.expandJson;
  const childLevel = level + 1;
  const lastIndex = data.length - 1;
  const setExpandWithCallback = (newExpandValue) => {
    if (expanded !== newExpandValue && (!beforeExpandChange || beforeExpandChange({
      level,
      value,
      field,
      newExpandValue
    }))) {
      setExpanded(newExpandValue);
    }
  };
  const onKeyDown = (e2) => {
    if (e2.key === "ArrowRight" || e2.key === "ArrowLeft") {
      e2.preventDefault();
      setExpandWithCallback(e2.key === "ArrowRight");
    } else if (e2.key === "ArrowUp" || e2.key === "ArrowDown") {
      e2.preventDefault();
      const direction = e2.key === "ArrowUp" ? -1 : 1;
      if (!outerRef.current) return;
      const buttonElements = outerRef.current.querySelectorAll("[role=button]");
      let currentIndex = -1;
      for (let i2 = 0; i2 < buttonElements.length; i2++) {
        if (buttonElements[i2].tabIndex === 0) {
          currentIndex = i2;
          break;
        }
      }
      if (currentIndex < 0) {
        return;
      }
      const nextIndex = (currentIndex + direction + buttonElements.length) % buttonElements.length;
      buttonElements[currentIndex].tabIndex = -1;
      buttonElements[nextIndex].tabIndex = 0;
      buttonElements[nextIndex].focus();
    }
  };
  const onClick = () => {
    var _outerRef$current;
    setExpandWithCallback(!expanded);
    const buttonElement = expanderButtonRef.current;
    if (!buttonElement) return;
    const prevButtonElement = (_outerRef$current = outerRef.current) === null || _outerRef$current === void 0 ? void 0 : _outerRef$current.querySelector('[role=button][tabindex="0"]');
    if (prevButtonElement) {
      prevButtonElement.tabIndex = -1;
    }
    buttonElement.tabIndex = 0;
    buttonElement.focus();
  };
  return /* @__PURE__ */ createElement$1("div", {
    className: style.basicChildStyle,
    role: "treeitem",
    "aria-expanded": expanded,
    "aria-selected": void 0
  }, /* @__PURE__ */ createElement$1("span", {
    className: expanderIconStyle,
    onClick,
    onKeyDown,
    role: "button",
    "aria-label": ariaLabel,
    "aria-expanded": expanded,
    "aria-controls": expanded ? contentsId : void 0,
    ref: expanderButtonRef,
    tabIndex: level === 0 ? 0 : -1
  }), (field || field === "") && (clickToExpandNode ? /* @__PURE__ */ createElement$1("span", {
    className: style.clickableLabel,
    onClick,
    onKeyDown
  }, quoteString(field, style.quotesForFieldNames), ":") : /* @__PURE__ */ createElement$1("span", {
    className: style.label
  }, quoteString(field, style.quotesForFieldNames), ":")), /* @__PURE__ */ createElement$1("span", {
    className: style.punctuation
  }, openBracket), expanded ? /* @__PURE__ */ createElement$1("ul", {
    id: contentsId,
    role: "group",
    className: style.childFieldsContainer
  }, data.map((dataElement, index2) => /* @__PURE__ */ createElement$1(DataRender, {
    key: dataElement[0] || index2,
    field: dataElement[0],
    value: dataElement[1],
    style,
    lastElement: index2 === lastIndex,
    level: childLevel,
    shouldExpandNode,
    clickToExpandNode,
    outerRef
  }))) : /* @__PURE__ */ createElement$1("span", {
    className: style.collapsedContent,
    onClick,
    onKeyDown
  }), /* @__PURE__ */ createElement$1("span", {
    className: style.punctuation
  }, closeBracket), !lastElement && /* @__PURE__ */ createElement$1("span", {
    className: style.punctuation
  }, ","));
}
function EmptyObject(_ref2) {
  let {
    field,
    openBracket,
    closeBracket,
    lastElement,
    style
  } = _ref2;
  return /* @__PURE__ */ createElement$1("div", {
    className: style.basicChildStyle,
    role: "treeitem",
    "aria-selected": void 0
  }, (field || field === "") && /* @__PURE__ */ createElement$1("span", {
    className: style.label
  }, quoteString(field, style.quotesForFieldNames), ":"), /* @__PURE__ */ createElement$1("span", {
    className: style.punctuation
  }, openBracket), /* @__PURE__ */ createElement$1("span", {
    className: style.punctuation
  }, closeBracket), !lastElement && /* @__PURE__ */ createElement$1("span", {
    className: style.punctuation
  }, ","));
}
function JsonObject(_ref3) {
  let {
    field,
    value,
    style,
    lastElement,
    shouldExpandNode,
    clickToExpandNode,
    level,
    outerRef,
    beforeExpandChange
  } = _ref3;
  return ExpandableObject({
    field,
    value,
    lastElement: lastElement || false,
    level,
    openBracket: "{",
    closeBracket: "}",
    style,
    shouldExpandNode,
    clickToExpandNode,
    data: Object.keys(value).map((key) => [key, value[key]]),
    outerRef,
    beforeExpandChange
  });
}
function JsonArray(_ref4) {
  let {
    field,
    value,
    style,
    lastElement,
    level,
    shouldExpandNode,
    clickToExpandNode,
    outerRef,
    beforeExpandChange
  } = _ref4;
  return ExpandableObject({
    field,
    value,
    lastElement: lastElement || false,
    level,
    openBracket: "[",
    closeBracket: "]",
    style,
    shouldExpandNode,
    clickToExpandNode,
    data: value.map((element) => [void 0, element]),
    outerRef,
    beforeExpandChange
  });
}
function JsonPrimitiveValue(_ref5) {
  let {
    field,
    value,
    style,
    lastElement
  } = _ref5;
  let stringValue;
  let valueStyle = style.otherValue;
  if (value === null) {
    stringValue = "null";
    valueStyle = style.nullValue;
  } else if (value === void 0) {
    stringValue = "undefined";
    valueStyle = style.undefinedValue;
  } else if (isString(value)) {
    stringValue = quoteStringValue(value, !style.noQuotesForStringValues, style.stringifyStringValues);
    valueStyle = style.stringValue;
  } else if (isBoolean(value)) {
    stringValue = value ? "true" : "false";
    valueStyle = style.booleanValue;
  } else if (isNumber(value)) {
    stringValue = value.toString();
    valueStyle = style.numberValue;
  } else if (isBigInt(value)) {
    stringValue = `${value.toString()}n`;
    valueStyle = style.numberValue;
  } else if (isDate(value)) {
    stringValue = value.toISOString();
  } else if (isFunction(value)) {
    stringValue = "function() { }";
  } else {
    stringValue = value.toString();
  }
  return /* @__PURE__ */ createElement$1("div", {
    className: style.basicChildStyle,
    role: "treeitem",
    "aria-selected": void 0
  }, (field || field === "") && /* @__PURE__ */ createElement$1("span", {
    className: style.label
  }, quoteString(field, style.quotesForFieldNames), ":"), /* @__PURE__ */ createElement$1("span", {
    className: valueStyle
  }, stringValue), !lastElement && /* @__PURE__ */ createElement$1("span", {
    className: style.punctuation
  }, ","));
}
function DataRender(props) {
  const value = props.value;
  if (isArray(value)) {
    return /* @__PURE__ */ createElement$1(JsonArray, Object.assign({}, props));
  }
  if (isObject(value) && !isDate(value) && !isFunction(value)) {
    return /* @__PURE__ */ createElement$1(JsonObject, Object.assign({}, props));
  }
  return /* @__PURE__ */ createElement$1(JsonPrimitiveValue, Object.assign({}, props));
}
var styles = { "container-light": "_2IvMF _GzYRV", "basic-element-style": "_2bkNM", "child-fields-container": "_1BXBN", "label-light": "_1MGIk", "clickable-label-light": "_2YKJg _1MGIk _1MFti", "punctuation-light": "_3uHL6 _3eOF8", "value-null-light": "_2T6PJ", "value-undefined-light": "_1Gho6", "value-string-light": "_vGjyY", "value-number-light": "_1bQdo", "value-boolean-light": "_3zQKs", "value-other-light": "_1xvuR", "collapse-icon-light": "_oLqym _f10Tu _1MFti _1LId0", "expand-icon-light": "_2AXVT _f10Tu _1MFti _1UmXx", "collapsed-content-light": "_2KJWg _1pNG9 _1MFti" };
const defaultAriaLables = {
  collapseJson: "collapse JSON",
  expandJson: "expand JSON"
};
const defaultStyles = {
  container: styles["container-light"],
  basicChildStyle: styles["basic-element-style"],
  childFieldsContainer: styles["child-fields-container"],
  label: styles["label-light"],
  clickableLabel: styles["clickable-label-light"],
  nullValue: styles["value-null-light"],
  undefinedValue: styles["value-undefined-light"],
  stringValue: styles["value-string-light"],
  booleanValue: styles["value-boolean-light"],
  numberValue: styles["value-number-light"],
  otherValue: styles["value-other-light"],
  punctuation: styles["punctuation-light"],
  collapseIcon: styles["collapse-icon-light"],
  expandIcon: styles["expand-icon-light"],
  collapsedContent: styles["collapsed-content-light"],
  noQuotesForStringValues: false,
  quotesForFieldNames: false,
  ariaLables: defaultAriaLables,
  stringifyStringValues: false
};
const allExpanded = () => true;
const JsonView = (_ref) => {
  let {
    data,
    style = defaultStyles,
    shouldExpandNode = allExpanded,
    clickToExpandNode = false,
    beforeExpandChange,
    ...ariaAttrs
  } = _ref;
  const outerRef = useRef(null);
  return /* @__PURE__ */ createElement$1("div", Object.assign({
    "aria-label": "JSON view"
  }, ariaAttrs, {
    className: style.container,
    ref: outerRef,
    role: "tree"
  }), /* @__PURE__ */ createElement$1(DataRender, {
    value: data,
    style: {
      ...defaultStyles,
      ...style
    },
    lastElement: true,
    level: 0,
    shouldExpandNode,
    clickToExpandNode,
    outerRef,
    beforeExpandChange
  }));
};
const CodeBoxJson = ({ data }) => {
  return /* @__PURE__ */ jsx(
    JsonView,
    {
      data,
      style: {
        container: clsx(""),
        basicChildStyle: clsx(
          "ui:relative ui:ml-3 ui:whitespace-nowrap ui:text-primary"
        ),
        label: clsx("ui:mr-1 ui:text-accent-pink-contrast"),
        nullValue: clsx("ui:text-accent-orange-contrast"),
        undefinedValue: clsx("ui:text-accent-orange-contrast"),
        stringValue: clsx("ui:text-primary"),
        numberValue: clsx("ui:text-accent-blue-contrast"),
        booleanValue: clsx("ui:text-accent-green-contrast"),
        punctuation: clsx("ui:text-tertiary"),
        otherValue: "",
        expandIcon: clsx(
          "ui:absolute ui:-mt-[5px] ui:-ml-4 ui:text-lg ui:text-tertiary ui:opacity-70 ui:after:content-['▸'] ui:hover:opacity-100"
        ),
        collapseIcon: clsx(
          "ui:absolute ui:-mt-[5px] ui:-ml-4 ui:text-lg ui:text-tertiary ui:opacity-70 ui:after:content-['▾'] ui:hover:opacity-100"
        ),
        collapsedContent: clsx(
          "ui:text-tertiary ui:opacity-70 ui:after:content-['...'] ui:hover:opacity-100"
        ),
        clickableLabel: "",
        noQuotesForStringValues: false
      }
    }
  );
};
const rootClassName = clsx(
  "ui:flex ui:flex-col ui:overflow-hidden",
  "ui:rounded-lg ui:border ui:border-primary",
  "ui:bg-card"
);
const headerClassName = clsx(
  "ui:flex ui:items-center ui:gap-2 ui:p-2 ui:pl-4",
  "ui:bg-subtle ui:text-secondary ui:dark:bg-secondary ui:dark:text-tertiary"
);
const titleClassName$3 = clsx(
  "ui:flex ui:items-center ui:gap-1.5 ui:self-center ui:rounded-xl ui:text-paragraph-200-medium"
);
const contentClassName$3 = clsx(
  "ui:flex ui:min-h-0 ui:flex-1 ui:flex-col ui:px-4",
  "ui:bg-card"
);
const tabsClassName = clsx("ui:mt-3 ui:-mb-3 ui:min-h-0");
const scrollAreaClassName = clsx("ui:-mx-4 ui:-mt-3 ui:min-h-0");
const scrollAreaContentClassName = clsx(
  "ui:px-4 ui:py-3 ui:font-mono ui:text-code-200 ui:text-primary"
);
const scrollBarClassName = clsx(
  "ui:data-[orientation=horizontal]:mx-3 ui:data-[orientation=vertical]:my-3"
);
const standaloneTabClassName = clsx(
  "ui:flex ui:min-h-0 ui:flex-1 ui:flex-col ui:pt-3"
);
const parseJson = (code) => {
  try {
    return JSON.parse(code);
  } catch {
    return code;
  }
};
const CodeBox = ({
  className,
  title,
  icon,
  snippets,
  theme: theme2 = "light",
  activeTabIndex,
  onChangeActiveTabIndex,
  onCopy,
  children,
  headerChildren,
  showTruncateWarning = false
}) => {
  const [activeSnippetIndex, setActiveSnippetIndex] = useState(
    activeTabIndex ?? 0
  );
  useEffect(() => {
    if (activeTabIndex == null) {
      return;
    }
    setActiveSnippetIndex(activeTabIndex);
  }, [activeTabIndex]);
  const invertedTheme = theme2 === "light" ? "dark" : "light";
  const renderTabContent = (snippet) => {
    return /* @__PURE__ */ jsx(
      ScrollArea,
      {
        className: scrollAreaClassName,
        scrollBarClassName,
        size: "sm",
        theme: invertedTheme,
        children: /* @__PURE__ */ jsx("div", { className: scrollAreaContentClassName, children: children ? children : snippet.language === "json" ? /* @__PURE__ */ jsx(CodeBoxJson, { data: parseJson(snippet.code) }) : /* @__PURE__ */ jsx(
          CodeBoxHighlighter,
          {
            language: snippet.language,
            code: snippet.code,
            wrapLongLines: snippet.wrapLongLines
          }
        ) })
      }
    );
  };
  const handleActiveTabChange = useCallback(
    (value) => {
      const selectedSnippet = snippets[+value];
      if (selectedSnippet == null ? void 0 : selectedSnippet.externalLink) {
        return window.open(selectedSnippet.externalLink);
      }
      setActiveSnippetIndex(+value);
      onChangeActiveTabIndex == null ? void 0 : onChangeActiveTabIndex(+value);
    },
    [snippets, onChangeActiveTabIndex]
  );
  const handleCopy = useCallback(() => {
    onCopy == null ? void 0 : onCopy(snippets[activeSnippetIndex]);
  }, [onCopy, activeSnippetIndex, snippets]);
  return /* @__PURE__ */ jsxs("div", { className: clsx(rootClassName, className), children: [
    /* @__PURE__ */ jsxs("div", { className: clsx(headerClassName), children: [
      /* @__PURE__ */ jsxs("div", { className: titleClassName$3, children: [
        icon,
        title
      ] }),
      showTruncateWarning && /* @__PURE__ */ jsx(
        Tooltip,
        {
          content: `Full ${title === "Request" ? "request" : "response"} has been truncated`,
          children: /* @__PURE__ */ jsx(WarningIcon, { className: "ml-2 text-icon-warning" })
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "ui:ml-auto ui:flex ui:items-center ui:gap-2", children: [
        headerChildren,
        /* @__PURE__ */ jsx(
          CopyTextButton,
          {
            size: "sm",
            value: snippets[activeSnippetIndex].code,
            theme: theme2 === "dark" ? "invert" : "inherit",
            onClick: handleCopy
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: contentClassName$3, children: snippets.length === 1 ? /* @__PURE__ */ jsx("div", { className: standaloneTabClassName, children: renderTabContent(snippets[0]) }) : /* @__PURE__ */ jsx(
      Tabs,
      {
        className: tabsClassName,
        tabs: snippets.map((snippet, index2) => ({
          value: String(index2),
          icon: snippet.icon,
          trailingIcon: snippet.externalLink ? /* @__PURE__ */ jsx(ArrowSquareOutIcon, {}) : void 0,
          title: snippet.title || "",
          content: renderTabContent(snippet)
        })),
        activeTab: String(activeSnippetIndex),
        onActiveTabChange: handleActiveTabChange
      }
    ) })
  ] });
};
const baseButtonClassName = clsx(
  "ui:inline-flex ui:items-center ui:justify-center ui:rounded-lg ui:outline-hidden ui:transition",
  "ui:size-7 ui:border ui:border-primary ui:bg-primary ui:text-icon-secondary",
  "ui:hover:bg-subtle ui:focus-visible:shadow-focus",
  "ui:aria-pressed:border-current ui:aria-pressed:bg-success-light ui:aria-pressed:text-icon-success",
  "ui:disabled:bg-secondary ui:disabled:text-icon-tertiary"
);
const CopyButton = ({
  value,
  theme: theme2 = "inherit",
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const { isCopiedToClipboard, handleCopyToClipboard } = useCopyToClipboard();
  const [isHovered, setIsHovered] = useState(false);
  const handleCopy = useCallback(
    (event) => {
      handleCopyToClipboard(value);
      onClick == null ? void 0 : onClick(event);
    },
    [value, handleCopyToClipboard, onClick]
  );
  const handleMouseEnter = useCallback(
    (event) => {
      if (!isCopiedToClipboard) {
        setIsHovered(true);
      }
      onMouseEnter == null ? void 0 : onMouseEnter(event);
    },
    [isCopiedToClipboard, onMouseEnter]
  );
  const handleMouseLeave = useCallback(
    (event) => {
      setIsHovered(false);
      onMouseLeave == null ? void 0 : onMouseLeave(event);
    },
    [onMouseLeave]
  );
  const tooltipOpen = isCopiedToClipboard || isHovered;
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      content: isCopiedToClipboard ? "Copied" : "Copy",
      withArrow: true,
      side: "top",
      open: tooltipOpen,
      disabled: props.disabled,
      children: /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          ...props,
          className: clsx(
            baseButtonClassName,
            theme2 === "inherit" ? void 0 : theme2,
            className
          ),
          onClick: handleCopy,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          "aria-pressed": isCopiedToClipboard,
          children: /* @__PURE__ */ jsx(CopyIcon, {})
        }
      )
    }
  );
};
function CopyField({ value, onCopy, ...props }) {
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ...props,
      value,
      readOnly: true,
      trailingSlot: /* @__PURE__ */ jsx(
        CopyTextButton,
        {
          size: "sm",
          value,
          className: "ui:-mr-0.5 ui:max-h-6",
          onClick: onCopy,
          disabled: props.disabled
        }
      ),
      onClick: (event) => event.currentTarget.select()
    }
  );
}
const containerClassName = clsx("ui:rounded-lg ui:bg-secondary");
const titleClassName$2 = clsx(
  "ui:group ui:px-3.5 ui:py-3 ui:text-left ui:outline-hidden",
  "ui:flex ui:w-full ui:items-center ui:justify-between",
  "ui:text-heading-h4 ui:text-secondary",
  "ui:rounded-lg ui:focus-visible:shadow-focus"
);
const chevronClassName = clsx(
  "ui:h-5 ui:w-5 ui:shrink-0 ui:transition",
  "ui:group-aria-expanded:rotate-180"
);
const contentClassName$2 = clsx(
  "ui:px-3.5 ui:pb-3 ui:text-paragraph-200-regular"
);
function Disclosure({
  title,
  className,
  titleContainerClassName,
  innerContainerClassName,
  iconClassName: iconClassName2,
  children,
  open,
  setOpen,
  defaultOpen
}) {
  const [openState, setOpenState] = useState(defaultOpen ?? false);
  const isOpen = open ?? openState;
  return /* @__PURE__ */ jsxs(
    Collapsible.Root,
    {
      className: clsx(className, containerClassName),
      open: isOpen,
      onOpenChange: setOpen ?? setOpenState,
      children: [
        /* @__PURE__ */ jsxs(
          Collapsible.Trigger,
          {
            className: clsx(titleContainerClassName, titleClassName$2),
            children: [
              title,
              /* @__PURE__ */ jsx(CaretDownIcon, { className: clsx(chevronClassName, iconClassName2) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Collapsible.Content, { asChild: true, forceMount: true, children: /* @__PURE__ */ jsx(
          motion.div,
          {
            initial: false,
            transition: { duration: 0.15 },
            animate: {
              opacity: isOpen ? 1 : 0,
              height: isOpen ? "auto" : 0,
              visibility: isOpen ? "visible" : void 0,
              overflow: isOpen ? "visible" : void 0,
              transitionEnd: {
                visibility: isOpen ? "visible" : "hidden",
                overflow: isOpen ? "visible" : "hidden"
              }
            },
            children: /* @__PURE__ */ jsx("div", { className: clsx(innerContainerClassName, contentClassName$2), children })
          }
        ) })
      ]
    }
  );
}
const popoverClassName = clsx(
  "ui:z-30 ui:flex ui:max-h-[320px] ui:overflow-hidden",
  "ui:rounded-lg ui:border ui:border-primary ui:bg-card ui:shadow-dropdown-lg ui:outline-hidden ui:dark:bg-primary"
);
const itemClassName = clsx(
  "ui:group ui:flex ui:cursor-pointer ui:items-center ui:gap-2 ui:px-3.5 ui:py-2.5 ui:outline-hidden ui:transition",
  "ui:text-paragraph-200-regular ui:text-secondary ui:hover:bg-secondary ui:data-highlighted:bg-secondary ui:dark:hover:bg-app-header-hover ui:dark:data-highlighted:bg-app-header-hover"
);
const DropdownMenu = ({
  children,
  options,
  sameWidth,
  onSelect,
  align = "start"
}) => {
  return /* @__PURE__ */ jsxs(DropdownMenu$1.Root, { modal: true, children: [
    /* @__PURE__ */ jsx(DropdownMenu$1.Trigger, { asChild: true, children }),
    /* @__PURE__ */ jsx(DropdownMenu$1.Portal, { children: /* @__PURE__ */ jsx(
      DropdownMenu$1.Content,
      {
        className: popoverClassName,
        align,
        sideOffset: 8,
        collisionPadding: 8,
        onCloseAutoFocus: preventDefault,
        style: {
          width: sameWidth ? "var(--radix-popper-anchor-width)" : void 0
        },
        children: /* @__PURE__ */ jsx(ScrollArea, { children: options.map(({ displayLabel, label, id }) => /* @__PURE__ */ jsx(
          DropdownMenu$1.Item,
          {
            className: itemClassName,
            onClick: () => onSelect(id),
            children: displayLabel || label
          },
          id
        )) })
      }
    ) })
  ] });
};
const preventDefault = (event) => event == null ? void 0 : event.preventDefault();
const cardClassName$1 = clsx("ui:group ui:w-full ui:disabled:cursor-not-allowed");
const cardInnerClassName = clsx(
  "ui:flex ui:rounded-[inherit] ui:group-disabled:bg-subtle/60"
);
const iconClassName$2 = clsx(
  "ui:flex ui:items-center ui:rounded-l-[7px]",
  "ui:bg-brand-subtle ui:p-4 ui:text-brand ui:transition",
  "ui:group-hover:text-brand",
  "ui:group-disabled:bg-disabled/60 ui:group-disabled:text-disabled ui:group-hover:group-disabled:text-disabled"
);
const contentClassName$1 = clsx("ui:flex-1 ui:p-3 ui:pr-0 ui:text-left");
const titleClassName$1 = clsx(
  "ui:text-paragraph-200-medium ui:text-primary",
  "ui:group-disabled:text-disabled"
);
const descriptionClassName$1 = clsx(
  "ui:text-paragraph-200-regular ui:text-tertiary"
);
const arrowClassName = clsx(
  "ui:mx-3 ui:mt-auto ui:mb-3 ui:text-tertiary ui:transition",
  "ui:group-hover:text-brand",
  "ui:group-active:text-informative"
);
const polyRef$3 = forwardRef;
const ExploreCard = polyRef$3(
  ({ as = "button", className, title, description, icon, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Card,
      {
        as,
        ref,
        interactive: !props.disabled,
        className: clsx(cardClassName$1, className),
        ...props,
        children: /* @__PURE__ */ jsxs("div", { className: cardInnerClassName, children: [
          /* @__PURE__ */ jsx("div", { className: iconClassName$2, children: icon }),
          /* @__PURE__ */ jsxs("div", { className: contentClassName$1, children: [
            /* @__PURE__ */ jsx("div", { className: titleClassName$1, children: title }),
            /* @__PURE__ */ jsx("div", { className: descriptionClassName$1, children: description })
          ] }),
          props.disabled ? null : /* @__PURE__ */ jsx(ArrowRightIcon, { className: arrowClassName })
        ] })
      }
    );
  }
);
const accentBlue = "data:image/svg+xml,%3csvg%20width='330'%20height='166'%20viewBox='0%200%20330%20166'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='-250.875'%20y='232.174'%20width='810.192'%20height='450.107'%20transform='rotate(-24.7053%20-250.875%20232.174)'%20fill='white'%20/%3e%3cg%20filter='url(%23filter0_f_753_39461)'%3e%3cellipse%20cx='442.917'%20cy='-221.094'%20rx='529.414'%20ry='499.9'%20transform='rotate(-24.7053%20442.917%20-221.094)'%20fill='%23BFE4FF'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter1_f_753_39461)'%3e%3cellipse%20cx='465.175'%20cy='-106.492'%20rx='401.027'%20ry='379.26'%20transform='rotate(-24.7053%20465.175%20-106.492)'%20fill='%23B0D0FF'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter2_f_753_39461)'%3e%3cellipse%20cx='509.188'%20cy='-122.627'%20rx='343.105'%20ry='323.92'%20transform='rotate(-24.7053%20509.188%20-122.627)'%20fill='%23D49EFF'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter3_f_753_39461)'%3e%3cpath%20d='M782.043%20-333.45C843.342%20-200.208%20836.886%20-95.7796%20626.145%20110.484C509.142%20190.014%20332.718%2034.7098%20271.419%20-98.5322C210.12%20-231.774%20274.734%20-392.376%20415.739%20-457.247C556.744%20-522.118%20720.744%20-466.692%20782.043%20-333.45Z'%20fill='%23F6F9FD'%20fill-opacity='0.6'%20/%3e%3c/g%3e%3cpath%20d='M299.927%2029.3945L468.827%20396.52L765.629%20157.223L509.468%20-292.281L299.927%2029.3945Z'%20fill='url(%23paint0_linear_753_39461)'%20/%3e%3cpath%20d='M300.006%2028.8974L468.651%20395.468L-184.461%20703.266L-416.315%20233.346L300.006%2028.8974Z'%20fill='url(%23paint1_linear_753_39461)'%20/%3e%3cdefs%3e%3cfilter%20id='filter0_f_753_39461'%20x='-270.181'%20y='-914.975'%20width='1426.2'%20height='1387.76'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='94.2932'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3cfilter%20id='filter1_f_753_39461'%20x='-38.1127'%20y='-595.607'%20width='1006.57'%20height='978.229'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='52.9382'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3cfilter%20id='filter2_f_753_39461'%20x='23.2324'%20y='-596.092'%20width='971.912'%20height='946.929'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='73.0191'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3cfilter%20id='filter3_f_753_39461'%20x='146.061'%20y='-586.587'%20width='771.851'%20height='820.938'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='51.1024'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear_753_39461'%20x1='95.1891'%20y1='-319.379'%20x2='740.674'%20y2='122.493'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_753_39461'%20x1='-410.651'%20y1='35.6542'%20x2='327.128'%20y2='294.897'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'%20/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
const accentYellow = "data:image/svg+xml,%3csvg%20width='330'%20height='166'%20viewBox='0%200%20330%20166'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='-250.875'%20y='232.174'%20width='810.192'%20height='450.107'%20transform='rotate(-24.7053%20-250.875%20232.174)'%20fill='white'%20/%3e%3cg%20filter='url(%23filter0_f_753_39461)'%3e%3cellipse%20cx='442.917'%20cy='-221.094'%20rx='529.414'%20ry='499.9'%20transform='rotate(-24.7053%20442.917%20-221.094)'%20fill='%23BFE4FF'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter1_f_753_39461)'%3e%3cellipse%20cx='465.175'%20cy='-106.492'%20rx='401.027'%20ry='379.26'%20transform='rotate(-24.7053%20465.175%20-106.492)'%20fill='%23B0D0FF'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter2_f_753_39461)'%3e%3cellipse%20cx='509.188'%20cy='-122.627'%20rx='343.105'%20ry='323.92'%20transform='rotate(-24.7053%20509.188%20-122.627)'%20fill='%23D49EFF'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter3_f_753_39461)'%3e%3cpath%20d='M782.043%20-333.45C843.342%20-200.208%20836.886%20-95.7796%20626.145%20110.484C509.142%20190.014%20332.718%2034.7098%20271.419%20-98.5322C210.12%20-231.774%20274.734%20-392.376%20415.739%20-457.247C556.744%20-522.118%20720.744%20-466.692%20782.043%20-333.45Z'%20fill='%23F6F9FD'%20fill-opacity='0.6'%20/%3e%3c/g%3e%3cpath%20d='M299.927%2029.3945L468.827%20396.52L765.629%20157.223L509.468%20-292.281L299.927%2029.3945Z'%20fill='url(%23paint0_linear_753_39461)'%20/%3e%3cpath%20d='M300.006%2028.8974L468.651%20395.468L-184.461%20703.266L-416.315%20233.346L300.006%2028.8974Z'%20fill='url(%23paint1_linear_753_39461)'%20/%3e%3cdefs%3e%3cfilter%20id='filter0_f_753_39461'%20x='-270.181'%20y='-914.975'%20width='1426.2'%20height='1387.76'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='94.2932'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3cfilter%20id='filter1_f_753_39461'%20x='-38.1127'%20y='-595.607'%20width='1006.57'%20height='978.229'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='52.9382'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3cfilter%20id='filter2_f_753_39461'%20x='23.2324'%20y='-596.092'%20width='971.912'%20height='946.929'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='73.0191'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3cfilter%20id='filter3_f_753_39461'%20x='146.061'%20y='-586.587'%20width='771.851'%20height='820.938'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='51.1024'%20result='effect1_foregroundBlur_753_39461'%20/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear_753_39461'%20x1='95.1891'%20y1='-319.379'%20x2='740.674'%20y2='122.493'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'%20/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_753_39461'%20x1='-410.651'%20y1='35.6542'%20x2='327.128'%20y2='294.897'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'%20/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
const cardClassName = clsx(
  "ui:relative ui:isolate ui:flex ui:cursor-default ui:snap-start ui:items-start ui:justify-between ui:select-none",
  "ui:overflow-hidden ui:rounded-lg ui:bg-disabled ui:outline-hidden ui:transition",
  "ui:focus-visible:shadow-focus"
);
const titleClassName = clsx("ui:text-heading-h3 ui:text-on-light");
const descriptionClassName = clsx(
  "ui:mt-1 ui:mb-4 ui:text-paragraph-200-regular ui:text-on-light"
);
const backgroundImageUrls = {
  blue: accentBlue,
  yellow: accentYellow
};
const FeatureCard = ({
  as: Component = "div",
  className,
  variant,
  title,
  description,
  ctaLabel,
  ctaLink,
  emblem,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(Component, { className: clsx(cardClassName, className), ...props, children: [
    /* @__PURE__ */ jsx(
      "img",
      {
        src: backgroundImageUrls[variant],
        alt: "",
        className: "ui:absolute ui:-z-10 ui:size-full ui:object-cover"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "ui:flex ui:h-full ui:flex-col ui:items-start ui:p-5", children: [
      /* @__PURE__ */ jsx("div", { className: titleClassName, children: title }),
      /* @__PURE__ */ jsx("div", { className: descriptionClassName, children: description }),
      ctaLabel && ctaLink && /* @__PURE__ */ jsx(
        Button,
        {
          as: "a",
          href: ctaLink,
          size: "sm",
          intent: "secondary",
          target: "_blank",
          className: "ui:mt-auto",
          rel: "noopener noreferrer",
          children: ctaLabel
        }
      )
    ] }),
    emblem && /* @__PURE__ */ jsx(
      "div",
      {
        className: "ui:my-4 ui:flex ui:min-w-[90px] ui:items-center ui:rounded-l-full ui:bg-primary/60 ui:p-2",
        style: {
          backdropFilter: "blur(15px)"
        },
        children: /* @__PURE__ */ jsx("div", { className: "ui:size-[68px] ui:rounded-full ui:bg-primary ui:p-2.5", children: emblem })
      }
    )
  ] });
};
const roundedClassName = {
  none: clsx(""),
  slight: clsx("ui:rounded"),
  full: clsx("ui:rounded-full")
};
const paddingClassName = {
  none: clsx(""),
  sm: clsx("ui:-m-0.5 ui:p-0.5"),
  md: clsx("ui:-m-1 ui:p-1"),
  lg: clsx("ui:-m-1.5 ui:p-1.5")
};
const polyRef$2 = forwardRef;
const IconButton = polyRef$2(
  ({ className, rounded = "full", padding = "md", as = "button", ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Command,
      {
        as,
        ref,
        ...props,
        className: clsx(
          className,
          roundedClassName[rounded],
          paddingClassName[padding]
        )
      }
    );
  }
);
const baseAlertClassName = clsx(
  "ui:inline-flex ui:items-start ui:gap-2 ui:rounded-lg",
  "ui:p-2 ui:text-start ui:text-label-200 ui:transition",
  "ui:outline-hidden ui:focus-visible:shadow-focus"
);
const intentClassNames = {
  default: clsx("ui:bg-primary ui:text-secondary"),
  info: clsx("ui:bg-informative-subtle ui:text-informative"),
  error: clsx("ui:bg-critical-subtle ui:text-critical"),
  warning: clsx("ui:bg-warning-subtle ui:text-warning"),
  success: clsx("ui:bg-success-subtle ui:text-success")
};
const interactiveIntentClassNames = {
  default: clsx("ui:hover:bg-subtle ui:active:bg-secondary"),
  info: clsx("ui:hover:bg-informative-light ui:active:bg-informative-medium"),
  error: clsx("ui:hover:bg-critical-light ui:active:bg-critical-medium"),
  warning: clsx("ui:hover:bg-warning-light ui:active:bg-warning-medium"),
  success: clsx("ui:hover:bg-success-light ui:active:bg-success-medium")
};
const leadingLabelClassName = clsx(
  "ui:-my-0.5 ui:rounded ui:px-2 ui:py-1 ui:text-label-100 ui:whitespace-nowrap"
);
const leadingLabelIntentClassNames = {
  default: clsx("ui:bg-secondary ui:text-secondary"),
  info: clsx("ui:bg-informative-dark ui:text-invert"),
  error: clsx("ui:bg-critical-dark ui:text-invert"),
  warning: clsx("ui:bg-warning-dark ui:text-invert"),
  success: clsx("ui:bg-success-dark ui:text-invert")
};
const polyRef$1 = forwardRef;
const InlineAlert = polyRef$1(
  ({
    as = "div",
    intent = "default",
    children,
    className,
    leadingLabel,
    interactive
  }, ref) => {
    const Component = as;
    return /* @__PURE__ */ jsxs(
      Component,
      {
        ref,
        className: clsx(
          className,
          baseAlertClassName,
          intentClassNames[intent],
          interactive ? interactiveIntentClassNames[intent] : null
        ),
        children: [
          leadingLabel ? /* @__PURE__ */ jsx(
            "div",
            {
              className: clsx(
                leadingLabelClassName,
                leadingLabelIntentClassNames[intent]
              ),
              children: leadingLabel
            }
          ) : null,
          /* @__PURE__ */ jsx("div", { className: "ui:grow ui:self-center ui:py-px", children }),
          interactive && /* @__PURE__ */ jsx(ArrowRightIcon, { className: "ui:my-[3px]" })
        ]
      }
    );
  }
);
const sizeClassNames$2 = {
  lg: clsx("ui:text-label-400"),
  md: clsx("ui:text-label-300"),
  sm: clsx("ui:text-label-200"),
  xs: clsx("ui:text-label-100")
};
const variantClassNames = {
  black: clsx(
    "ui:text-primary",
    "ui:hover:text-secondary",
    "ui:active:text-primary"
  ),
  white: "",
  // should be black in dark mode
  blue: clsx(
    "ui:text-brand",
    "ui:hover:text-accent-blue",
    "ui:active:text-accent-blue-contrast"
  )
};
const baseLinkClassName = clsx(
  "ui:group/link ui:-m-1 ui:inline-flex ui:items-center ui:p-1",
  "ui:cursor-pointer ui:rounded-lg ui:outline-hidden ui:transition",
  "ui:aria-disabled:cursor-default ui:aria-disabled:text-disabled",
  "ui:focus-visible:shadow-focus"
);
const iconClassName$1 = clsx(
  "ui:transition-transform ui:group-hover/link:translate-x-1",
  "ui:group-aria-disabled/link:translate-x-0"
);
const Link = ({
  as: Component = "a",
  children,
  className,
  size: size2 = "md",
  variant = "blue",
  showArrowIcon,
  disabled,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(
    Component,
    {
      ...props,
      "aria-disabled": disabled,
      className: clsx(
        className,
        baseLinkClassName,
        sizeClassNames$2[size2],
        variantClassNames[variant === "white" ? "black" : variant],
        variant === "blue" ? "" : variant === "white" ? "dark" : "light"
      ),
      children: [
        children,
        showArrowIcon ? /* @__PURE__ */ jsx(CaretRightIcon, { className: iconClassName$1 }) : null
      ]
    }
  );
};
const buttonClassName$1 = clsx(
  "ui:flex ui:h-10 ui:items-center ui:gap-2 ui:rounded-lg ui:px-3 ui:text-start",
  "ui:bg-primary/10 ui:text-label-200 ui:text-invert ui:outline-hidden ui:transition",
  "ui:hover:bg-primary/20",
  "ui:active:bg-primary/5",
  "ui:focus-visible:bg-primary/5 ui:focus-visible:shadow-focus-dark",
  "ui:disabled:opacity-50"
);
const iconClassName = clsx("ui:only:-mx-px");
const polyRef = forwardRef;
const LowOpacityButton = polyRef(
  ({ as: Component = "button", children, icon, className, ...props }, ref) => {
    return /* @__PURE__ */ jsxs(
      Component,
      {
        type: "button",
        ref,
        ...props,
        className: clsx(className, buttonClassName$1),
        children: [
          icon ? /* @__PURE__ */ jsx("span", { className: iconClassName, children: icon }) : null,
          children ? /* @__PURE__ */ jsx("span", { children }) : null
        ]
      }
    );
  }
);
var lib = { exports: {} };
var Modal$1 = {};
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e2 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g2 = b2 ? Symbol.for("react.profiler") : 60114, h2 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z(a3) {
    if ("object" === typeof a3 && null !== a3) {
      var u2 = a3.$$typeof;
      switch (u2) {
        case c2:
          switch (a3 = a3.type, a3) {
            case l2:
            case m2:
            case e2:
            case g2:
            case f2:
            case p2:
              return a3;
            default:
              switch (a3 = a3 && a3.$$typeof, a3) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a3;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A2(a3) {
    return z(a3) === m2;
  }
  reactIs_production_min.AsyncMode = l2;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h2;
  reactIs_production_min.Element = c2;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e2;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d2;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f2;
  reactIs_production_min.Suspense = p2;
  reactIs_production_min.isAsyncMode = function(a3) {
    return A2(a3) || z(a3) === l2;
  };
  reactIs_production_min.isConcurrentMode = A2;
  reactIs_production_min.isContextConsumer = function(a3) {
    return z(a3) === k2;
  };
  reactIs_production_min.isContextProvider = function(a3) {
    return z(a3) === h2;
  };
  reactIs_production_min.isElement = function(a3) {
    return "object" === typeof a3 && null !== a3 && a3.$$typeof === c2;
  };
  reactIs_production_min.isForwardRef = function(a3) {
    return z(a3) === n2;
  };
  reactIs_production_min.isFragment = function(a3) {
    return z(a3) === e2;
  };
  reactIs_production_min.isLazy = function(a3) {
    return z(a3) === t2;
  };
  reactIs_production_min.isMemo = function(a3) {
    return z(a3) === r2;
  };
  reactIs_production_min.isPortal = function(a3) {
    return z(a3) === d2;
  };
  reactIs_production_min.isProfiler = function(a3) {
    return z(a3) === g2;
  };
  reactIs_production_min.isStrictMode = function(a3) {
    return z(a3) === f2;
  };
  reactIs_production_min.isSuspense = function(a3) {
    return z(a3) === p2;
  };
  reactIs_production_min.isValidElementType = function(a3) {
    return "string" === typeof a3 || "function" === typeof a3 || a3 === e2 || a3 === m2 || a3 === g2 || a3 === f2 || a3 === p2 || a3 === q2 || "object" === typeof a3 && null !== a3 && (a3.$$typeof === t2 || a3.$$typeof === r2 || a3.$$typeof === h2 || a3.$$typeof === k2 || a3.$$typeof === n2 || a3.$$typeof === w2 || a3.$$typeof === x2 || a3.$$typeof === y2 || a3.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from, symbols[i2])) {
            to[symbols[i2]] = from[symbols[i2]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error2.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error2 = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is(propValue, expectedValues[i2])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var ModalPortal = { exports: {} };
var focusManager = {};
var tabbable = { exports: {} };
var hasRequiredTabbable;
function requireTabbable() {
  if (hasRequiredTabbable) return tabbable.exports;
  hasRequiredTabbable = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = findTabbableDescendants;
    /*!
     * Adapted from jQuery UI core
     *
     * http://jqueryui.com
     *
     * Copyright 2014 jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     *
     * http://api.jqueryui.com/category/ui-core/
     */
    var DISPLAY_NONE = "none";
    var DISPLAY_CONTENTS = "contents";
    var tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
    function isNotOverflowing(element, style) {
      return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
      element.scrollWidth <= 0 && element.scrollHeight <= 0;
    }
    function hidesContents(element) {
      var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
      if (zeroSize && !element.innerHTML) return true;
      try {
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
      } catch (exception) {
        console.warn("Failed to inspect element style");
        return false;
      }
    }
    function visible(element) {
      var parentElement = element;
      var rootNode = element.getRootNode && element.getRootNode();
      while (parentElement) {
        if (parentElement === document.body) break;
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if (hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
      }
      return true;
    }
    function focusable(element, isTabIndexNotNaN) {
      var nodeName = element.nodeName.toLowerCase();
      var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
      return res && visible(element);
    }
    function tabbable2(element) {
      var tabIndex = element.getAttribute("tabindex");
      if (tabIndex === null) tabIndex = void 0;
      var isTabIndexNaN = isNaN(tabIndex);
      return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
    }
    function findTabbableDescendants(element) {
      var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
      }, []);
      return descendants.filter(tabbable2);
    }
    module.exports = exports["default"];
  })(tabbable, tabbable.exports);
  return tabbable.exports;
}
var hasRequiredFocusManager;
function requireFocusManager() {
  if (hasRequiredFocusManager) return focusManager;
  hasRequiredFocusManager = 1;
  Object.defineProperty(focusManager, "__esModule", {
    value: true
  });
  focusManager.resetState = resetState;
  focusManager.log = log;
  focusManager.handleBlur = handleBlur;
  focusManager.handleFocus = handleFocus;
  focusManager.markForFocusLater = markForFocusLater;
  focusManager.returnFocus = returnFocus;
  focusManager.popWithoutFocus = popWithoutFocus;
  focusManager.setupScopedFocus = setupScopedFocus;
  focusManager.teardownScopedFocus = teardownScopedFocus;
  var _tabbable = requireTabbable();
  var _tabbable2 = _interopRequireDefault(_tabbable);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var focusLaterElements = [];
  var modalElement = null;
  var needToFocus = false;
  function resetState() {
    focusLaterElements = [];
  }
  function log() {
    if (process.env.NODE_ENV !== "production") {
      console.log("focusManager ----------");
      focusLaterElements.forEach(function(f2) {
        var check = f2 || {};
        console.log(check.nodeName, check.className, check.id);
      });
      console.log("end focusManager ----------");
    }
  }
  function handleBlur() {
    needToFocus = true;
  }
  function handleFocus() {
    if (needToFocus) {
      needToFocus = false;
      if (!modalElement) {
        return;
      }
      setTimeout(function() {
        if (modalElement.contains(document.activeElement)) {
          return;
        }
        var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
        el.focus();
      }, 0);
    }
  }
  function markForFocusLater() {
    focusLaterElements.push(document.activeElement);
  }
  function returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var toFocus = null;
    try {
      if (focusLaterElements.length !== 0) {
        toFocus = focusLaterElements.pop();
        toFocus.focus({ preventScroll });
      }
      return;
    } catch (e2) {
      console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
    }
  }
  function popWithoutFocus() {
    focusLaterElements.length > 0 && focusLaterElements.pop();
  }
  function setupScopedFocus(element) {
    modalElement = element;
    if (window.addEventListener) {
      window.addEventListener("blur", handleBlur, false);
      document.addEventListener("focus", handleFocus, true);
    } else {
      window.attachEvent("onBlur", handleBlur);
      document.attachEvent("onFocus", handleFocus);
    }
  }
  function teardownScopedFocus() {
    modalElement = null;
    if (window.addEventListener) {
      window.removeEventListener("blur", handleBlur);
      document.removeEventListener("focus", handleFocus);
    } else {
      window.detachEvent("onBlur", handleBlur);
      document.detachEvent("onFocus", handleFocus);
    }
  }
  return focusManager;
}
var scopeTab = { exports: {} };
var hasRequiredScopeTab;
function requireScopeTab() {
  if (hasRequiredScopeTab) return scopeTab.exports;
  hasRequiredScopeTab = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = scopeTab2;
    var _tabbable = requireTabbable();
    var _tabbable2 = _interopRequireDefault(_tabbable);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function getActiveElement() {
      var el = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
      return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
    }
    function scopeTab2(node, event) {
      var tabbable2 = (0, _tabbable2.default)(node);
      if (!tabbable2.length) {
        event.preventDefault();
        return;
      }
      var target = void 0;
      var shiftKey = event.shiftKey;
      var head = tabbable2[0];
      var tail = tabbable2[tabbable2.length - 1];
      var activeElement = getActiveElement();
      if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
      }
      if (tail === activeElement && !shiftKey) {
        target = head;
      }
      if (head === activeElement && shiftKey) {
        target = tail;
      }
      if (target) {
        event.preventDefault();
        target.focus();
        return;
      }
      var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
      var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
      if (!isSafariDesktop) return;
      var x2 = tabbable2.indexOf(activeElement);
      if (x2 > -1) {
        x2 += shiftKey ? -1 : 1;
      }
      target = tabbable2[x2];
      if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
      }
      event.preventDefault();
      target.focus();
    }
    module.exports = exports["default"];
  })(scopeTab, scopeTab.exports);
  return scopeTab.exports;
}
var ariaAppHider = {};
var warning_1;
var hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning) return warning_1;
  hasRequiredWarning = 1;
  var __DEV__ = process.env.NODE_ENV !== "production";
  var warning = function() {
  };
  if (__DEV__) {
    var printWarning = function printWarning2(format2, args) {
      var len = arguments.length;
      args = new Array(len > 1 ? len - 1 : 0);
      for (var key = 1; key < len; key++) {
        args[key - 1] = arguments[key];
      }
      var argIndex = 0;
      var message = "Warning: " + format2.replace(/%s/g, function() {
        return args[argIndex++];
      });
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
    warning = function(condition, format2, args) {
      var len = arguments.length;
      args = new Array(len > 2 ? len - 2 : 0);
      for (var key = 2; key < len; key++) {
        args[key - 2] = arguments[key];
      }
      if (format2 === void 0) {
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      }
      if (!condition) {
        printWarning.apply(null, [format2].concat(args));
      }
    };
  }
  warning_1 = warning;
  return warning_1;
}
var safeHTMLElement = {};
var exenv = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
var hasRequiredExenv;
function requireExenv() {
  if (hasRequiredExenv) return exenv.exports;
  hasRequiredExenv = 1;
  (function(module) {
    (function() {
      var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
      var ExecutionEnvironment = {
        canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
      };
      if (module.exports) {
        module.exports = ExecutionEnvironment;
      } else {
        window.ExecutionEnvironment = ExecutionEnvironment;
      }
    })();
  })(exenv);
  return exenv.exports;
}
var hasRequiredSafeHTMLElement;
function requireSafeHTMLElement() {
  if (hasRequiredSafeHTMLElement) return safeHTMLElement;
  hasRequiredSafeHTMLElement = 1;
  Object.defineProperty(safeHTMLElement, "__esModule", {
    value: true
  });
  safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = void 0;
  var _exenv = requireExenv();
  var _exenv2 = _interopRequireDefault(_exenv);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var EE = _exenv2.default;
  var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
  safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
  safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
  safeHTMLElement.canUseDOM = EE.canUseDOM;
  safeHTMLElement.default = SafeHTMLElement;
  return safeHTMLElement;
}
var hasRequiredAriaAppHider;
function requireAriaAppHider() {
  if (hasRequiredAriaAppHider) return ariaAppHider;
  hasRequiredAriaAppHider = 1;
  Object.defineProperty(ariaAppHider, "__esModule", {
    value: true
  });
  ariaAppHider.resetState = resetState;
  ariaAppHider.log = log;
  ariaAppHider.assertNodeList = assertNodeList;
  ariaAppHider.setElement = setElement;
  ariaAppHider.validateElement = validateElement;
  ariaAppHider.hide = hide;
  ariaAppHider.show = show;
  ariaAppHider.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
  var _warning = requireWarning();
  var _warning2 = _interopRequireDefault(_warning);
  var _safeHTMLElement = requireSafeHTMLElement();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var globalElement = null;
  function resetState() {
    if (globalElement) {
      if (globalElement.removeAttribute) {
        globalElement.removeAttribute("aria-hidden");
      } else if (globalElement.length != null) {
        globalElement.forEach(function(element) {
          return element.removeAttribute("aria-hidden");
        });
      } else {
        document.querySelectorAll(globalElement).forEach(function(element) {
          return element.removeAttribute("aria-hidden");
        });
      }
    }
    globalElement = null;
  }
  function log() {
    if (process.env.NODE_ENV !== "production") {
      var check = globalElement || {};
      console.log("ariaAppHider ----------");
      console.log(check.nodeName, check.className, check.id);
      console.log("end ariaAppHider ----------");
    }
  }
  function assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) {
      throw new Error("react-modal: No elements were found for selector " + selector + ".");
    }
  }
  function setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
      var el = document.querySelectorAll(useElement);
      assertNodeList(el, useElement);
      useElement = el;
    }
    globalElement = useElement || globalElement;
    return globalElement;
  }
  function validateElement(appElement) {
    var el = appElement || globalElement;
    if (el) {
      return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
    } else {
      (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
      return [];
    }
  }
  function hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = void 0;
    try {
      for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;
        el.setAttribute("aria-hidden", "true");
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  function show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = void 0;
    try {
      for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var el = _step2.value;
        el.removeAttribute("aria-hidden");
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  function documentNotReadyOrSSRTesting() {
    globalElement = null;
  }
  return ariaAppHider;
}
var classList = {};
var hasRequiredClassList;
function requireClassList() {
  if (hasRequiredClassList) return classList;
  hasRequiredClassList = 1;
  Object.defineProperty(classList, "__esModule", {
    value: true
  });
  classList.resetState = resetState;
  classList.log = log;
  var htmlClassList = {};
  var docBodyClassList = {};
  function removeClass(at, cls) {
    at.classList.remove(cls);
  }
  function resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for (var cls in htmlClassList) {
      removeClass(htmlElement, htmlClassList[cls]);
    }
    var body = document.body;
    for (var _cls in docBodyClassList) {
      removeClass(body, docBodyClassList[_cls]);
    }
    htmlClassList = {};
    docBodyClassList = {};
  }
  function log() {
    if (process.env.NODE_ENV !== "production") {
      var classes = document.getElementsByTagName("html")[0].className;
      var buffer = "Show tracked classes:\n\n";
      buffer += "<html /> (" + classes + "):\n  ";
      for (var x2 in htmlClassList) {
        buffer += "  " + x2 + " " + htmlClassList[x2] + "\n  ";
      }
      classes = document.body.className;
      buffer += "\n\ndoc.body (" + classes + "):\n  ";
      for (var _x in docBodyClassList) {
        buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
      }
      buffer += "\n";
      console.log(buffer);
    }
  }
  var incrementReference = function incrementReference2(poll, className) {
    if (!poll[className]) {
      poll[className] = 0;
    }
    poll[className] += 1;
    return className;
  };
  var decrementReference = function decrementReference2(poll, className) {
    if (poll[className]) {
      poll[className] -= 1;
    }
    return className;
  };
  var trackClass = function trackClass2(classListRef, poll, classes) {
    classes.forEach(function(className) {
      incrementReference(poll, className);
      classListRef.add(className);
    });
  };
  var untrackClass = function untrackClass2(classListRef, poll, classes) {
    classes.forEach(function(className) {
      decrementReference(poll, className);
      poll[className] === 0 && classListRef.remove(className);
    });
  };
  classList.add = function add(element, classString) {
    return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
  };
  classList.remove = function remove(element, classString) {
    return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
  };
  return classList;
}
var portalOpenInstances = {};
var hasRequiredPortalOpenInstances;
function requirePortalOpenInstances() {
  if (hasRequiredPortalOpenInstances) return portalOpenInstances;
  hasRequiredPortalOpenInstances = 1;
  Object.defineProperty(portalOpenInstances, "__esModule", {
    value: true
  });
  portalOpenInstances.log = log;
  portalOpenInstances.resetState = resetState;
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var PortalOpenInstances = function PortalOpenInstances2() {
    var _this = this;
    _classCallCheck(this, PortalOpenInstances2);
    this.register = function(openInstance) {
      if (_this.openInstances.indexOf(openInstance) !== -1) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("React-Modal: Cannot register modal instance that's already open");
        }
        return;
      }
      _this.openInstances.push(openInstance);
      _this.emit("register");
    };
    this.deregister = function(openInstance) {
      var index2 = _this.openInstances.indexOf(openInstance);
      if (index2 === -1) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("React-Modal: Unable to deregister " + openInstance + " as it was never registered");
        }
        return;
      }
      _this.openInstances.splice(index2, 1);
      _this.emit("deregister");
    };
    this.subscribe = function(callback) {
      _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
      _this.subscribers.forEach(function(subscriber) {
        return subscriber(
          eventType,
          // shallow copy to avoid accidental mutation
          _this.openInstances.slice()
        );
      });
    };
    this.openInstances = [];
    this.subscribers = [];
  };
  var portalOpenInstances$1 = new PortalOpenInstances();
  function log() {
    console.log("portalOpenInstances ----------");
    console.log(portalOpenInstances$1.openInstances.length);
    portalOpenInstances$1.openInstances.forEach(function(p2) {
      return console.log(p2);
    });
    console.log("end portalOpenInstances ----------");
  }
  function resetState() {
    portalOpenInstances$1 = new PortalOpenInstances();
  }
  portalOpenInstances.default = portalOpenInstances$1;
  return portalOpenInstances;
}
var bodyTrap = {};
var hasRequiredBodyTrap;
function requireBodyTrap() {
  if (hasRequiredBodyTrap) return bodyTrap;
  hasRequiredBodyTrap = 1;
  Object.defineProperty(bodyTrap, "__esModule", {
    value: true
  });
  bodyTrap.resetState = resetState;
  bodyTrap.log = log;
  var _portalOpenInstances = requirePortalOpenInstances();
  var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var before = void 0, after = void 0, instances = [];
  function resetState() {
    var _arr = [before, after];
    for (var _i = 0; _i < _arr.length; _i++) {
      var item = _arr[_i];
      if (!item) continue;
      item.parentNode && item.parentNode.removeChild(item);
    }
    before = after = null;
    instances = [];
  }
  function log() {
    console.log("bodyTrap ----------");
    console.log(instances.length);
    var _arr2 = [before, after];
    for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
      var item = _arr2[_i2];
      var check = item || {};
      console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
  }
  function focusContent() {
    if (instances.length === 0) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("React-Modal: Open instances > 0 expected");
      }
      return;
    }
    instances[instances.length - 1].focusContent();
  }
  function bodyTrap$1(eventType, openInstances) {
    if (!before && !after) {
      before = document.createElement("div");
      before.setAttribute("data-react-modal-body-trap", "");
      before.style.position = "absolute";
      before.style.opacity = "0";
      before.setAttribute("tabindex", "0");
      before.addEventListener("focus", focusContent);
      after = before.cloneNode();
      after.addEventListener("focus", focusContent);
    }
    instances = openInstances;
    if (instances.length > 0) {
      if (document.body.firstChild !== before) {
        document.body.insertBefore(before, document.body.firstChild);
      }
      if (document.body.lastChild !== after) {
        document.body.appendChild(after);
      }
    } else {
      if (before.parentElement) {
        before.parentElement.removeChild(before);
      }
      if (after.parentElement) {
        after.parentElement.removeChild(after);
      }
    }
  }
  _portalOpenInstances2.default.subscribe(bodyTrap$1);
  return bodyTrap;
}
var hasRequiredModalPortal;
function requireModalPortal() {
  if (hasRequiredModalPortal) return ModalPortal.exports;
  hasRequiredModalPortal = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extends2 = Object.assign || function(target) {
      for (var i2 = 1; i2 < arguments.length; i2++) {
        var source = arguments[i2];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _createClass = /* @__PURE__ */ function() {
      function defineProperties(target, props) {
        for (var i2 = 0; i2 < props.length; i2++) {
          var descriptor = props[i2];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _react = React__default;
    var _propTypes = /* @__PURE__ */ requirePropTypes();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _focusManager = requireFocusManager();
    var focusManager2 = _interopRequireWildcard(_focusManager);
    var _scopeTab = requireScopeTab();
    var _scopeTab2 = _interopRequireDefault(_scopeTab);
    var _ariaAppHider = requireAriaAppHider();
    var ariaAppHider2 = _interopRequireWildcard(_ariaAppHider);
    var _classList = requireClassList();
    var classList2 = _interopRequireWildcard(_classList);
    var _safeHTMLElement = requireSafeHTMLElement();
    var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
    var _portalOpenInstances = requirePortalOpenInstances();
    var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
    requireBodyTrap();
    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};
        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }
        newObj.default = obj;
        return newObj;
      }
    }
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var CLASS_NAMES = {
      overlay: "ReactModal__Overlay",
      content: "ReactModal__Content"
    };
    var isTabKey = function isTabKey2(event) {
      return event.code === "Tab" || event.keyCode === 9;
    };
    var isEscKey = function isEscKey2(event) {
      return event.code === "Escape" || event.keyCode === 27;
    };
    var ariaHiddenInstances = 0;
    var ModalPortal2 = function(_Component) {
      _inherits(ModalPortal3, _Component);
      function ModalPortal3(props) {
        _classCallCheck(this, ModalPortal3);
        var _this = _possibleConstructorReturn(this, (ModalPortal3.__proto__ || Object.getPrototypeOf(ModalPortal3)).call(this, props));
        _this.setOverlayRef = function(overlay) {
          _this.overlay = overlay;
          _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
          _this.content = content;
          _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
          var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName2 = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
          var parentDocument = parentSelector && parentSelector().ownerDocument || document;
          bodyOpenClassName && classList2.remove(parentDocument.body, bodyOpenClassName);
          htmlOpenClassName2 && classList2.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName2);
          if (ariaHideApp && ariaHiddenInstances > 0) {
            ariaHiddenInstances -= 1;
            if (ariaHiddenInstances === 0) {
              ariaAppHider2.show(appElement);
            }
          }
          if (_this.props.shouldFocusAfterRender) {
            if (_this.props.shouldReturnFocusAfterClose) {
              focusManager2.returnFocus(_this.props.preventScroll);
              focusManager2.teardownScopedFocus();
            } else {
              focusManager2.popWithoutFocus();
            }
          }
          if (_this.props.onAfterClose) {
            _this.props.onAfterClose();
          }
          _portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
          _this.beforeOpen();
          if (_this.state.afterOpen && _this.state.beforeClose) {
            clearTimeout(_this.closeTimer);
            _this.setState({ beforeClose: false });
          } else {
            if (_this.props.shouldFocusAfterRender) {
              focusManager2.setupScopedFocus(_this.node);
              focusManager2.markForFocusLater();
            }
            _this.setState({ isOpen: true }, function() {
              _this.openAnimationFrame = requestAnimationFrame(function() {
                _this.setState({ afterOpen: true });
                if (_this.props.isOpen && _this.props.onAfterOpen) {
                  _this.props.onAfterOpen({
                    overlayEl: _this.overlay,
                    contentEl: _this.content
                  });
                }
              });
            });
          }
        };
        _this.close = function() {
          if (_this.props.closeTimeoutMS > 0) {
            _this.closeWithTimeout();
          } else {
            _this.closeWithoutTimeout();
          }
        };
        _this.focusContent = function() {
          return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
        };
        _this.closeWithTimeout = function() {
          var closesAt = Date.now() + _this.props.closeTimeoutMS;
          _this.setState({ beforeClose: true, closesAt }, function() {
            _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
          });
        };
        _this.closeWithoutTimeout = function() {
          _this.setState({
            beforeClose: false,
            isOpen: false,
            afterOpen: false,
            closesAt: null
          }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
          if (isTabKey(event)) {
            (0, _scopeTab2.default)(_this.content, event);
          }
          if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
            event.stopPropagation();
            _this.requestClose(event);
          }
        };
        _this.handleOverlayOnClick = function(event) {
          if (_this.shouldClose === null) {
            _this.shouldClose = true;
          }
          if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
            if (_this.ownerHandlesClose()) {
              _this.requestClose(event);
            } else {
              _this.focusContent();
            }
          }
          _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
          _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
          if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
            event.preventDefault();
          }
        };
        _this.handleContentOnClick = function() {
          _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
          _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
          return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
          return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
          return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
          return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
          var classNames = (typeof additional === "undefined" ? "undefined" : _typeof2(additional)) === "object" ? additional : {
            base: CLASS_NAMES[which],
            afterOpen: CLASS_NAMES[which] + "--after-open",
            beforeClose: CLASS_NAMES[which] + "--before-close"
          };
          var className = classNames.base;
          if (_this.state.afterOpen) {
            className = className + " " + classNames.afterOpen;
          }
          if (_this.state.beforeClose) {
            className = className + " " + classNames.beforeClose;
          }
          return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
          return Object.keys(items).reduce(function(acc, name) {
            acc[prefix + "-" + name] = items[name];
            return acc;
          }, {});
        };
        _this.state = {
          afterOpen: false,
          beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
      }
      _createClass(ModalPortal3, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.props.isOpen) {
            this.open();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
          if (process.env.NODE_ENV !== "production") {
            if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
              console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.');
            }
            if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
              console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.');
            }
          }
          if (this.props.isOpen && !prevProps.isOpen) {
            this.open();
          } else if (!this.props.isOpen && prevProps.isOpen) {
            this.close();
          }
          if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
            this.focusContent();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.state.isOpen) {
            this.afterClose();
          }
          clearTimeout(this.closeTimer);
          cancelAnimationFrame(this.openAnimationFrame);
        }
      }, {
        key: "beforeOpen",
        value: function beforeOpen() {
          var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName2 = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
          var parentDocument = parentSelector && parentSelector().ownerDocument || document;
          bodyOpenClassName && classList2.add(parentDocument.body, bodyOpenClassName);
          htmlOpenClassName2 && classList2.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName2);
          if (ariaHideApp) {
            ariaHiddenInstances += 1;
            ariaAppHider2.hide(appElement);
          }
          _portalOpenInstances2.default.register(this);
        }
        // Don't steal focus from inner elements
      }, {
        key: "render",
        value: function render() {
          var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName2 = _props2.overlayClassName, defaultStyles2 = _props2.defaultStyles, children = _props2.children;
          var contentStyles = className ? {} : defaultStyles2.content;
          var overlayStyles = overlayClassName2 ? {} : defaultStyles2.overlay;
          if (this.shouldBeClosed()) {
            return null;
          }
          var overlayProps = {
            ref: this.setOverlayRef,
            className: this.buildClassName("overlay", overlayClassName2),
            style: _extends2({}, overlayStyles, this.props.style.overlay),
            onClick: this.handleOverlayOnClick,
            onMouseDown: this.handleOverlayOnMouseDown
          };
          var contentProps = _extends2({
            id,
            ref: this.setContentRef,
            style: _extends2({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", _extends2({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          });
          var contentElement = this.props.contentElement(contentProps, children);
          return this.props.overlayElement(overlayProps, contentElement);
        }
      }]);
      return ModalPortal3;
    }(_react.Component);
    ModalPortal2.defaultProps = {
      style: {
        overlay: {},
        content: {}
      },
      defaultStyles: {}
    };
    ModalPortal2.propTypes = {
      isOpen: _propTypes2.default.bool.isRequired,
      defaultStyles: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
      }),
      style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
      }),
      className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
      overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
      parentSelector: _propTypes2.default.func,
      bodyOpenClassName: _propTypes2.default.string,
      htmlOpenClassName: _propTypes2.default.string,
      ariaHideApp: _propTypes2.default.bool,
      appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
      onAfterOpen: _propTypes2.default.func,
      onAfterClose: _propTypes2.default.func,
      onRequestClose: _propTypes2.default.func,
      closeTimeoutMS: _propTypes2.default.number,
      shouldFocusAfterRender: _propTypes2.default.bool,
      shouldCloseOnOverlayClick: _propTypes2.default.bool,
      shouldReturnFocusAfterClose: _propTypes2.default.bool,
      preventScroll: _propTypes2.default.bool,
      role: _propTypes2.default.string,
      contentLabel: _propTypes2.default.string,
      aria: _propTypes2.default.object,
      data: _propTypes2.default.object,
      children: _propTypes2.default.node,
      shouldCloseOnEsc: _propTypes2.default.bool,
      overlayRef: _propTypes2.default.func,
      contentRef: _propTypes2.default.func,
      id: _propTypes2.default.string,
      overlayElement: _propTypes2.default.func,
      contentElement: _propTypes2.default.func,
      testId: _propTypes2.default.string
    };
    exports.default = ModalPortal2;
    module.exports = exports["default"];
  })(ModalPortal, ModalPortal.exports);
  return ModalPortal.exports;
}
function componentWillMount() {
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== void 0) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== void 0 ? state : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
  var prototype = Component.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") {
    return Component;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks"
    );
  }
  if (typeof Component.getDerivedStateFromProps === "function") {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype.componentDidUpdate !== "function") {
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component;
}
const reactLifecyclesCompat_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill
}, Symbol.toStringTag, { value: "Module" }));
const require$$6 = /* @__PURE__ */ getAugmentedNamespace(reactLifecyclesCompat_es);
var hasRequiredModal;
function requireModal() {
  if (hasRequiredModal) return Modal$1;
  hasRequiredModal = 1;
  Object.defineProperty(Modal$1, "__esModule", {
    value: true
  });
  Modal$1.bodyOpenClassName = Modal$1.portalClassName = void 0;
  var _extends2 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i2 = 0; i2 < props.length; i2++) {
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  var _reactDom = ReactDOM__default;
  var _reactDom2 = _interopRequireDefault(_reactDom);
  var _propTypes = /* @__PURE__ */ requirePropTypes();
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _ModalPortal = requireModalPortal();
  var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
  var _ariaAppHider = requireAriaAppHider();
  var ariaAppHider2 = _interopRequireWildcard(_ariaAppHider);
  var _safeHTMLElement = requireSafeHTMLElement();
  var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
  var _reactLifecyclesCompat = require$$6;
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var portalClassName = Modal$1.portalClassName = "ReactModalPortal";
  var bodyOpenClassName = Modal$1.bodyOpenClassName = "ReactModal__Body--open";
  var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== void 0;
  var createHTMLElement = function createHTMLElement2(name) {
    return document.createElement(name);
  };
  var getCreatePortal = function getCreatePortal2() {
    return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
  };
  function getParentElement(parentSelector) {
    return parentSelector();
  }
  var Modal2 = function(_Component) {
    _inherits(Modal3, _Component);
    function Modal3() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck(this, Modal3);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal3.__proto__ || Object.getPrototypeOf(Modal3)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function() {
        !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
        var parent = getParentElement(_this.props.parentSelector);
        if (parent && parent.contains(_this.node)) {
          parent.removeChild(_this.node);
        } else {
          console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }
      }, _this.portalRef = function(ref) {
        _this.portal = ref;
      }, _this.renderPortal = function(props) {
        var createPortal2 = getCreatePortal();
        var portal = createPortal2(_this, _react2.default.createElement(_ModalPortal2.default, _extends2({ defaultStyles: Modal3.defaultStyles }, props)), _this.node);
        _this.portalRef(portal);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Modal3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!_safeHTMLElement.canUseDOM) return;
        if (!isReact16) {
          this.node = createHTMLElement("div");
        }
        this.node.className = this.props.portalClassName;
        var parent = getParentElement(this.props.parentSelector);
        parent.appendChild(this.node);
        !isReact16 && this.renderPortal(this.props);
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function getSnapshotBeforeUpdate(prevProps) {
        var prevParent = getParentElement(prevProps.parentSelector);
        var nextParent = getParentElement(this.props.parentSelector);
        return { prevParent, nextParent };
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, _2, snapshot) {
        if (!_safeHTMLElement.canUseDOM) return;
        var _props = this.props, isOpen = _props.isOpen, portalClassName2 = _props.portalClassName;
        if (prevProps.portalClassName !== portalClassName2) {
          this.node.className = portalClassName2;
        }
        var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
        if (nextParent !== prevParent) {
          prevParent.removeChild(this.node);
          nextParent.appendChild(this.node);
        }
        if (!prevProps.isOpen && !isOpen) return;
        !isReact16 && this.renderPortal(this.props);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
        var state = this.portal.state;
        var now = Date.now();
        var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
        if (closesAt) {
          if (!state.beforeClose) {
            this.portal.closeWithTimeout();
          }
          setTimeout(this.removePortal, closesAt - now);
        } else {
          this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (!_safeHTMLElement.canUseDOM || !isReact16) {
          return null;
        }
        if (!this.node && isReact16) {
          this.node = createHTMLElement("div");
        }
        var createPortal2 = getCreatePortal();
        return createPortal2(_react2.default.createElement(_ModalPortal2.default, _extends2({
          ref: this.portalRef,
          defaultStyles: Modal3.defaultStyles
        }, this.props)), this.node);
      }
    }], [{
      key: "setAppElement",
      value: function setAppElement(element) {
        ariaAppHider2.setElement(element);
      }
      /* eslint-disable react/no-unused-prop-types */
      /* eslint-enable react/no-unused-prop-types */
    }]);
    return Modal3;
  }(_react.Component);
  Modal2.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    style: _propTypes2.default.shape({
      content: _propTypes2.default.object,
      overlay: _propTypes2.default.object
    }),
    portalClassName: _propTypes2.default.string,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      base: _propTypes2.default.string.isRequired,
      afterOpen: _propTypes2.default.string.isRequired,
      beforeClose: _propTypes2.default.string.isRequired
    })]),
    overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      base: _propTypes2.default.string.isRequired,
      afterOpen: _propTypes2.default.string.isRequired,
      beforeClose: _propTypes2.default.string.isRequired
    })]),
    appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
    onAfterOpen: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    ariaHideApp: _propTypes2.default.bool,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    parentSelector: _propTypes2.default.func,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func
  };
  Modal2.defaultProps = {
    isOpen: false,
    portalClassName,
    bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
      return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
      return _react2.default.createElement(
        "div",
        props,
        contentEl
      );
    },
    contentElement: function contentElement(props, children) {
      return _react2.default.createElement(
        "div",
        props,
        children
      );
    }
  };
  Modal2.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  };
  (0, _reactLifecyclesCompat.polyfill)(Modal2);
  if (process.env.NODE_ENV !== "production") {
    Modal2.setCreateHTMLElement = function(fn) {
      return createHTMLElement = fn;
    };
  }
  Modal$1.default = Modal2;
  return Modal$1;
}
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib.exports;
  hasRequiredLib = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _Modal2 = requireModal();
    var _Modal22 = _interopRequireDefault(_Modal2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports.default = _Modal22.default;
    module.exports = exports["default"];
  })(lib, lib.exports);
  return lib.exports;
}
var libExports = requireLib();
const ReactModal = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
const overlayBeforeCloseClassName = clsx("ui:opacity-0");
const overlayBaseClassName = clsx(
  "ui:fixed ui:inset-0 ui:z-30 ui:bg-black/80",
  "ui:flex ui:overflow-y-auto",
  "ui:px-4 ui:py-5"
);
const containerBeforeCloseClassName = clsx("ui:translate-y-5 ui:opacity-0");
const containerAfterOpenClassName = clsx("ui:translate-y-0! ui:opacity-100!");
const containerBaseClassName = clsx(
  "ui:m-auto ui:w-full ui:max-w-[726px]",
  "ui:inline-block ui:rounded-lg ui:border ui:border-primary ui:bg-card ui:px-6 ui:py-8 ui:text-primary",
  "ui:shadow-gray-xs ui:outline-hidden ui:transition ui:dark:shadow-none",
  containerBeforeCloseClassName
);
const htmlOpenClassName = clsx("ui:overflow-hidden");
const _Modal = ({
  title,
  subtitle,
  isOpen,
  shouldDisableClose,
  children,
  onClose,
  onAfterClose,
  className,
  headerClassName: headerClassName2
}) => {
  return /* @__PURE__ */ jsxs(
    ReactModal,
    {
      isOpen,
      className: {
        base: clsx(containerBaseClassName, className),
        afterOpen: isOpen ? containerAfterOpenClassName : "",
        beforeClose: containerBeforeCloseClassName
      },
      overlayClassName: {
        base: overlayBaseClassName,
        afterOpen: "",
        beforeClose: overlayBeforeCloseClassName
      },
      htmlOpenClassName,
      shouldCloseOnEsc: !shouldDisableClose,
      shouldCloseOnOverlayClick: !shouldDisableClose,
      onAfterClose,
      onRequestClose: onClose,
      closeTimeoutMS: 150,
      children: [
        title !== void 0 && /* @__PURE__ */ jsxs(
          "div",
          {
            className: clsx(
              "ui:-mt-1 ui:mb-6 ui:flex ui:items-center ui:justify-between",
              headerClassName2
            ),
            children: [
              /* @__PURE__ */ jsx("span", { className: "ui:text-heading-h2 ui:text-primary", children: title }),
              /* @__PURE__ */ jsx(IconButton, { disabled: shouldDisableClose, onClick: onClose, children: /* @__PURE__ */ jsx(XIcon, { className: "ui:text-icon-secondary" }) })
            ]
          }
        ),
        subtitle && /* @__PURE__ */ jsx("div", { className: "ui:-mt-4 ui:mb-4 ui:text-paragraph-200-regular ui:text-secondary", children: subtitle }),
        children
      ]
    }
  );
};
const Modal = Object.assign(_Modal, {
  setAppElement: ReactModal.setAppElement.bind(ReactModal)
});
const buttonClassName = clsx(
  "ui:flex ui:h-10 ui:items-center ui:gap-1.5 ui:p-3 ui:text-start",
  "ui:rounded-full ui:outline-hidden ui:transition",
  "ui:border ui:border-primary ui:bg-primary ui:text-label-200 ui:text-primary",
  "ui:hover:bg-subtle",
  "ui:active:bg-secondary",
  "ui:focus-visible:shadow-focus",
  "ui:disabled:border-inset ui:disabled:bg-subtle ui:disabled:text-disabled"
);
const ReferralButton = ({
  className,
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      className: clsx(buttonClassName, className),
      ...props,
      children
    }
  );
};
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? React__default.useLayoutEffect : () => {
};
function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
  const ref = useRef(null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    ref.current = fn;
  }, [
    fn
  ]);
  return useCallback((...args) => {
    const f2 = ref.current;
    return f2 === null || f2 === void 0 ? void 0 : f2(...args);
  }, []);
}
const $431fbd86ca7dc216$export$b204af158042fbac = (el) => {
  var _el_ownerDocument;
  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $431fbd86ca7dc216$export$f21a1ffae260145a = (el) => {
  if (el && "window" in el && el.window === el) return el;
  const doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
  return doc.defaultView || window;
};
function $431fbd86ca7dc216$var$isNode(value) {
  return value !== null && typeof value === "object" && "nodeType" in value && typeof value.nodeType === "number";
}
function $431fbd86ca7dc216$export$af51f0f06c0f328a(node) {
  return $431fbd86ca7dc216$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in node;
}
let $f4e2df6bd15f8569$var$_shadowDOM = false;
function $f4e2df6bd15f8569$export$98658e8c59125e6a() {
  return $f4e2df6bd15f8569$var$_shadowDOM;
}
function $d4ee10de306f2510$export$4282f70798064fe0(node, otherNode) {
  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return otherNode && node ? node.contains(otherNode) : false;
  if (!node || !otherNode) return false;
  let currentNode = otherNode;
  while (currentNode !== null) {
    if (currentNode === node) return true;
    if (currentNode.tagName === "SLOT" && currentNode.assignedSlot)
      currentNode = currentNode.assignedSlot.parentNode;
    else if ($431fbd86ca7dc216$export$af51f0f06c0f328a(currentNode))
      currentNode = currentNode.host;
    else currentNode = currentNode.parentNode;
  }
  return false;
}
const $d4ee10de306f2510$export$cd4e5573fbe2b576 = (doc = document) => {
  var _activeElement_shadowRoot;
  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return doc.activeElement;
  let activeElement = doc.activeElement;
  while (activeElement && "shadowRoot" in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement)) activeElement = activeElement.shadowRoot.activeElement;
  return activeElement;
};
function $d4ee10de306f2510$export$e58f029f0fbfdb29(event) {
  if ($f4e2df6bd15f8569$export$98658e8c59125e6a() && event.target.shadowRoot) {
    if (event.composedPath) return event.composedPath()[0];
  }
  return event.target;
}
function $c87311424ea30a05$var$testUserAgent(re) {
  var _window_navigator_userAgentData;
  if (typeof window === "undefined" || window.navigator == null) return false;
  return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand) => re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
  var _window_navigator_userAgentData;
  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$var$cached(fn) {
  if (process.env.NODE_ENV === "test") return fn;
  let res = null;
  return () => {
    if (res == null) res = fn();
    return res;
  };
}
const $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
});
$c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
});
$c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
});
const $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
});
$c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
});
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  let globalListeners = useRef(/* @__PURE__ */ new Map());
  let addGlobalListener = useCallback((eventTarget, type, listener, options) => {
    let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args) => {
      globalListeners.current.delete(listener);
      listener(...args);
    } : listener;
    globalListeners.current.set(listener, {
      type,
      eventTarget,
      fn,
      options
    });
    eventTarget.addEventListener(type, fn, options);
  }, []);
  let removeGlobalListener = useCallback((eventTarget, type, listener, options) => {
    var _globalListeners_current_get;
    let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current.delete(listener);
  }, []);
  let removeAllGlobalListeners = useCallback(() => {
    globalListeners.current.forEach((value, key) => {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [
    removeGlobalListener
  ]);
  useEffect(() => {
    return removeAllGlobalListeners;
  }, [
    removeAllGlobalListeners
  ]);
  return {
    addGlobalListener,
    removeGlobalListener,
    removeAllGlobalListeners
  };
}
function $6a7db85432448f7f$export$60278871457622de(event) {
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}
function $8a9cb279dc87e130$export$525bc4921d56d4a(nativeEvent) {
  let event = nativeEvent;
  event.nativeEvent = nativeEvent;
  event.isDefaultPrevented = () => event.defaultPrevented;
  event.isPropagationStopped = () => event.cancelBubble;
  event.persist = () => {
  };
  return event;
}
function $8a9cb279dc87e130$export$c2b7abe5d61ec696(event, target) {
  Object.defineProperty(event, "target", {
    value: target
  });
  Object.defineProperty(event, "currentTarget", {
    value: target
  });
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  let stateRef = useRef({
    isFocused: false,
    observer: null
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const state = stateRef.current;
    return () => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  let dispatchBlur = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e2) => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e2);
  });
  return useCallback((e2) => {
    if (e2.target instanceof HTMLButtonElement || e2.target instanceof HTMLInputElement || e2.target instanceof HTMLTextAreaElement || e2.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      let target = e2.target;
      let onBlurHandler = (e3) => {
        stateRef.current.isFocused = false;
        if (target.disabled) {
          let event = $8a9cb279dc87e130$export$525bc4921d56d4a(e3);
          dispatchBlur(event);
        }
        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };
      target.addEventListener("focusout", onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(() => {
        if (stateRef.current.isFocused && target.disabled) {
          var _stateRef_current_observer;
          (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 ? void 0 : _stateRef_current_observer.disconnect();
          let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
          target.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: relatedTargetEl
          }));
          target.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true,
            relatedTarget: relatedTargetEl
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    dispatchBlur
  ]);
}
let $8a9cb279dc87e130$export$fda7da73ab5d4c48 = false;
let $507fabe10e71c6fb$var$currentModality = null;
let $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set();
let $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */ new Map();
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: true,
  Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e2) {
  for (let handler of $507fabe10e71c6fb$var$changeHandlers) handler(modality, e2);
}
function $507fabe10e71c6fb$var$isValidKey(e2) {
  return !(e2.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && e2.altKey || e2.ctrlKey || e2.key === "Control" || e2.key === "Shift" || e2.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e2) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
  if ($507fabe10e71c6fb$var$isValidKey(e2)) {
    $507fabe10e71c6fb$var$currentModality = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e2);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e2) {
  $507fabe10e71c6fb$var$currentModality = "pointer";
  if (e2.type === "mousedown" || e2.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e2);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent(e2) {
  if ($6a7db85432448f7f$export$60278871457622de(e2)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = "virtual";
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e2) {
  if (e2.target === window || e2.target === document || $8a9cb279dc87e130$export$fda7da73ab5d4c48 || !e2.isTrusted) return;
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e2);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
  if (typeof window === "undefined" || typeof document === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(element))) return;
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let focus = windowObject.HTMLElement.prototype.focus;
  windowObject.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };
  documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else if (process.env.NODE_ENV === "test") {
    documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  windowObject.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
  }, {
    once: true
  });
  $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
    focus
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener) => {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
  if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
  windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
  documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else if (process.env.NODE_ENV === "test") {
    documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(element) {
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let loadListener;
  if (documentObject.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
  else {
    loadListener = () => {
      $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    };
    documentObject.addEventListener("DOMContentLoaded", loadListener);
  }
  return () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
if (typeof document !== "undefined") $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
const $507fabe10e71c6fb$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e2) {
  let document1 = $431fbd86ca7dc216$export$b204af158042fbac(e2 === null || e2 === void 0 ? void 0 : e2.target);
  const IHTMLInputElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e2 === null || e2 === void 0 ? void 0 : e2.target).HTMLInputElement : HTMLInputElement;
  const IHTMLTextAreaElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e2 === null || e2 === void 0 ? void 0 : e2.target).HTMLTextAreaElement : HTMLTextAreaElement;
  const IHTMLElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e2 === null || e2 === void 0 ? void 0 : e2.target).HTMLElement : HTMLElement;
  const IKeyboardEvent = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e2 === null || e2 === void 0 ? void 0 : e2.target).KeyboardEvent : KeyboardEvent;
  isTextInput = isTextInput || document1.activeElement instanceof IHTMLInputElement && !$507fabe10e71c6fb$var$nonTextInputTypes.has(document1.activeElement.type) || document1.activeElement instanceof IHTMLTextAreaElement || document1.activeElement instanceof IHTMLElement && document1.activeElement.isContentEditable;
  return !(isTextInput && modality === "keyboard" && e2 instanceof IKeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e2.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents();
  useEffect(() => {
    let handler = (modality, e2) => {
      if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e2)) return;
      fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
    };
    $507fabe10e71c6fb$var$changeHandlers.add(handler);
    return () => {
      $507fabe10e71c6fb$var$changeHandlers.delete(handler);
    };
  }, deps);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
  let { isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange } = props;
  const onBlur = useCallback((e2) => {
    if (e2.target === e2.currentTarget) {
      if (onBlurProp) onBlurProp(e2);
      if (onFocusChange) onFocusChange(false);
      return true;
    }
  }, [
    onBlurProp,
    onFocusChange
  ]);
  const onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  const onFocus = useCallback((e2) => {
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(e2.target);
    const activeElement = ownerDocument ? $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument) : $d4ee10de306f2510$export$cd4e5573fbe2b576();
    if (e2.target === e2.currentTarget && activeElement === $d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)) {
      if (onFocusProp) onFocusProp(e2);
      if (onFocusChange) onFocusChange(true);
      onSyntheticFocus(e2);
    }
  }, [
    onFocusChange,
    onFocusProp,
    onSyntheticFocus
  ]);
  return {
    focusProps: {
      onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : void 0,
      onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : void 0
    }
  };
}
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  let { isDisabled, onBlurWithin, onFocusWithin, onFocusWithinChange } = props;
  let state = useRef({
    isFocusWithin: false
  });
  let { addGlobalListener, removeAllGlobalListeners } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let onBlur = useCallback((e2) => {
    if (!e2.currentTarget.contains(e2.target)) return;
    if (state.current.isFocusWithin && !e2.currentTarget.contains(e2.relatedTarget)) {
      state.current.isFocusWithin = false;
      removeAllGlobalListeners();
      if (onBlurWithin) onBlurWithin(e2);
      if (onFocusWithinChange) onFocusWithinChange(false);
    }
  }, [
    onBlurWithin,
    onFocusWithinChange,
    state,
    removeAllGlobalListeners
  ]);
  let onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  let onFocus = useCallback((e2) => {
    if (!e2.currentTarget.contains(e2.target)) return;
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(e2.target);
    const activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
    if (!state.current.isFocusWithin && activeElement === $d4ee10de306f2510$export$e58f029f0fbfdb29(e2.nativeEvent)) {
      if (onFocusWithin) onFocusWithin(e2);
      if (onFocusWithinChange) onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e2);
      let currentTarget = e2.currentTarget;
      addGlobalListener(ownerDocument, "focus", (e3) => {
        if (state.current.isFocusWithin && !$d4ee10de306f2510$export$4282f70798064fe0(currentTarget, e3.target)) {
          let nativeEvent = new ownerDocument.defaultView.FocusEvent("blur", {
            relatedTarget: e3.target
          });
          $8a9cb279dc87e130$export$c2b7abe5d61ec696(nativeEvent, currentTarget);
          let event = $8a9cb279dc87e130$export$525bc4921d56d4a(nativeEvent);
          onBlur(event);
        }
      }, {
        capture: true
      });
    }
  }, [
    onFocusWithin,
    onFocusWithinChange,
    onSyntheticFocus,
    addGlobalListener,
    onBlur
  ]);
  if (isDisabled) return {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  };
  return {
    focusWithinProps: {
      onFocus,
      onBlur
    }
  };
}
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
  setTimeout(() => {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e2) {
  if (e2.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (typeof document === "undefined") return;
  if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
  else if (process.env.NODE_ENV === "test") document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  $6179b936705e76d3$var$hoverCount++;
  return () => {
    $6179b936705e76d3$var$hoverCount--;
    if ($6179b936705e76d3$var$hoverCount > 0) return;
    if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
    else if (process.env.NODE_ENV === "test") document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
  let { onHoverStart, onHoverChange, onHoverEnd, isDisabled } = props;
  let [isHovered, setHovered] = useState(false);
  let state = useRef({
    isHovered: false,
    ignoreEmulatedMouseEvents: false,
    pointerType: "",
    target: null
  }).current;
  useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  let { addGlobalListener, removeAllGlobalListeners } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let { hoverProps, triggerHoverEnd } = useMemo(() => {
    let triggerHoverStart = (event, pointerType) => {
      state.pointerType = pointerType;
      if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
      state.isHovered = true;
      let target = event.currentTarget;
      state.target = target;
      addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(event.target), "pointerover", (e2) => {
        if (state.isHovered && state.target && !$d4ee10de306f2510$export$4282f70798064fe0(state.target, e2.target)) triggerHoverEnd2(e2, e2.pointerType);
      }, {
        capture: true
      });
      if (onHoverStart) onHoverStart({
        type: "hoverstart",
        target,
        pointerType
      });
      if (onHoverChange) onHoverChange(true);
      setHovered(true);
    };
    let triggerHoverEnd2 = (event, pointerType) => {
      let target = state.target;
      state.pointerType = "";
      state.target = null;
      if (pointerType === "touch" || !state.isHovered || !target) return;
      state.isHovered = false;
      removeAllGlobalListeners();
      if (onHoverEnd) onHoverEnd({
        type: "hoverend",
        target,
        pointerType
      });
      if (onHoverChange) onHoverChange(false);
      setHovered(false);
    };
    let hoverProps2 = {};
    if (typeof PointerEvent !== "undefined") {
      hoverProps2.onPointerEnter = (e2) => {
        if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e2.pointerType === "mouse") return;
        triggerHoverStart(e2, e2.pointerType);
      };
      hoverProps2.onPointerLeave = (e2) => {
        if (!isDisabled && e2.currentTarget.contains(e2.target)) triggerHoverEnd2(e2, e2.pointerType);
      };
    } else if (process.env.NODE_ENV === "test") {
      hoverProps2.onTouchStart = () => {
        state.ignoreEmulatedMouseEvents = true;
      };
      hoverProps2.onMouseEnter = (e2) => {
        if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e2, "mouse");
        state.ignoreEmulatedMouseEvents = false;
      };
      hoverProps2.onMouseLeave = (e2) => {
        if (!isDisabled && e2.currentTarget.contains(e2.target)) triggerHoverEnd2(e2, "mouse");
      };
    }
    return {
      hoverProps: hoverProps2,
      triggerHoverEnd: triggerHoverEnd2
    };
  }, [
    onHoverStart,
    onHoverChange,
    onHoverEnd,
    isDisabled,
    state,
    addGlobalListener,
    removeAllGlobalListeners
  ]);
  useEffect(() => {
    if (isDisabled) triggerHoverEnd({
      currentTarget: state.target
    }, state.pointerType);
  }, [
    isDisabled
  ]);
  return {
    hoverProps,
    isHovered
  };
}
function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
  let { autoFocus = false, isTextInput, within } = props;
  let state = useRef({
    isFocused: false,
    isFocusVisible: autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  });
  let [isFocused, setFocused] = useState(false);
  let [isFocusVisibleState, setFocusVisible] = useState(() => state.current.isFocused && state.current.isFocusVisible);
  let updateState = useCallback(() => setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
  let onFocusChange = useCallback((isFocused2) => {
    state.current.isFocused = isFocused2;
    setFocused(isFocused2);
    updateState();
  }, [
    updateState
  ]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3((isFocusVisible) => {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput
  });
  let { focusProps } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: within,
    onFocusChange
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !within,
    onFocusWithinChange: onFocusChange
  });
  return {
    isFocused,
    isFocusVisible: isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
var i$5 = Object.defineProperty;
var d$3 = (t2, e2, n2) => e2 in t2 ? i$5(t2, e2, { enumerable: true, configurable: true, writable: true, value: n2 }) : t2[e2] = n2;
var r$4 = (t2, e2, n2) => (d$3(t2, typeof e2 != "symbol" ? e2 + "" : e2, n2), n2);
let o$9 = class o {
  constructor() {
    r$4(this, "current", this.detect());
    r$4(this, "handoffState", "pending");
    r$4(this, "currentId", 0);
  }
  set(e2) {
    this.current !== e2 && (this.handoffState = "pending", this.currentId = 0, this.current = e2);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
};
let s$6 = new o$9();
function o$8(n2) {
  var e2, r2;
  return s$6.isServer ? null : n2 ? "ownerDocument" in n2 ? n2.ownerDocument : "current" in n2 ? (r2 = (e2 = n2.current) == null ? void 0 : e2.ownerDocument) != null ? r2 : document : null : document;
}
function t$5(e2) {
  typeof queueMicrotask == "function" ? queueMicrotask(e2) : Promise.resolve().then(e2).catch((o4) => setTimeout(() => {
    throw o4;
  }));
}
function o$7() {
  let s2 = [], r2 = { addEventListener(e2, t2, n2, i2) {
    return e2.addEventListener(t2, n2, i2), r2.add(() => e2.removeEventListener(t2, n2, i2));
  }, requestAnimationFrame(...e2) {
    let t2 = requestAnimationFrame(...e2);
    return r2.add(() => cancelAnimationFrame(t2));
  }, nextFrame(...e2) {
    return r2.requestAnimationFrame(() => r2.requestAnimationFrame(...e2));
  }, setTimeout(...e2) {
    let t2 = setTimeout(...e2);
    return r2.add(() => clearTimeout(t2));
  }, microTask(...e2) {
    let t2 = { current: true };
    return t$5(() => {
      t2.current && e2[0]();
    }), r2.add(() => {
      t2.current = false;
    });
  }, style(e2, t2, n2) {
    let i2 = e2.style.getPropertyValue(t2);
    return Object.assign(e2.style, { [t2]: n2 }), this.add(() => {
      Object.assign(e2.style, { [t2]: i2 });
    });
  }, group(e2) {
    let t2 = o$7();
    return e2(t2), this.add(() => t2.dispose());
  }, add(e2) {
    return s2.includes(e2) || s2.push(e2), () => {
      let t2 = s2.indexOf(e2);
      if (t2 >= 0) for (let n2 of s2.splice(t2, 1)) n2();
    };
  }, dispose() {
    for (let e2 of s2.splice(0)) e2();
  } };
  return r2;
}
function p$4() {
  let [e2] = useState(o$7);
  return useEffect(() => () => e2.dispose(), [e2]), e2;
}
let n$6 = (e2, t2) => {
  s$6.isServer ? useEffect(e2, t2) : useLayoutEffect(e2, t2);
};
function s$5(e2) {
  let r2 = useRef(e2);
  return n$6(() => {
    r2.current = e2;
  }, [e2]), r2;
}
let o$6 = function(t2) {
  let e2 = s$5(t2);
  return React__default.useCallback((...r2) => e2.current(...r2), [e2]);
};
function E$4(e2) {
  let t2 = e2.width / 2, n2 = e2.height / 2;
  return { top: e2.clientY - n2, right: e2.clientX + t2, bottom: e2.clientY + n2, left: e2.clientX - t2 };
}
function P$2(e2, t2) {
  return !(!e2 || !t2 || e2.right < t2.left || e2.left > t2.right || e2.bottom < t2.top || e2.top > t2.bottom);
}
function w$2({ disabled: e2 = false } = {}) {
  let t2 = useRef(null), [n2, l2] = useState(false), r2 = p$4(), o4 = o$6(() => {
    t2.current = null, l2(false), r2.dispose();
  }), f2 = o$6((s2) => {
    if (r2.dispose(), t2.current === null) {
      t2.current = s2.currentTarget, l2(true);
      {
        let i2 = o$8(s2.currentTarget);
        r2.addEventListener(i2, "pointerup", o4, false), r2.addEventListener(i2, "pointermove", (c2) => {
          if (t2.current) {
            let p2 = E$4(c2);
            l2(P$2(p2, t2.current.getBoundingClientRect()));
          }
        }, false), r2.addEventListener(i2, "pointercancel", o4, false);
      }
    }
  });
  return { pressed: n2, pressProps: e2 ? {} : { onPointerDown: f2, onPointerUp: o4, onClick: o4 } };
}
let e$4 = createContext(void 0);
function a$a() {
  return useContext(e$4);
}
function l$6({ value: t2, children: o4 }) {
  return React__default.createElement(e$4.Provider, { value: t2 }, o4);
}
function t$4(...r2) {
  return Array.from(new Set(r2.flatMap((n2) => typeof n2 == "string" ? n2.split(" ") : []))).filter(Boolean).join(" ");
}
function u$a(r2, n2, ...a3) {
  if (r2 in n2) {
    let e2 = n2[r2];
    return typeof e2 == "function" ? e2(...a3) : e2;
  }
  let t2 = new Error(`Tried to handle "${r2}" but there is no handler defined. Only defined handlers are: ${Object.keys(n2).map((e2) => `"${e2}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(t2, u$a), t2;
}
var O$2 = ((a3) => (a3[a3.None = 0] = "None", a3[a3.RenderStrategy = 1] = "RenderStrategy", a3[a3.Static = 2] = "Static", a3))(O$2 || {}), A$1 = ((e2) => (e2[e2.Unmount = 0] = "Unmount", e2[e2.Hidden = 1] = "Hidden", e2))(A$1 || {});
function L$3() {
  let n2 = U$2();
  return useCallback((r2) => C$6({ mergeRefs: n2, ...r2 }), [n2]);
}
function C$6({ ourProps: n2, theirProps: r2, slot: e2, defaultTag: a3, features: s2, visible: t2 = true, name: l2, mergeRefs: i2 }) {
  i2 = i2 != null ? i2 : $$1;
  let o4 = P$1(r2, n2);
  if (t2) return F$2(o4, e2, a3, l2, i2);
  let y2 = s2 != null ? s2 : 0;
  if (y2 & 2) {
    let { static: f2 = false, ...u2 } = o4;
    if (f2) return F$2(u2, e2, a3, l2, i2);
  }
  if (y2 & 1) {
    let { unmount: f2 = true, ...u2 } = o4;
    return u$a(f2 ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return F$2({ ...u2, hidden: true, style: { display: "none" } }, e2, a3, l2, i2);
    } });
  }
  return F$2(o4, e2, a3, l2, i2);
}
function F$2(n2, r2 = {}, e2, a3, s2) {
  let { as: t2 = e2, children: l2, refName: i2 = "ref", ...o4 } = h$3(n2, ["unmount", "static"]), y2 = n2.ref !== void 0 ? { [i2]: n2.ref } : {}, f2 = typeof l2 == "function" ? l2(r2) : l2;
  "className" in o4 && o4.className && typeof o4.className == "function" && (o4.className = o4.className(r2)), o4["aria-labelledby"] && o4["aria-labelledby"] === o4.id && (o4["aria-labelledby"] = void 0);
  let u2 = {};
  if (r2) {
    let d2 = false, p2 = [];
    for (let [c2, T2] of Object.entries(r2)) typeof T2 == "boolean" && (d2 = true), T2 === true && p2.push(c2.replace(/([A-Z])/g, (g2) => `-${g2.toLowerCase()}`));
    if (d2) {
      u2["data-headlessui-state"] = p2.join(" ");
      for (let c2 of p2) u2[`data-${c2}`] = "";
    }
  }
  if (t2 === Fragment$1 && (Object.keys(m$5(o4)).length > 0 || Object.keys(m$5(u2)).length > 0)) if (!isValidElement(f2) || Array.isArray(f2) && f2.length > 1) {
    if (Object.keys(m$5(o4)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${a3} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(m$5(o4)).concat(Object.keys(m$5(u2))).map((d2) => `  - ${d2}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((d2) => `  - ${d2}`).join(`
`)].join(`
`));
  } else {
    let d2 = f2.props, p2 = d2 == null ? void 0 : d2.className, c2 = typeof p2 == "function" ? (...R2) => t$4(p2(...R2), o4.className) : t$4(p2, o4.className), T2 = c2 ? { className: c2 } : {}, g2 = P$1(f2.props, m$5(h$3(o4, ["ref"])));
    for (let R2 in u2) R2 in g2 && delete u2[R2];
    return cloneElement(f2, Object.assign({}, g2, u2, y2, { ref: s2(H$4(f2), y2.ref) }, T2));
  }
  return createElement$1(t2, Object.assign({}, h$3(o4, ["ref"]), t2 !== Fragment$1 && y2, t2 !== Fragment$1 && u2), f2);
}
function U$2() {
  let n2 = useRef([]), r2 = useCallback((e2) => {
    for (let a3 of n2.current) a3 != null && (typeof a3 == "function" ? a3(e2) : a3.current = e2);
  }, []);
  return (...e2) => {
    if (!e2.every((a3) => a3 == null)) return n2.current = e2, r2;
  };
}
function $$1(...n2) {
  return n2.every((r2) => r2 == null) ? void 0 : (r2) => {
    for (let e2 of n2) e2 != null && (typeof e2 == "function" ? e2(r2) : e2.current = r2);
  };
}
function P$1(...n2) {
  if (n2.length === 0) return {};
  if (n2.length === 1) return n2[0];
  let r2 = {}, e2 = {};
  for (let s2 of n2) for (let t2 in s2) t2.startsWith("on") && typeof s2[t2] == "function" ? (e2[t2] != null || (e2[t2] = []), e2[t2].push(s2[t2])) : r2[t2] = s2[t2];
  if (r2.disabled || r2["aria-disabled"]) for (let s2 in e2) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(s2) && (e2[s2] = [(t2) => {
    var l2;
    return (l2 = t2 == null ? void 0 : t2.preventDefault) == null ? void 0 : l2.call(t2);
  }]);
  for (let s2 in e2) Object.assign(r2, { [s2](t2, ...l2) {
    let i2 = e2[s2];
    for (let o4 of i2) {
      if ((t2 instanceof Event || (t2 == null ? void 0 : t2.nativeEvent) instanceof Event) && t2.defaultPrevented) return;
      o4(t2, ...l2);
    }
  } });
  return r2;
}
function _$3(...n2) {
  if (n2.length === 0) return {};
  if (n2.length === 1) return n2[0];
  let r2 = {}, e2 = {};
  for (let s2 of n2) for (let t2 in s2) t2.startsWith("on") && typeof s2[t2] == "function" ? (e2[t2] != null || (e2[t2] = []), e2[t2].push(s2[t2])) : r2[t2] = s2[t2];
  for (let s2 in e2) Object.assign(r2, { [s2](...t2) {
    let l2 = e2[s2];
    for (let i2 of l2) i2 == null || i2(...t2);
  } });
  return r2;
}
function K(n2) {
  var r2;
  return Object.assign(forwardRef(n2), { displayName: (r2 = n2.displayName) != null ? r2 : n2.name });
}
function m$5(n2) {
  let r2 = Object.assign({}, n2);
  for (let e2 in r2) r2[e2] === void 0 && delete r2[e2];
  return r2;
}
function h$3(n2, r2 = []) {
  let e2 = Object.assign({}, n2);
  for (let a3 of r2) a3 in e2 && delete e2[a3];
  return e2;
}
function H$4(n2) {
  return React__default.version.split(".")[0] >= "19" ? n2.props.ref : n2.ref;
}
function T$4(l2, r2, c2) {
  let [i2, s2] = useState(c2), e2 = l2 !== void 0, t2 = useRef(e2), u2 = useRef(false), d2 = useRef(false);
  return e2 && !t2.current && !u2.current ? (u2.current = true, t2.current = e2, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e2 && t2.current && !d2.current && (d2.current = true, t2.current = e2, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [e2 ? l2 : i2, o$6((n2) => (e2 || s2(n2), r2 == null ? void 0 : r2(n2)))];
}
function l$5(e2) {
  let [t2] = useState(e2);
  return t2;
}
function e$3(i2 = {}, s2 = null, t2 = []) {
  for (let [r2, n2] of Object.entries(i2)) o$5(t2, f$c(s2, r2), n2);
  return t2;
}
function f$c(i2, s2) {
  return i2 ? i2 + "[" + s2 + "]" : s2;
}
function o$5(i2, s2, t2) {
  if (Array.isArray(t2)) for (let [r2, n2] of t2.entries()) o$5(i2, f$c(s2, r2.toString()), n2);
  else t2 instanceof Date ? i2.push([s2, t2.toISOString()]) : typeof t2 == "boolean" ? i2.push([s2, t2 ? "1" : "0"]) : typeof t2 == "string" ? i2.push([s2, t2]) : typeof t2 == "number" ? i2.push([s2, `${t2}`]) : t2 == null ? i2.push([s2, ""]) : e$3(t2, s2, i2);
}
let a$9 = "span";
var s$4 = ((e2) => (e2[e2.None = 1] = "None", e2[e2.Focusable = 2] = "Focusable", e2[e2.Hidden = 4] = "Hidden", e2))(s$4 || {});
function l$4(t2, r2) {
  var n2;
  let { features: d2 = 1, ...e2 } = t2, o4 = { ref: r2, "aria-hidden": (d2 & 2) === 2 ? true : (n2 = e2["aria-hidden"]) != null ? n2 : void 0, hidden: (d2 & 4) === 4 ? true : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(d2 & 4) === 4 && (d2 & 2) !== 2 && { display: "none" } } };
  return L$3()({ ourProps: o4, theirProps: e2, slot: {}, defaultTag: a$9, name: "Hidden" });
}
let f$b = K(l$4);
let f$a = createContext(null);
function W(t2) {
  let [e2, r2] = useState(null);
  return React__default.createElement(f$a.Provider, { value: { target: e2 } }, t2.children, React__default.createElement(f$b, { features: s$4.Hidden, ref: r2 }));
}
function c$7({ children: t2 }) {
  let e2 = useContext(f$a);
  if (!e2) return React__default.createElement(React__default.Fragment, null, t2);
  let { target: r2 } = e2;
  return r2 ? createPortal(React__default.createElement(React__default.Fragment, null, t2), r2) : null;
}
function j$3({ data: t2, form: e2, disabled: r2, onReset: n2, overrides: F2 }) {
  let [i2, a3] = useState(null), p2 = p$4();
  return useEffect(() => {
    if (n2 && i2) return p2.addEventListener(i2, "reset", n2);
  }, [i2, e2, n2]), React__default.createElement(c$7, null, React__default.createElement(C$5, { setForm: a3, formId: e2 }), e$3(t2).map(([s2, v]) => React__default.createElement(f$b, { features: s$4.Hidden, ...m$5({ key: s2, as: "input", type: "hidden", hidden: true, readOnly: true, form: e2, disabled: r2, name: s2, value: v, ...F2 }) })));
}
function C$5({ setForm: t2, formId: e2 }) {
  return useEffect(() => {
    if (e2) {
      let r2 = document.getElementById(e2);
      r2 && t2(r2);
    }
  }, [t2, e2]), e2 ? null : React__default.createElement(f$b, { features: s$4.Hidden, as: "input", type: "hidden", hidden: true, readOnly: true, ref: (r2) => {
    if (!r2) return;
    let n2 = r2.closest("form");
    n2 && t2(n2);
  } });
}
let e$2 = createContext(void 0);
function u$9() {
  return useContext(e$2);
}
function f$9({ id: t2, children: r2 }) {
  return React__default.createElement(e$2.Provider, { value: t2 }, r2);
}
function o$4(e2) {
  return typeof e2 != "object" || e2 === null ? false : "nodeType" in e2;
}
function t$3(e2) {
  return o$4(e2) && "tagName" in e2;
}
function n$5(e2) {
  return t$3(e2) && "accessKey" in e2;
}
function i$4(e2) {
  return t$3(e2) && "tabIndex" in e2;
}
function r$3(e2) {
  return t$3(e2) && "style" in e2;
}
function u$8(e2) {
  return n$5(e2) && e2.nodeName === "IFRAME";
}
function l$3(e2) {
  return n$5(e2) && e2.nodeName === "INPUT";
}
function m$4(e2) {
  return n$5(e2) && e2.nodeName === "LABEL";
}
function a$8(e2) {
  return n$5(e2) && e2.nodeName === "FIELDSET";
}
function E$3(e2) {
  return n$5(e2) && e2.nodeName === "LEGEND";
}
function L$2(e2) {
  return t$3(e2) ? e2.matches('a[href],audio[controls],button,details,embed,iframe,img[usemap],input:not([type="hidden"]),label,select,textarea,video[controls]') : false;
}
function s$3(l2) {
  let e2 = l2.parentElement, t2 = null;
  for (; e2 && !a$8(e2); ) E$3(e2) && (t2 = e2), e2 = e2.parentElement;
  let i2 = (e2 == null ? void 0 : e2.getAttribute("disabled")) === "";
  return i2 && r$2(t2) ? false : i2;
}
function r$2(l2) {
  if (!l2) return false;
  let e2 = l2.previousElementSibling;
  for (; e2 !== null; ) {
    if (E$3(e2)) return false;
    e2 = e2.previousElementSibling;
  }
  return true;
}
let u$7 = Symbol();
function T$3(t2, n2 = true) {
  return Object.assign(t2, { [u$7]: n2 });
}
function y$5(...t2) {
  let n2 = useRef(t2);
  useEffect(() => {
    n2.current = t2;
  }, [t2]);
  let c2 = o$6((e2) => {
    for (let o4 of n2.current) o4 != null && (typeof o4 == "function" ? o4(e2) : o4.current = e2);
  });
  return t2.every((e2) => e2 == null || (e2 == null ? void 0 : e2[u$7])) ? void 0 : c2;
}
let a$7 = createContext(null);
a$7.displayName = "DescriptionContext";
function f$8() {
  let r2 = useContext(a$7);
  if (r2 === null) {
    let e2 = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e2, f$8), e2;
  }
  return r2;
}
function U$1() {
  var r2, e2;
  return (e2 = (r2 = useContext(a$7)) == null ? void 0 : r2.value) != null ? e2 : void 0;
}
function w$1() {
  let [r2, e2] = useState([]);
  return [r2.length > 0 ? r2.join(" ") : void 0, useMemo(() => function(t2) {
    let i2 = o$6((n2) => (e2((s2) => [...s2, n2]), () => e2((s2) => {
      let o4 = s2.slice(), p2 = o4.indexOf(n2);
      return p2 !== -1 && o4.splice(p2, 1), o4;
    }))), l2 = useMemo(() => ({ register: i2, slot: t2.slot, name: t2.name, props: t2.props, value: t2.value }), [i2, t2.slot, t2.name, t2.props, t2.value]);
    return React__default.createElement(a$7.Provider, { value: l2 }, t2.children);
  }, [e2])];
}
let S$3 = "p";
function C$4(r2, e2) {
  let d2 = useId$1(), t2 = a$a(), { id: i2 = `headlessui-description-${d2}`, ...l2 } = r2, n2 = f$8(), s2 = y$5(e2);
  n$6(() => n2.register(i2), [i2, n2.register]);
  let o4 = t2 || false, p2 = useMemo(() => ({ ...n2.slot, disabled: o4 }), [n2.slot, o4]), D2 = { ref: s2, ...n2.props, id: i2 };
  return L$3()({ ourProps: D2, theirProps: l2, slot: p2, defaultTag: S$3, name: n2.name || "Description" });
}
let _$2 = K(C$4), H$3 = Object.assign(_$2, {});
var o$3 = ((r2) => (r2.Space = " ", r2.Enter = "Enter", r2.Escape = "Escape", r2.Backspace = "Backspace", r2.Delete = "Delete", r2.ArrowLeft = "ArrowLeft", r2.ArrowUp = "ArrowUp", r2.ArrowRight = "ArrowRight", r2.ArrowDown = "ArrowDown", r2.Home = "Home", r2.End = "End", r2.PageUp = "PageUp", r2.PageDown = "PageDown", r2.Tab = "Tab", r2))(o$3 || {});
let L$1 = createContext(null);
L$1.displayName = "LabelContext";
function C$3() {
  let n2 = useContext(L$1);
  if (n2 === null) {
    let l2 = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(l2, C$3), l2;
  }
  return n2;
}
function N(n2) {
  var a3, e2, o4;
  let l2 = (e2 = (a3 = useContext(L$1)) == null ? void 0 : a3.value) != null ? e2 : void 0;
  return ((o4 = n2 == null ? void 0 : n2.length) != null ? o4 : 0) > 0 ? [l2, ...n2].filter(Boolean).join(" ") : l2;
}
function Q({ inherit: n2 = false } = {}) {
  let l2 = N(), [a3, e2] = useState([]), o4 = n2 ? [l2, ...a3].filter(Boolean) : a3;
  return [o4.length > 0 ? o4.join(" ") : void 0, useMemo(() => function(t2) {
    let p2 = o$6((i2) => (e2((u2) => [...u2, i2]), () => e2((u2) => {
      let d2 = u2.slice(), f2 = d2.indexOf(i2);
      return f2 !== -1 && d2.splice(f2, 1), d2;
    }))), b2 = useMemo(() => ({ register: p2, slot: t2.slot, name: t2.name, props: t2.props, value: t2.value }), [p2, t2.slot, t2.name, t2.props, t2.value]);
    return React__default.createElement(L$1.Provider, { value: b2 }, t2.children);
  }, [e2])];
}
let G = "label";
function U(n2, l2) {
  var E3;
  let a3 = useId$1(), e2 = C$3(), o4 = u$9(), y2 = a$a(), { id: t2 = `headlessui-label-${a3}`, htmlFor: p2 = o4 != null ? o4 : (E3 = e2.props) == null ? void 0 : E3.htmlFor, passive: b2 = false, ...i2 } = n2, u2 = y$5(l2);
  n$6(() => e2.register(t2), [t2, e2.register]);
  let d2 = o$6((s2) => {
    let g2 = s2.currentTarget;
    if (!(s2.target !== s2.currentTarget && L$2(s2.target)) && (m$4(g2) && s2.preventDefault(), e2.props && "onClick" in e2.props && typeof e2.props.onClick == "function" && e2.props.onClick(s2), m$4(g2))) {
      let r2 = document.getElementById(g2.htmlFor);
      if (r2) {
        let x2 = r2.getAttribute("disabled");
        if (x2 === "true" || x2 === "") return;
        let h2 = r2.getAttribute("aria-disabled");
        if (h2 === "true" || h2 === "") return;
        (l$3(r2) && (r2.type === "file" || r2.type === "radio" || r2.type === "checkbox") || r2.role === "radio" || r2.role === "checkbox" || r2.role === "switch") && r2.click(), r2.focus({ preventScroll: true });
      }
    }
  }), f2 = y2 || false, R2 = useMemo(() => ({ ...e2.slot, disabled: f2 }), [e2.slot, f2]), c2 = { ref: u2, ...e2.props, id: t2, htmlFor: p2, onClick: d2 };
  return b2 && ("onClick" in c2 && (delete c2.htmlFor, delete c2.onClick), "onClick" in i2 && delete i2.onClick), L$3()({ ourProps: c2, theirProps: i2, slot: R2, defaultTag: p2 ? G : "div", name: e2.name || "Label" });
}
let j$2 = K(U), V = Object.assign(j$2, {});
function memo(getDeps, fn, opts) {
  let deps = opts.initialDeps ?? [];
  let result;
  function memoizedFunction() {
    var _a, _b, _c, _d;
    let depTime;
    if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
    const newDeps = getDeps();
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index2) => deps[index2] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
    result = fn(...newDeps);
    if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
      const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      const resultFpsPercentage = resultEndTime / 16;
      const pad = (str, num) => {
        str = String(str);
        while (str.length < num) {
          str = " " + str;
        }
        return str;
      };
      console.info(
        `%c⏱ ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * resultFpsPercentage, 120)
        )}deg 100% 31%);`,
        opts == null ? void 0 : opts.key
      );
    }
    (_d = opts == null ? void 0 : opts.onChange) == null ? void 0 : _d.call(opts, result);
    return result;
  }
  memoizedFunction.updateDeps = (newDeps) => {
    deps = newDeps;
  };
  return memoizedFunction;
}
function notUndefined(value, msg) {
  if (value === void 0) {
    throw new Error(`Unexpected undefined${""}`);
  } else {
    return value;
  }
}
const approxEqual = (a3, b2) => Math.abs(a3 - b2) < 1.01;
const debounce = (targetWindow, fn, ms) => {
  let timeoutId;
  return function(...args) {
    targetWindow.clearTimeout(timeoutId);
    timeoutId = targetWindow.setTimeout(() => fn.apply(this, args), ms);
  };
};
const getRect = (element) => {
  const { offsetWidth, offsetHeight } = element;
  return { width: offsetWidth, height: offsetHeight };
};
const defaultKeyExtractor = (index2) => index2;
const defaultRangeExtractor = (range) => {
  const start = Math.max(range.startIndex - range.overscan, 0);
  const end = Math.min(range.endIndex + range.overscan, range.count - 1);
  const arr = [];
  for (let i2 = start; i2 <= end; i2++) {
    arr.push(i2);
  }
  return arr;
};
const observeElementRect = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  const handler = (rect) => {
    const { width, height } = rect;
    cb({ width: Math.round(width), height: Math.round(height) });
  };
  handler(getRect(element));
  if (!targetWindow.ResizeObserver) {
    return () => {
    };
  }
  const observer = new targetWindow.ResizeObserver((entries) => {
    const run = () => {
      const entry = entries[0];
      if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
          handler({ width: box.inlineSize, height: box.blockSize });
          return;
        }
      }
      handler(getRect(element));
    };
    instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
  });
  observer.observe(element, { box: "border-box" });
  return () => {
    observer.unobserve(element);
  };
};
const addEventListenerOptions = {
  passive: true
};
const supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const observeElementOffset = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  let offset2 = 0;
  const fallback = instance.options.useScrollendEvent && supportsScrollend ? () => void 0 : debounce(
    targetWindow,
    () => {
      cb(offset2, false);
    },
    instance.options.isScrollingResetDelay
  );
  const createHandler = (isScrolling) => () => {
    const { horizontal, isRtl } = instance.options;
    offset2 = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
    fallback();
    cb(offset2, isScrolling);
  };
  const handler = createHandler(true);
  const endHandler = createHandler(false);
  endHandler();
  element.addEventListener("scroll", handler, addEventListenerOptions);
  const registerScrollendEvent = instance.options.useScrollendEvent && supportsScrollend;
  if (registerScrollendEvent) {
    element.addEventListener("scrollend", endHandler, addEventListenerOptions);
  }
  return () => {
    element.removeEventListener("scroll", handler);
    if (registerScrollendEvent) {
      element.removeEventListener("scrollend", endHandler);
    }
  };
};
const measureElement = (element, entry, instance) => {
  if (entry == null ? void 0 : entry.borderBoxSize) {
    const box = entry.borderBoxSize[0];
    if (box) {
      const size2 = Math.round(
        box[instance.options.horizontal ? "inlineSize" : "blockSize"]
      );
      return size2;
    }
  }
  return element[instance.options.horizontal ? "offsetWidth" : "offsetHeight"];
};
const elementScroll = (offset2, {
  adjustments = 0,
  behavior
}, instance) => {
  var _a, _b;
  const toOffset = offset2 + adjustments;
  (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, {
    [instance.options.horizontal ? "left" : "top"]: toOffset,
    behavior
  });
};
class Virtualizer {
  constructor(opts) {
    this.unsubs = [];
    this.scrollElement = null;
    this.targetWindow = null;
    this.isScrolling = false;
    this.measurementsCache = [];
    this.itemSizeCache = /* @__PURE__ */ new Map();
    this.pendingMeasuredCacheIndexes = [];
    this.scrollRect = null;
    this.scrollOffset = null;
    this.scrollDirection = null;
    this.scrollAdjustments = 0;
    this.elementsCache = /* @__PURE__ */ new Map();
    this.observer = /* @__PURE__ */ (() => {
      let _ro = null;
      const get = () => {
        if (_ro) {
          return _ro;
        }
        if (!this.targetWindow || !this.targetWindow.ResizeObserver) {
          return null;
        }
        return _ro = new this.targetWindow.ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const run = () => {
              this._measureElement(entry.target, entry);
            };
            this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
          });
        });
      };
      return {
        disconnect: () => {
          var _a;
          (_a = get()) == null ? void 0 : _a.disconnect();
          _ro = null;
        },
        observe: (target) => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.observe(target, { box: "border-box" });
        },
        unobserve: (target) => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.unobserve(target);
        }
      };
    })();
    this.range = null;
    this.setOptions = (opts2) => {
      Object.entries(opts2).forEach(([key, value]) => {
        if (typeof value === "undefined") delete opts2[key];
      });
      this.options = {
        debug: false,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: false,
        getItemKey: defaultKeyExtractor,
        rangeExtractor: defaultRangeExtractor,
        onChange: () => {
        },
        measureElement,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: true,
        isRtl: false,
        useScrollendEvent: false,
        useAnimationFrameWithResizeObserver: false,
        ...opts2
      };
    };
    this.notify = (sync) => {
      var _a, _b;
      (_b = (_a = this.options).onChange) == null ? void 0 : _b.call(_a, this, sync);
    };
    this.maybeNotify = memo(
      () => {
        this.calculateRange();
        return [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ];
      },
      (isScrolling) => {
        this.notify(isScrolling);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    );
    this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((d2) => d2());
      this.unsubs = [];
      this.observer.disconnect();
      this.scrollElement = null;
      this.targetWindow = null;
    };
    this._didMount = () => {
      return () => {
        this.cleanup();
      };
    };
    this._willUpdate = () => {
      var _a;
      const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== scrollElement) {
        this.cleanup();
        if (!scrollElement) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = scrollElement;
        if (this.scrollElement && "ownerDocument" in this.scrollElement) {
          this.targetWindow = this.scrollElement.ownerDocument.defaultView;
        } else {
          this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
        }
        this.elementsCache.forEach((cached) => {
          this.observer.observe(cached);
        });
        this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
        this.unsubs.push(
          this.options.observeElementRect(this, (rect) => {
            this.scrollRect = rect;
            this.maybeNotify();
          })
        );
        this.unsubs.push(
          this.options.observeElementOffset(this, (offset2, isScrolling) => {
            this.scrollAdjustments = 0;
            this.scrollDirection = isScrolling ? this.getScrollOffset() < offset2 ? "forward" : "backward" : null;
            this.scrollOffset = offset2;
            this.isScrolling = isScrolling;
            this.maybeNotify();
          })
        );
      }
    };
    this.getSize = () => {
      if (!this.options.enabled) {
        this.scrollRect = null;
        return 0;
      }
      this.scrollRect = this.scrollRect ?? this.options.initialRect;
      return this.scrollRect[this.options.horizontal ? "width" : "height"];
    };
    this.getScrollOffset = () => {
      if (!this.options.enabled) {
        this.scrollOffset = null;
        return 0;
      }
      this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
      return this.scrollOffset;
    };
    this.getFurthestMeasurement = (measurements, index2) => {
      const furthestMeasurementsFound = /* @__PURE__ */ new Map();
      const furthestMeasurements = /* @__PURE__ */ new Map();
      for (let m2 = index2 - 1; m2 >= 0; m2--) {
        const measurement = measurements[m2];
        if (furthestMeasurementsFound.has(measurement.lane)) {
          continue;
        }
        const previousFurthestMeasurement = furthestMeasurements.get(
          measurement.lane
        );
        if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
          furthestMeasurements.set(measurement.lane, measurement);
        } else if (measurement.end < previousFurthestMeasurement.end) {
          furthestMeasurementsFound.set(measurement.lane, true);
        }
        if (furthestMeasurementsFound.size === this.options.lanes) {
          break;
        }
      }
      return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a3, b2) => {
        if (a3.end === b2.end) {
          return a3.index - b2.index;
        }
        return a3.end - b2.end;
      })[0] : void 0;
    };
    this.getMeasurementOptions = memo(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (count2, paddingStart, scrollMargin, getItemKey, enabled) => {
        this.pendingMeasuredCacheIndexes = [];
        return {
          count: count2,
          paddingStart,
          scrollMargin,
          getItemKey,
          enabled
        };
      },
      {
        key: false
      }
    );
    this.getMeasurements = memo(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: count2, paddingStart, scrollMargin, getItemKey, enabled }, itemSizeCache) => {
        if (!enabled) {
          this.measurementsCache = [];
          this.itemSizeCache.clear();
          return [];
        }
        if (this.measurementsCache.length === 0) {
          this.measurementsCache = this.options.initialMeasurementsCache;
          this.measurementsCache.forEach((item) => {
            this.itemSizeCache.set(item.key, item.size);
          });
        }
        const min2 = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const measurements = this.measurementsCache.slice(0, min2);
        for (let i2 = min2; i2 < count2; i2++) {
          const key = getItemKey(i2);
          const furthestMeasurement = this.options.lanes === 1 ? measurements[i2 - 1] : this.getFurthestMeasurement(measurements, i2);
          const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
          const measuredSize = itemSizeCache.get(key);
          const size2 = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i2);
          const end = start + size2;
          const lane = furthestMeasurement ? furthestMeasurement.lane : i2 % this.options.lanes;
          measurements[i2] = {
            index: i2,
            start,
            size: size2,
            end,
            key,
            lane
          };
        }
        this.measurementsCache = measurements;
        return measurements;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    );
    this.calculateRange = memo(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (measurements, outerSize, scrollOffset, lanes) => {
        return this.range = measurements.length > 0 && outerSize > 0 ? calculateRange({
          measurements,
          outerSize,
          scrollOffset,
          lanes
        }) : null;
      },
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    );
    this.getVirtualIndexes = memo(
      () => {
        let startIndex = null;
        let endIndex = null;
        const range = this.calculateRange();
        if (range) {
          startIndex = range.startIndex;
          endIndex = range.endIndex;
        }
        this.maybeNotify.updateDeps([this.isScrolling, startIndex, endIndex]);
        return [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          startIndex,
          endIndex
        ];
      },
      (rangeExtractor, overscan, count2, startIndex, endIndex) => {
        return startIndex === null || endIndex === null ? [] : rangeExtractor({
          startIndex,
          endIndex,
          overscan,
          count: count2
        });
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    );
    this.indexFromElement = (node) => {
      const attributeName = this.options.indexAttribute;
      const indexStr = node.getAttribute(attributeName);
      if (!indexStr) {
        console.warn(
          `Missing attribute name '${attributeName}={index}' on measured element.`
        );
        return -1;
      }
      return parseInt(indexStr, 10);
    };
    this._measureElement = (node, entry) => {
      const index2 = this.indexFromElement(node);
      const item = this.measurementsCache[index2];
      if (!item) {
        return;
      }
      const key = item.key;
      const prevNode = this.elementsCache.get(key);
      if (prevNode !== node) {
        if (prevNode) {
          this.observer.unobserve(prevNode);
        }
        this.observer.observe(node);
        this.elementsCache.set(key, node);
      }
      if (node.isConnected) {
        this.resizeItem(index2, this.options.measureElement(node, entry, this));
      }
    };
    this.resizeItem = (index2, size2) => {
      const item = this.measurementsCache[index2];
      if (!item) {
        return;
      }
      const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
      const delta = size2 - itemSize;
      if (delta !== 0) {
        if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) {
          if (process.env.NODE_ENV !== "production" && this.options.debug) {
            console.info("correction", delta);
          }
          this._scrollToOffset(this.getScrollOffset(), {
            adjustments: this.scrollAdjustments += delta,
            behavior: void 0
          });
        }
        this.pendingMeasuredCacheIndexes.push(item.index);
        this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size2));
        this.notify(false);
      }
    };
    this.measureElement = (node) => {
      if (!node) {
        this.elementsCache.forEach((cached, key) => {
          if (!cached.isConnected) {
            this.observer.unobserve(cached);
            this.elementsCache.delete(key);
          }
        });
        return;
      }
      this._measureElement(node, void 0);
    };
    this.getVirtualItems = memo(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (indexes, measurements) => {
        const virtualItems = [];
        for (let k2 = 0, len = indexes.length; k2 < len; k2++) {
          const i2 = indexes[k2];
          const measurement = measurements[i2];
          virtualItems.push(measurement);
        }
        return virtualItems;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    );
    this.getVirtualItemForOffset = (offset2) => {
      const measurements = this.getMeasurements();
      if (measurements.length === 0) {
        return void 0;
      }
      return notUndefined(
        measurements[findNearestBinarySearch(
          0,
          measurements.length - 1,
          (index2) => notUndefined(measurements[index2]).start,
          offset2
        )]
      );
    };
    this.getOffsetForAlignment = (toOffset, align, itemSize = 0) => {
      const size2 = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        align = toOffset >= scrollOffset + size2 ? "end" : "start";
      }
      if (align === "center") {
        toOffset += (itemSize - size2) / 2;
      } else if (align === "end") {
        toOffset -= size2;
      }
      const maxOffset = this.getTotalSize() + this.options.scrollMargin - size2;
      return Math.max(Math.min(maxOffset, toOffset), 0);
    };
    this.getOffsetForIndex = (index2, align = "auto") => {
      index2 = Math.max(0, Math.min(index2, this.options.count - 1));
      const item = this.measurementsCache[index2];
      if (!item) {
        return void 0;
      }
      const size2 = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        if (item.end >= scrollOffset + size2 - this.options.scrollPaddingEnd) {
          align = "end";
        } else if (item.start <= scrollOffset + this.options.scrollPaddingStart) {
          align = "start";
        } else {
          return [scrollOffset, align];
        }
      }
      const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(toOffset, align, item.size),
        align
      ];
    };
    this.isDynamicMode = () => this.elementsCache.size > 0;
    this.scrollToOffset = (toOffset, { align = "start", behavior } = {}) => {
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
        adjustments: void 0,
        behavior
      });
    };
    this.scrollToIndex = (index2, { align: initialAlign = "auto", behavior } = {}) => {
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      index2 = Math.max(0, Math.min(index2, this.options.count - 1));
      let attempts = 0;
      const maxAttempts = 10;
      const tryScroll = (currentAlign) => {
        if (!this.targetWindow) return;
        const offsetInfo = this.getOffsetForIndex(index2, currentAlign);
        if (!offsetInfo) {
          console.warn("Failed to get offset for index:", index2);
          return;
        }
        const [offset2, align] = offsetInfo;
        this._scrollToOffset(offset2, { adjustments: void 0, behavior });
        this.targetWindow.requestAnimationFrame(() => {
          const currentOffset = this.getScrollOffset();
          const afterInfo = this.getOffsetForIndex(index2, align);
          if (!afterInfo) {
            console.warn("Failed to get offset for index:", index2);
            return;
          }
          if (!approxEqual(afterInfo[0], currentOffset)) {
            scheduleRetry(align);
          }
        });
      };
      const scheduleRetry = (align) => {
        if (!this.targetWindow) return;
        attempts++;
        if (attempts < maxAttempts) {
          if (process.env.NODE_ENV !== "production" && this.options.debug) {
            console.info("Schedule retry", attempts, maxAttempts);
          }
          this.targetWindow.requestAnimationFrame(() => tryScroll(align));
        } else {
          console.warn(
            `Failed to scroll to index ${index2} after ${maxAttempts} attempts.`
          );
        }
      };
      tryScroll(initialAlign);
    };
    this.scrollBy = (delta, { behavior } = {}) => {
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      this._scrollToOffset(this.getScrollOffset() + delta, {
        adjustments: void 0,
        behavior
      });
    };
    this.getTotalSize = () => {
      var _a;
      const measurements = this.getMeasurements();
      let end;
      if (measurements.length === 0) {
        end = this.options.paddingStart;
      } else if (this.options.lanes === 1) {
        end = ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0;
      } else {
        const endByLane = Array(this.options.lanes).fill(null);
        let endIndex = measurements.length - 1;
        while (endIndex >= 0 && endByLane.some((val) => val === null)) {
          const item = measurements[endIndex];
          if (endByLane[item.lane] === null) {
            endByLane[item.lane] = item.end;
          }
          endIndex--;
        }
        end = Math.max(...endByLane.filter((val) => val !== null));
      }
      return Math.max(
        end - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    };
    this._scrollToOffset = (offset2, {
      adjustments,
      behavior
    }) => {
      this.options.scrollToFn(offset2, { behavior, adjustments }, this);
    };
    this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map();
      this.notify(false);
    };
    this.setOptions(opts);
  }
}
const findNearestBinarySearch = (low, high, getCurrentValue, value) => {
  while (low <= high) {
    const middle = (low + high) / 2 | 0;
    const currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange({
  measurements,
  outerSize,
  scrollOffset,
  lanes
}) {
  const lastIndex = measurements.length - 1;
  const getOffset = (index2) => measurements[index2].start;
  if (measurements.length <= lanes) {
    return {
      startIndex: 0,
      endIndex: lastIndex
    };
  }
  let startIndex = findNearestBinarySearch(
    0,
    lastIndex,
    getOffset,
    scrollOffset
  );
  let endIndex = startIndex;
  if (lanes === 1) {
    while (endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize) {
      endIndex++;
    }
  } else if (lanes > 1) {
    const endPerLane = Array(lanes).fill(0);
    while (endIndex < lastIndex && endPerLane.some((pos) => pos < scrollOffset + outerSize)) {
      const item = measurements[endIndex];
      endPerLane[item.lane] = item.end;
      endIndex++;
    }
    const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
    while (startIndex >= 0 && startPerLane.some((pos) => pos >= scrollOffset)) {
      const item = measurements[startIndex];
      startPerLane[item.lane] = item.start;
      startIndex--;
    }
    startIndex = Math.max(0, startIndex - startIndex % lanes);
    endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
  }
  return { startIndex, endIndex };
}
const useIsomorphicLayoutEffect = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
function useVirtualizerBase(options) {
  const rerender = React.useReducer(() => ({}), {})[1];
  const resolvedOptions = {
    ...options,
    onChange: (instance2, sync) => {
      var _a;
      if (sync) {
        flushSync(rerender);
      } else {
        rerender();
      }
      (_a = options.onChange) == null ? void 0 : _a.call(options, instance2, sync);
    }
  };
  const [instance] = React.useState(
    () => new Virtualizer(resolvedOptions)
  );
  instance.setOptions(resolvedOptions);
  useIsomorphicLayoutEffect(() => {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect(() => {
    return instance._willUpdate();
  });
  return instance;
}
function useVirtualizer(options) {
  return useVirtualizerBase({
    observeElementRect,
    observeElementOffset,
    scrollToFn: elementScroll,
    ...options
  });
}
function l$2(e2, r2) {
  return e2 !== null && r2 !== null && typeof e2 == "object" && typeof r2 == "object" && "id" in e2 && "id" in r2 ? e2.id === r2.id : e2 === r2;
}
function u$6(e2 = l$2) {
  return useCallback((r2, t2) => {
    if (typeof e2 == "string") {
      let o4 = e2;
      return (r2 == null ? void 0 : r2[o4]) === (t2 == null ? void 0 : t2[o4]);
    }
    return e2(r2, t2);
  }, [e2]);
}
function f$7(e2) {
  if (e2 === null) return { width: 0, height: 0 };
  let { width: t2, height: r2 } = e2.getBoundingClientRect();
  return { width: t2, height: r2 };
}
function d$2(e2, t2 = false) {
  let [r2, u2] = useReducer(() => ({}), {}), i2 = useMemo(() => f$7(e2), [e2, r2]);
  return n$6(() => {
    if (!e2) return;
    let n2 = new ResizeObserver(u2);
    return n2.observe(e2), () => {
      n2.disconnect();
    };
  }, [e2]), t2 ? { width: `${i2.width}px`, height: `${i2.height}px` } : i2;
}
let a$6 = class a extends Map {
  constructor(t2) {
    super();
    this.factory = t2;
  }
  get(t2) {
    let e2 = super.get(t2);
    return e2 === void 0 && (e2 = this.factory(t2), this.set(t2, e2)), e2;
  }
};
var p$3 = Object.defineProperty;
var h$2 = (t2, e2, r2) => e2 in t2 ? p$3(t2, e2, { enumerable: true, configurable: true, writable: true, value: r2 }) : t2[e2] = r2;
var f$6 = (t2, e2, r2) => (h$2(t2, e2 + "", r2), r2), b$2 = (t2, e2, r2) => {
  if (!e2.has(t2)) throw TypeError("Cannot " + r2);
};
var n$4 = (t2, e2, r2) => (b$2(t2, e2, "read from private field"), r2 ? r2.call(t2) : e2.get(t2)), c$6 = (t2, e2, r2) => {
  if (e2.has(t2)) throw TypeError("Cannot add the same private member more than once");
  e2 instanceof WeakSet ? e2.add(t2) : e2.set(t2, r2);
}, u$5 = (t2, e2, r2, s2) => (b$2(t2, e2, "write to private field"), e2.set(t2, r2), r2);
var i$3, a$5, o$2;
let E$2 = class E {
  constructor(e2) {
    c$6(this, i$3, {});
    c$6(this, a$5, new a$6(() => /* @__PURE__ */ new Set()));
    c$6(this, o$2, /* @__PURE__ */ new Set());
    f$6(this, "disposables", o$7());
    u$5(this, i$3, e2);
  }
  dispose() {
    this.disposables.dispose();
  }
  get state() {
    return n$4(this, i$3);
  }
  subscribe(e2, r2) {
    let s2 = { selector: e2, callback: r2, current: e2(n$4(this, i$3)) };
    return n$4(this, o$2).add(s2), this.disposables.add(() => {
      n$4(this, o$2).delete(s2);
    });
  }
  on(e2, r2) {
    return n$4(this, a$5).get(e2).add(r2), this.disposables.add(() => {
      n$4(this, a$5).get(e2).delete(r2);
    });
  }
  send(e2) {
    let r2 = this.reduce(n$4(this, i$3), e2);
    if (r2 !== n$4(this, i$3)) {
      u$5(this, i$3, r2);
      for (let s2 of n$4(this, o$2)) {
        let l2 = s2.selector(n$4(this, i$3));
        j$1(s2.current, l2) || (s2.current = l2, s2.callback(l2));
      }
      for (let s2 of n$4(this, a$5).get(e2.type)) s2(n$4(this, i$3), e2);
    }
  }
};
i$3 = /* @__PURE__ */ new WeakMap(), a$5 = /* @__PURE__ */ new WeakMap(), o$2 = /* @__PURE__ */ new WeakMap();
function j$1(t2, e2) {
  return Object.is(t2, e2) ? true : typeof t2 != "object" || t2 === null || typeof e2 != "object" || e2 === null ? false : Array.isArray(t2) && Array.isArray(e2) ? t2.length !== e2.length ? false : d$1(t2[Symbol.iterator](), e2[Symbol.iterator]()) : t2 instanceof Map && e2 instanceof Map || t2 instanceof Set && e2 instanceof Set ? t2.size !== e2.size ? false : d$1(t2.entries(), e2.entries()) : y$4(t2) && y$4(e2) ? d$1(Object.entries(t2)[Symbol.iterator](), Object.entries(e2)[Symbol.iterator]()) : false;
}
function d$1(t2, e2) {
  do {
    let r2 = t2.next(), s2 = e2.next();
    if (r2.done && s2.done) return true;
    if (r2.done || s2.done || !Object.is(r2.value, s2.value)) return false;
  } while (true);
}
function y$4(t2) {
  if (Object.prototype.toString.call(t2) !== "[object Object]") return false;
  let e2 = Object.getPrototypeOf(t2);
  return e2 === null || Object.getPrototypeOf(e2) === null;
}
var a$4 = Object.defineProperty;
var r$1 = (e2, c2, t2) => c2 in e2 ? a$4(e2, c2, { enumerable: true, configurable: true, writable: true, value: t2 }) : e2[c2] = t2;
var p$2 = (e2, c2, t2) => (r$1(e2, typeof c2 != "symbol" ? c2 + "" : c2, t2), t2);
var k$3 = ((t2) => (t2[t2.Push = 0] = "Push", t2[t2.Pop = 1] = "Pop", t2))(k$3 || {});
let y$3 = { [0](e2, c2) {
  let t2 = c2.id, s2 = e2.stack, i2 = e2.stack.indexOf(t2);
  if (i2 !== -1) {
    let n2 = e2.stack.slice();
    return n2.splice(i2, 1), n2.push(t2), s2 = n2, { ...e2, stack: s2 };
  }
  return { ...e2, stack: [...e2.stack, t2] };
}, [1](e2, c2) {
  let t2 = c2.id, s2 = e2.stack.indexOf(t2);
  if (s2 === -1) return e2;
  let i2 = e2.stack.slice();
  return i2.splice(s2, 1), { ...e2, stack: i2 };
} };
let o$1 = class o2 extends E$2 {
  constructor() {
    super(...arguments);
    p$2(this, "actions", { push: (t2) => this.send({ type: 0, id: t2 }), pop: (t2) => this.send({ type: 1, id: t2 }) });
    p$2(this, "selectors", { isTop: (t2, s2) => t2.stack[t2.stack.length - 1] === s2, inStack: (t2, s2) => t2.stack.includes(s2) });
  }
  static new() {
    return new o2({ stack: [] });
  }
  reduce(t2, s2) {
    return u$a(s2.type, y$3, t2, s2);
  }
};
const x$1 = new a$6(() => o$1.new());
var withSelector = { exports: {} };
var useSyncExternalStoreWithSelector_production = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreWithSelector_production;
function requireUseSyncExternalStoreWithSelector_production() {
  if (hasRequiredUseSyncExternalStoreWithSelector_production) return useSyncExternalStoreWithSelector_production;
  hasRequiredUseSyncExternalStoreWithSelector_production = 1;
  var React2 = React__default;
  function is(x2, y2) {
    return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore2 = React2.useSyncExternalStore, useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
  useSyncExternalStoreWithSelector_production.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef2(null);
    if (null === instRef.current) {
      var inst = { hasValue: false, value: null };
      instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo2(
      function() {
        function memoizedSelector(nextSnapshot) {
          if (!hasMemo) {
            hasMemo = true;
            memoizedSnapshot = nextSnapshot;
            nextSnapshot = selector(nextSnapshot);
            if (void 0 !== isEqual && inst.hasValue) {
              var currentSelection = inst.value;
              if (isEqual(currentSelection, nextSnapshot))
                return memoizedSelection = currentSelection;
            }
            return memoizedSelection = nextSnapshot;
          }
          currentSelection = memoizedSelection;
          if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
          var nextSelection = selector(nextSnapshot);
          if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
            return memoizedSnapshot = nextSnapshot, currentSelection;
          memoizedSnapshot = nextSnapshot;
          return memoizedSelection = nextSelection;
        }
        var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
          function() {
            return memoizedSelector(getSnapshot());
          },
          null === maybeGetServerSnapshot ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          }
        ];
      },
      [getSnapshot, getServerSnapshot, selector, isEqual]
    );
    var value = useSyncExternalStore2(subscribe, instRef[0], instRef[1]);
    useEffect2(
      function() {
        inst.hasValue = true;
        inst.value = value;
      },
      [value]
    );
    useDebugValue(value);
    return value;
  };
  return useSyncExternalStoreWithSelector_production;
}
var useSyncExternalStoreWithSelector_development = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreWithSelector_development;
function requireUseSyncExternalStoreWithSelector_development() {
  if (hasRequiredUseSyncExternalStoreWithSelector_development) return useSyncExternalStoreWithSelector_development;
  hasRequiredUseSyncExternalStoreWithSelector_development = 1;
  "production" !== process.env.NODE_ENV && function() {
    function is(x2, y2) {
      return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore2 = React2.useSyncExternalStore, useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
    useSyncExternalStoreWithSelector_development.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
      var instRef = useRef2(null);
      if (null === instRef.current) {
        var inst = { hasValue: false, value: null };
        instRef.current = inst;
      } else inst = instRef.current;
      instRef = useMemo2(
        function() {
          function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
              hasMemo = true;
              memoizedSnapshot = nextSnapshot;
              nextSnapshot = selector(nextSnapshot);
              if (void 0 !== isEqual && inst.hasValue) {
                var currentSelection = inst.value;
                if (isEqual(currentSelection, nextSnapshot))
                  return memoizedSelection = currentSelection;
              }
              return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot))
              return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
              return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
          }
          var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
          return [
            function() {
              return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
              return memoizedSelector(maybeGetServerSnapshot());
            }
          ];
        },
        [getSnapshot, getServerSnapshot, selector, isEqual]
      );
      var value = useSyncExternalStore2(subscribe, instRef[0], instRef[1]);
      useEffect2(
        function() {
          inst.hasValue = true;
          inst.value = value;
        },
        [value]
      );
      useDebugValue(value);
      return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }();
  return useSyncExternalStoreWithSelector_development;
}
var hasRequiredWithSelector;
function requireWithSelector() {
  if (hasRequiredWithSelector) return withSelector.exports;
  hasRequiredWithSelector = 1;
  if (process.env.NODE_ENV === "production") {
    withSelector.exports = requireUseSyncExternalStoreWithSelector_production();
  } else {
    withSelector.exports = requireUseSyncExternalStoreWithSelector_development();
  }
  return withSelector.exports;
}
var withSelectorExports = requireWithSelector();
function S$2(e2, n2, r2 = j$1) {
  return withSelectorExports.useSyncExternalStoreWithSelector(o$6((i2) => e2.subscribe(s$2, i2)), o$6(() => e2.state), o$6(() => e2.state), o$6(n2), r2);
}
function s$2(e2) {
  return e2;
}
function I$2(o4, s2) {
  let t2 = useId$1(), r2 = x$1.get(s2), [i2, c2] = S$2(r2, useCallback((e2) => [r2.selectors.isTop(e2, t2), r2.selectors.inStack(e2, t2)], [r2, t2]));
  return n$6(() => {
    if (o4) return r2.actions.push(t2), () => r2.actions.pop(t2);
  }, [r2, o4, t2]), o4 ? c2 ? i2 : true : false;
}
let f$5 = /* @__PURE__ */ new Map(), u$4 = /* @__PURE__ */ new Map();
function h$1(t2) {
  var e2;
  let r2 = (e2 = u$4.get(t2)) != null ? e2 : 0;
  return u$4.set(t2, r2 + 1), r2 !== 0 ? () => m$3(t2) : (f$5.set(t2, { "aria-hidden": t2.getAttribute("aria-hidden"), inert: t2.inert }), t2.setAttribute("aria-hidden", "true"), t2.inert = true, () => m$3(t2));
}
function m$3(t2) {
  var i2;
  let r2 = (i2 = u$4.get(t2)) != null ? i2 : 1;
  if (r2 === 1 ? u$4.delete(t2) : u$4.set(t2, r2 - 1), r2 !== 1) return;
  let e2 = f$5.get(t2);
  e2 && (e2["aria-hidden"] === null ? t2.removeAttribute("aria-hidden") : t2.setAttribute("aria-hidden", e2["aria-hidden"]), t2.inert = e2.inert, f$5.delete(t2));
}
function y$2(t2, { allowed: r2, disallowed: e2 } = {}) {
  let i2 = I$2(t2, "inert-others");
  n$6(() => {
    var d2, c2;
    if (!i2) return;
    let a3 = o$7();
    for (let n2 of (d2 = e2 == null ? void 0 : e2()) != null ? d2 : []) n2 && a3.add(h$1(n2));
    let s2 = (c2 = r2 == null ? void 0 : r2()) != null ? c2 : [];
    for (let n2 of s2) {
      if (!n2) continue;
      let l2 = o$8(n2);
      if (!l2) continue;
      let o4 = n2.parentElement;
      for (; o4 && o4 !== l2.body; ) {
        for (let p2 of o4.children) s2.some((E3) => p2.contains(E3)) || a3.add(h$1(p2));
        o4 = o4.parentElement;
      }
    }
    return a3.dispose;
  }, [i2, r2, e2]);
}
function p$1(s2, n2, o4) {
  let i2 = s$5((t2) => {
    let e2 = t2.getBoundingClientRect();
    e2.x === 0 && e2.y === 0 && e2.width === 0 && e2.height === 0 && o4();
  });
  useEffect(() => {
    if (!s2) return;
    let t2 = n2 === null ? null : n$5(n2) ? n2 : n2.current;
    if (!t2) return;
    let e2 = o$7();
    if (typeof ResizeObserver != "undefined") {
      let r2 = new ResizeObserver(() => i2.current(t2));
      r2.observe(t2), e2.add(() => r2.disconnect());
    }
    if (typeof IntersectionObserver != "undefined") {
      let r2 = new IntersectionObserver(() => i2.current(t2));
      r2.observe(t2), e2.add(() => r2.disconnect());
    }
    return () => e2.dispose();
  }, [n2, i2, s2]);
}
let f$4 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e2) => `${e2}:not([tabindex='-1'])`).join(",");
var T$2 = ((n2) => (n2[n2.First = 1] = "First", n2[n2.Previous = 2] = "Previous", n2[n2.Next = 4] = "Next", n2[n2.Last = 8] = "Last", n2[n2.WrapAround = 16] = "WrapAround", n2[n2.NoScroll = 32] = "NoScroll", n2[n2.AutoFocus = 64] = "AutoFocus", n2))(T$2 || {}), y$1 = ((o4) => (o4[o4.Error = 0] = "Error", o4[o4.Overflow = 1] = "Overflow", o4[o4.Success = 2] = "Success", o4[o4.Underflow = 3] = "Underflow", o4))(y$1 || {}), S$1 = ((t2) => (t2[t2.Previous = -1] = "Previous", t2[t2.Next = 1] = "Next", t2))(S$1 || {});
var h = ((t2) => (t2[t2.Strict = 0] = "Strict", t2[t2.Loose = 1] = "Loose", t2))(h || {});
function A(e2, r2 = 0) {
  var t2;
  return e2 === ((t2 = o$8(e2)) == null ? void 0 : t2.body) ? false : u$a(r2, { [0]() {
    return e2.matches(f$4);
  }, [1]() {
    let l2 = e2;
    for (; l2 !== null; ) {
      if (l2.matches(f$4)) return true;
      l2 = l2.parentElement;
    }
    return false;
  } });
}
var H$2 = ((t2) => (t2[t2.Keyboard = 0] = "Keyboard", t2[t2.Mouse = 1] = "Mouse", t2))(H$2 || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e2) => {
  e2.metaKey || e2.altKey || e2.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, true), document.addEventListener("click", (e2) => {
  e2.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e2.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, true));
function P(e2, r2 = (t2) => t2) {
  return e2.slice().sort((t2, l2) => {
    let o4 = r2(t2), c2 = r2(l2);
    if (o4 === null || c2 === null) return 0;
    let u2 = o4.compareDocumentPosition(c2);
    return u2 & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : u2 & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function t$2() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function i$2() {
  return /Android/gi.test(window.navigator.userAgent);
}
function n$3() {
  return t$2() || i$2();
}
function i$1(t2, e2, o4, n2) {
  let u2 = s$5(o4);
  useEffect(() => {
    if (!t2) return;
    function r2(m2) {
      u2.current(m2);
    }
    return document.addEventListener(e2, r2, n2), () => document.removeEventListener(e2, r2, n2);
  }, [t2, e2, n2]);
}
function s$1(t2, e2, o4, n2) {
  let i2 = s$5(o4);
  useEffect(() => {
    if (!t2) return;
    function r2(d2) {
      i2.current(d2);
    }
    return window.addEventListener(e2, r2, n2), () => window.removeEventListener(e2, r2, n2);
  }, [t2, e2, n2]);
}
const C$2 = 30;
function k$2(o4, f2, h$12) {
  let m2 = s$5(h$12), s2 = useCallback(function(e2, c2) {
    if (e2.defaultPrevented) return;
    let r2 = c2(e2);
    if (r2 === null || !r2.getRootNode().contains(r2) || !r2.isConnected) return;
    let M2 = function u2(n2) {
      return typeof n2 == "function" ? u2(n2()) : Array.isArray(n2) || n2 instanceof Set ? n2 : [n2];
    }(f2);
    for (let u2 of M2) if (u2 !== null && (u2.contains(r2) || e2.composed && e2.composedPath().includes(u2))) return;
    return !A(r2, h.Loose) && r2.tabIndex !== -1 && e2.preventDefault(), m2.current(e2, r2);
  }, [m2, f2]), i2 = useRef(null);
  i$1(o4, "pointerdown", (t2) => {
    var e2, c2;
    n$3() || (i2.current = ((c2 = (e2 = t2.composedPath) == null ? void 0 : e2.call(t2)) == null ? void 0 : c2[0]) || t2.target);
  }, true), i$1(o4, "pointerup", (t2) => {
    if (n$3() || !i2.current) return;
    let e2 = i2.current;
    return i2.current = null, s2(t2, () => e2);
  }, true);
  let l2 = useRef({ x: 0, y: 0 });
  i$1(o4, "touchstart", (t2) => {
    l2.current.x = t2.touches[0].clientX, l2.current.y = t2.touches[0].clientY;
  }, true), i$1(o4, "touchend", (t2) => {
    let e2 = { x: t2.changedTouches[0].clientX, y: t2.changedTouches[0].clientY };
    if (!(Math.abs(e2.x - l2.current.x) >= C$2 || Math.abs(e2.y - l2.current.y) >= C$2)) return s2(t2, () => i$4(t2.target) ? t2.target : null);
  }, true), s$1(o4, "blur", (t2) => s2(t2, () => u$8(window.document.activeElement) ? window.document.activeElement : null), true);
}
function n$2(...e2) {
  return useMemo(() => o$8(...e2), [...e2]);
}
var m$2 = ((e2) => (e2[e2.Ignore = 0] = "Ignore", e2[e2.Select = 1] = "Select", e2[e2.Close = 2] = "Close", e2))(m$2 || {});
const g$2 = { Ignore: { kind: 0 }, Select: (r2) => ({ kind: 1, target: r2 }), Close: { kind: 2 } }, E$1 = 200;
function k$1(r2, { trigger: n2, action: s2, close: e2, select: a3 }) {
  let o4 = useRef(null);
  i$1(r2 && n2 !== null, "pointerdown", (t2) => {
    o$4(t2 == null ? void 0 : t2.target) && n2 != null && n2.contains(t2.target) && (o4.current = /* @__PURE__ */ new Date());
  }), i$1(r2 && n2 !== null, "pointerup", (t2) => {
    if (o4.current === null || !i$4(t2.target)) return;
    let i2 = s2(t2), u2 = (/* @__PURE__ */ new Date()).getTime() - o4.current.getTime();
    switch (o4.current = null, i2.kind) {
      case 0:
        return;
      case 1: {
        u2 > E$1 && (a3(i2.target), e2());
        break;
      }
      case 2: {
        e2();
        break;
      }
    }
  }, { capture: true });
}
function E2(n2, e2, a3, t2) {
  let i2 = s$5(a3);
  useEffect(() => {
    n2 = n2 != null ? n2 : window;
    function r2(o4) {
      i2.current(o4);
    }
    return n2.addEventListener(e2, r2, t2), () => n2.removeEventListener(e2, r2, t2);
  }, [n2, e2, t2]);
}
function f$3(e2) {
  let l2 = useRef({ value: "", selectionStart: null, selectionEnd: null });
  return E2(e2, "blur", (n2) => {
    let t2 = n2.target;
    l$3(t2) && (l2.current = { value: t2.value, selectionStart: t2.selectionStart, selectionEnd: t2.selectionEnd });
  }), o$6(() => {
    if (document.activeElement !== e2 && l$3(e2) && e2.isConnected) {
      if (e2.focus({ preventScroll: true }), e2.value !== l2.current.value) e2.setSelectionRange(e2.value.length, e2.value.length);
      else {
        let { selectionStart: n2, selectionEnd: t2 } = l2.current;
        n2 !== null && t2 !== null && e2.setSelectionRange(n2, t2);
      }
      l2.current = { value: "", selectionStart: null, selectionEnd: null };
    }
  });
}
function e$1(t2, u2) {
  return useMemo(() => {
    var n2;
    if (t2.type) return t2.type;
    let r2 = (n2 = t2.as) != null ? n2 : "button";
    if (typeof r2 == "string" && r2.toLowerCase() === "button" || (u2 == null ? void 0 : u2.tagName) === "BUTTON" && !u2.hasAttribute("type")) return "button";
  }, [t2.type, t2.as, u2]);
}
function o3(t2) {
  return useSyncExternalStore(t2.subscribe, t2.getSnapshot, t2.getSnapshot);
}
function a$3(o4, r2) {
  let t2 = o4(), n2 = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t2;
  }, subscribe(e2) {
    return n2.add(e2), () => n2.delete(e2);
  }, dispatch(e2, ...s2) {
    let i2 = r2[e2].call(t2, ...s2);
    i2 && (t2 = i2, n2.forEach((c2) => c2()));
  } };
}
function d() {
  let r2;
  return { before({ doc: e2 }) {
    var l2;
    let o4 = e2.documentElement, t2 = (l2 = e2.defaultView) != null ? l2 : window;
    r2 = Math.max(0, t2.innerWidth - o4.clientWidth);
  }, after({ doc: e2, d: o4 }) {
    let t2 = e2.documentElement, l2 = Math.max(0, t2.clientWidth - t2.offsetWidth), n2 = Math.max(0, r2 - l2);
    o4.style(t2, "paddingRight", `${n2}px`);
  } };
}
function w() {
  return t$2() ? { before({ doc: n2, d: l2, meta: f2 }) {
    function i2(a3) {
      return f2.containers.flatMap((r2) => r2()).some((r2) => r2.contains(a3));
    }
    l2.microTask(() => {
      var c2;
      if (window.getComputedStyle(n2.documentElement).scrollBehavior !== "auto") {
        let t2 = o$7();
        t2.style(n2.documentElement, "scrollBehavior", "auto"), l2.add(() => l2.microTask(() => t2.dispose()));
      }
      let a3 = (c2 = window.scrollY) != null ? c2 : window.pageYOffset, r2 = null;
      l2.addEventListener(n2, "click", (t2) => {
        if (i$4(t2.target)) try {
          let e2 = t2.target.closest("a");
          if (!e2) return;
          let { hash: m2 } = new URL(e2.href), s2 = n2.querySelector(m2);
          i$4(s2) && !i2(s2) && (r2 = s2);
        } catch {
        }
      }, true), l2.addEventListener(n2, "touchstart", (t2) => {
        if (i$4(t2.target) && r$3(t2.target)) if (i2(t2.target)) {
          let e2 = t2.target;
          for (; e2.parentElement && i2(e2.parentElement); ) e2 = e2.parentElement;
          l2.style(e2, "overscrollBehavior", "contain");
        } else l2.style(t2.target, "touchAction", "none");
      }), l2.addEventListener(n2, "touchmove", (t2) => {
        if (i$4(t2.target)) {
          if (l$3(t2.target)) return;
          if (i2(t2.target)) {
            let e2 = t2.target;
            for (; e2.parentElement && e2.dataset.headlessuiPortal !== "" && !(e2.scrollHeight > e2.clientHeight || e2.scrollWidth > e2.clientWidth); ) e2 = e2.parentElement;
            e2.dataset.headlessuiPortal === "" && t2.preventDefault();
          } else t2.preventDefault();
        }
      }, { passive: false }), l2.add(() => {
        var e2;
        let t2 = (e2 = window.scrollY) != null ? e2 : window.pageYOffset;
        a3 !== t2 && window.scrollTo(0, a3), r2 && r2.isConnected && (r2.scrollIntoView({ block: "nearest" }), r2 = null);
      });
    });
  } } : {};
}
function r() {
  return { before({ doc: e2, d: o4 }) {
    o4.style(e2.documentElement, "overflow", "hidden");
  } };
}
function m$1(e2) {
  let n2 = {};
  for (let t2 of e2) Object.assign(n2, t2(n2));
  return n2;
}
let a$2 = a$3(() => /* @__PURE__ */ new Map(), { PUSH(e2, n2) {
  var o4;
  let t2 = (o4 = this.get(e2)) != null ? o4 : { doc: e2, count: 0, d: o$7(), meta: /* @__PURE__ */ new Set() };
  return t2.count++, t2.meta.add(n2), this.set(e2, t2), this;
}, POP(e2, n2) {
  let t2 = this.get(e2);
  return t2 && (t2.count--, t2.meta.delete(n2)), this;
}, SCROLL_PREVENT({ doc: e2, d: n2, meta: t2 }) {
  let o4 = { doc: e2, d: n2, meta: m$1(t2) }, c2 = [w(), d(), r()];
  c2.forEach(({ before: r2 }) => r2 == null ? void 0 : r2(o4)), c2.forEach(({ after: r2 }) => r2 == null ? void 0 : r2(o4));
}, SCROLL_ALLOW({ d: e2 }) {
  e2.dispose();
}, TEARDOWN({ doc: e2 }) {
  this.delete(e2);
} });
a$2.subscribe(() => {
  let e2 = a$2.getSnapshot(), n2 = /* @__PURE__ */ new Map();
  for (let [t2] of e2) n2.set(t2, t2.documentElement.style.overflow);
  for (let t2 of e2.values()) {
    let o4 = n2.get(t2.doc) === "hidden", c2 = t2.count !== 0;
    (c2 && !o4 || !c2 && o4) && a$2.dispatch(t2.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t2), t2.count === 0 && a$2.dispatch("TEARDOWN", t2);
  }
});
function a$1(r2, e2, n2 = () => ({ containers: [] })) {
  let f2 = o3(a$2), o$12 = e2 ? f2.get(e2) : void 0, i2 = o$12 ? o$12.count > 0 : false;
  return n$6(() => {
    if (!(!e2 || !r2)) return a$2.dispatch("PUSH", e2, n2), () => a$2.dispatch("POP", e2, n2);
  }, [r2, e2]), i2;
}
function f$2(e2, c2, n2 = () => [document.body]) {
  let r2 = I$2(e2, "scroll-lock");
  a$1(r2, c2, (t2) => {
    var o4;
    return { containers: [...(o4 = t2.containers) != null ? o4 : [], n2] };
  });
}
function t$1(e2) {
  return [e2.screenX, e2.screenY];
}
function u$3() {
  let e2 = useRef([-1, -1]);
  return { wasMoved(r2) {
    let n2 = t$1(r2);
    return e2.current[0] === n2[0] && e2.current[1] === n2[1] ? false : (e2.current = n2, true);
  }, update(r2) {
    e2.current = t$1(r2);
  } };
}
function c$5(u2 = 0) {
  let [t2, l2] = useState(u2), g2 = useCallback((e2) => l2(e2), [t2]), s2 = useCallback((e2) => l2((a3) => a3 | e2), [t2]), m2 = useCallback((e2) => (t2 & e2) === e2, [t2]), n2 = useCallback((e2) => l2((a3) => a3 & ~e2), [l2]), F2 = useCallback((e2) => l2((a3) => a3 ^ e2), [l2]);
  return { flags: t2, setFlag: g2, addFlag: s2, hasFlag: m2, removeFlag: n2, toggleFlag: F2 };
}
var T$1, b$1;
typeof process != "undefined" && typeof globalThis != "undefined" && typeof Element != "undefined" && ((T$1 = process == null ? void 0 : process.env) == null ? void 0 : T$1["NODE_ENV"]) === "test" && typeof ((b$1 = Element == null ? void 0 : Element.prototype) == null ? void 0 : b$1.getAnimations) == "undefined" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var L = ((r2) => (r2[r2.None = 0] = "None", r2[r2.Closed = 1] = "Closed", r2[r2.Enter = 2] = "Enter", r2[r2.Leave = 4] = "Leave", r2))(L || {});
function R(t2) {
  let n2 = {};
  for (let e2 in t2) t2[e2] === true && (n2[`data-${e2}`] = "");
  return n2;
}
function x(t2, n2, e2, i2) {
  let [r2, o4] = useState(e2), { hasFlag: s2, addFlag: a3, removeFlag: l2 } = c$5(t2 && r2 ? 3 : 0), u2 = useRef(false), f2 = useRef(false), E3 = p$4();
  return n$6(() => {
    var d2;
    if (t2) {
      if (e2 && o4(true), !n2) {
        e2 && a3(3);
        return;
      }
      return (d2 = void 0) == null || d2.call(i2, e2), C$1(n2, { inFlight: u2, prepare() {
        f2.current ? f2.current = false : f2.current = u2.current, u2.current = true, !f2.current && (e2 ? (a3(3), l2(4)) : (a3(4), l2(2)));
      }, run() {
        f2.current ? e2 ? (l2(3), a3(4)) : (l2(4), a3(3)) : e2 ? l2(1) : a3(1);
      }, done() {
        var p2;
        f2.current && typeof n2.getAnimations == "function" && n2.getAnimations().length > 0 || (u2.current = false, l2(7), e2 || o4(false), (p2 = void 0) == null || p2.call(i2, e2));
      } });
    }
  }, [t2, e2, n2, E3]), t2 ? [r2, { closed: s2(1), enter: s2(2), leave: s2(4), transition: s2(2) || s2(4) }] : [e2, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function C$1(t2, { prepare: n2, run: e2, done: i2, inFlight: r2 }) {
  let o4 = o$7();
  return j(t2, { prepare: n2, inFlight: r2 }), o4.nextFrame(() => {
    e2(), o4.requestAnimationFrame(() => {
      o4.add(M$2(t2, i2));
    });
  }), o4.dispose;
}
function M$2(t2, n2) {
  var o4, s2;
  let e2 = o$7();
  if (!t2) return e2.dispose;
  let i2 = false;
  e2.add(() => {
    i2 = true;
  });
  let r2 = (s2 = (o4 = t2.getAnimations) == null ? void 0 : o4.call(t2).filter((a3) => a3 instanceof CSSTransition)) != null ? s2 : [];
  return r2.length === 0 ? (n2(), e2.dispose) : (Promise.allSettled(r2.map((a3) => a3.finished)).then(() => {
    i2 || n2();
  }), e2.dispose);
}
function j(t2, { inFlight: n2, prepare: e2 }) {
  if (n2 != null && n2.current) {
    e2();
    return;
  }
  let i2 = t2.style.transition;
  t2.style.transition = "none", e2(), t2.offsetHeight, t2.style.transition = i2;
}
function F$1(c2, { container: e2, accept: t2, walk: r2 }) {
  let o4 = useRef(t2), l2 = useRef(r2);
  useEffect(() => {
    o4.current = t2, l2.current = r2;
  }, [t2, r2]), n$6(() => {
    if (!e2 || !c2) return;
    let n2 = o$8(e2);
    if (!n2) return;
    let f2 = o4.current, p2 = l2.current, i2 = Object.assign((m2) => f2(m2), { acceptNode: f2 }), u2 = n2.createTreeWalker(e2, NodeFilter.SHOW_ELEMENT, i2, false);
    for (; u2.nextNode(); ) p2(u2.currentNode);
  }, [e2, c2, o4, l2]);
}
function m(u2, t2) {
  let e2 = useRef([]), r2 = o$6(u2);
  useEffect(() => {
    let o4 = [...e2.current];
    for (let [a3, l2] of t2.entries()) if (e2.current[a3] !== l2) {
      let n2 = r2(t2, o4);
      return e2.current = t2, n2;
    }
  }, [r2, ...t2]);
}
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
const tableElements = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement(element) {
  return tableElements.has(getNodeName(element));
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element) {
  return topLayerSelectors.some((selector) => {
    try {
      return element.matches(selector);
    } catch (_e) {
      return false;
    }
  });
}
const transformProperties = ["transform", "translate", "scale", "rotate", "perspective"];
const willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
const containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return transformProperties.some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value) => (css.willChange || "").includes(value)) || containValues.some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
const lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map((_ref) => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(" ");
  }
  return navigator.userAgent;
}
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
const yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y2,
    left: x2,
    right: x2 + width,
    bottom: y2 + height,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow$1(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const flip$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d2) => d2.overflows[0] > 0 && getSideAxis(d2.placement) === initialSideAxis)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a3, b2) => a3.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a3, b2) => a3[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x: x2,
        y: y2,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y3
            } = _ref;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
const size$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width;
  let y2 = ($2 ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y2 += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y: y2
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y2 = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y: y2
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
const absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y2 = top * scale.y;
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y2 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill2) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill2) {
    return polyfill2(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill2) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill2);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill2);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a3, b2) {
  return a3.x === b2.x && a3.y === b2.y && a3.width === b2.width && a3.height === b2.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const detectOverflow = detectOverflow$1;
const offset$1 = offset$2;
const shift$1 = shift$2;
const flip$1 = flip$2;
const size$1 = size$2;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var isClient = typeof document !== "undefined";
var noop = function noop2() {
};
var index$1 = isClient ? useLayoutEffect : noop;
function deepEqual$1(a3, b2) {
  if (a3 === b2) {
    return true;
  }
  if (typeof a3 !== typeof b2) {
    return false;
  }
  if (typeof a3 === "function" && a3.toString() === b2.toString()) {
    return true;
  }
  let length;
  let i2;
  let keys;
  if (a3 && b2 && typeof a3 === "object") {
    if (Array.isArray(a3)) {
      length = a3.length;
      if (length !== b2.length) return false;
      for (i2 = length; i2-- !== 0; ) {
        if (!deepEqual$1(a3[i2], b2[i2])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a3);
    length = keys.length;
    if (length !== Object.keys(b2).length) {
      return false;
    }
    for (i2 = length; i2-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b2, keys[i2])) {
        return false;
      }
    }
    for (i2 = length; i2-- !== 0; ) {
      const key = keys[i2];
      if (key === "_owner" && a3.$$typeof) {
        continue;
      }
      if (!deepEqual$1(a3[key], b2[key])) {
        return false;
      }
    }
    return true;
  }
  return a3 !== a3 && b2 !== b2;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual$1(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual$1(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x2 = roundByDPR(elements.floating, data.x);
    const y2 = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x2 + "px, " + y2 + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x2,
      top: y2
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
const offset = (options, deps) => ({
  ...offset$1(options),
  options: [options, deps]
});
const shift = (options, deps) => ({
  ...shift$1(options),
  options: [options, deps]
});
const flip = (options, deps) => ({
  ...flip$1(options),
  options: [options, deps]
});
const size = (options, deps) => ({
  ...size$1(options),
  options: [options, deps]
});
const SafeReact = {
  ...React
};
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEffectEvent(callback) {
  const ref = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
var index = typeof document !== "undefined" ? useLayoutEffect : useEffect;
let serverHandoffComplete = false;
let count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  index(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;
const useId = useReactId || useFloatingId;
let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /* @__PURE__ */ new Set();
}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l2) => l2 !== listener)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);
const FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = React.useRef({});
  const [events] = React.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
  }
  const [positionReference, setPositionReference] = React.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open2, event, reason) => {
    dataRef.current.openEvent = open2 ? event : void 0;
    events.emit("openchange", {
      open: open2,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open2, event, reason);
  });
  const refs = React.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React.useState(null);
  const [positionReference, _setPositionReference] = React.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React.useRef(null);
  const tree = useFloatingTree();
  index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = useFloating$1({
    ...options,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = React.useCallback((node) => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = React.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position.elements,
    domReference
  }), [position.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}
const ACTIVE_KEY = "active";
const SELECTED_KEY = "selected";
function mergeProps(userProps, propsList, elementKey) {
  const map = /* @__PURE__ */ new Map();
  const isItem = elementKey === "item";
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _2,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...elementKey === "floating" && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    },
    ...domUserProps,
    ...propsList.map((value) => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === "function") {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach((_ref) => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf("on") === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === "function") {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function() {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn) => fn(...args)).find((val) => val !== void 0);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map((key) => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map((key) => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map((key) => key == null ? void 0 : key.item);
  const getReferenceProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps
  );
  const getFloatingProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps
  );
  const getItemProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps
  );
  return React.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}
function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
const inner = (props) => ({
  name: "inner",
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index: index2 = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = evaluate(props, state);
    const {
      rects,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index2];
    const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
    const clientTop = floating.clientTop || scrollEl.clientTop;
    const floatingIsBordered = floating.clientTop !== 0;
    const scrollElIsBordered = scrollEl.clientTop !== 0;
    const floatingIsScrollEl = floating === scrollEl;
    if (process.env.NODE_ENV !== "production") {
      if (!state.placement.startsWith("bottom")) {
        warn('`placement` side must be "bottom" when using the `inner`', "middleware.");
      }
    }
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...await offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
    };
    const overflow = await detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
    const refOverflow = await detectOverflow(nextArgs, {
      ...detectOverflowOptions,
      elementContext: "reference"
    });
    const diffY = max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
    const rounder = isScrollable ? (v) => v : round;
    const maxHeight = rounder(max(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - max(0, overflow.bottom)));
    scrollEl.style.maxHeight = maxHeight + "px";
    scrollEl.scrollTop = diffY;
    if (onFallbackChange) {
      const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * min(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
      ReactDOM.flushSync(() => onFallbackChange(shouldFallback));
    }
    if (overflowRef) {
      overflowRef.current = await detectOverflow(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
function useInnerOffset(context, props) {
  const {
    open,
    elements
  } = context;
  const {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = props;
  const onChange = useEffectEvent(unstable_onChange);
  const controlledScrollingRef = React.useRef(false);
  const prevScrollTopRef = React.useRef(null);
  const initialOverflowRef = React.useRef(null);
  React.useEffect(() => {
    if (!enabled) return;
    function onWheel(e2) {
      if (e2.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e2.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? "max" : "min";
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e2.preventDefault();
        ReactDOM.flushSync(() => {
          onChange((d2) => d2 + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener("wheel", onWheel);
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener("wheel", onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  const floating = React.useMemo(() => ({
    onKeyDown() {
      controlledScrollingRef.current = true;
    },
    onWheel() {
      controlledScrollingRef.current = false;
    },
    onPointerMove() {
      controlledScrollingRef.current = false;
    },
    onScroll() {
      const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
      if (!overflowRef.current || !el || !controlledScrollingRef.current) {
        return;
      }
      if (prevScrollTopRef.current !== null) {
        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
          ReactDOM.flushSync(() => onChange((d2) => d2 + scrollDiff));
        }
      }
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
      });
    }
  }), [elements.floating, onChange, overflowRef, scrollRef]);
  return React.useMemo(() => enabled ? {
    floating
  } : {}, [enabled, floating]);
}
let y = createContext({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
y.displayName = "FloatingContext";
let $ = createContext(null);
$.displayName = "PlacementContext";
function ye(e2) {
  return useMemo(() => e2 ? typeof e2 == "string" ? { to: e2 } : e2 : null, [e2]);
}
function Fe() {
  return useContext(y).setReference;
}
function Te() {
  let { getFloatingProps: e2, slot: t2 } = useContext(y);
  return useCallback((...n2) => Object.assign({}, e2(...n2), { "data-anchor": t2.anchor }), [e2, t2]);
}
function Re(e2 = null) {
  e2 === false && (e2 = null), typeof e2 == "string" && (e2 = { to: e2 });
  let t2 = useContext($), n2 = useMemo(() => e2, [JSON.stringify(e2, (l2, o4) => {
    var u2;
    return (u2 = o4 == null ? void 0 : o4.outerHTML) != null ? u2 : o4;
  })]);
  n$6(() => {
    t2 == null || t2(n2 != null ? n2 : null);
  }, [t2, n2]);
  let r2 = useContext(y);
  return useMemo(() => [r2.setFloating, e2 ? r2.styles : {}], [r2.setFloating, e2, r2.styles]);
}
let D$2 = 4;
function Ae({ children: e2, enabled: t2 = true }) {
  let [n2, r2] = useState(null), [l2, o4] = useState(0), u2 = useRef(null), [f2, s2] = useState(null);
  ce(f2);
  let i2 = t2 && n2 !== null && f2 !== null, { to: F2 = "bottom", gap: E3 = 0, offset: A2 = 0, padding: c2 = 0, inner: h2 } = ge(n2, f2), [a3, p2 = "center"] = F2.split(" ");
  n$6(() => {
    i2 && o4(0);
  }, [i2]);
  let { refs: b2, floatingStyles: S2, context: g2 } = useFloating({ open: i2, placement: a3 === "selection" ? p2 === "center" ? "bottom" : `bottom-${p2}` : p2 === "center" ? `${a3}` : `${a3}-${p2}`, strategy: "absolute", transform: false, middleware: [offset({ mainAxis: a3 === "selection" ? 0 : E3, crossAxis: A2 }), shift({ padding: c2 }), a3 !== "selection" && flip({ padding: c2 }), a3 === "selection" && h2 ? inner({ ...h2, padding: c2, overflowRef: u2, offset: l2, minItemsVisible: D$2, referenceOverflowThreshold: c2, onFallbackChange(P2) {
    var L2, N2;
    if (!P2) return;
    let d2 = g2.elements.floating;
    if (!d2) return;
    let M2 = parseFloat(getComputedStyle(d2).scrollPaddingBottom) || 0, I2 = Math.min(D$2, d2.childElementCount), W2 = 0, B2 = 0;
    for (let m2 of (N2 = (L2 = g2.elements.floating) == null ? void 0 : L2.childNodes) != null ? N2 : []) if (n$5(m2)) {
      let x2 = m2.offsetTop, k2 = x2 + m2.clientHeight + M2, H2 = d2.scrollTop, U2 = H2 + d2.clientHeight;
      if (x2 >= H2 && k2 <= U2) I2--;
      else {
        B2 = Math.max(0, Math.min(k2, U2) - Math.max(x2, H2)), W2 = m2.clientHeight;
        break;
      }
    }
    I2 >= 1 && o4((m2) => {
      let x2 = W2 * I2 - B2 + M2;
      return m2 >= x2 ? m2 : x2;
    });
  } }) : null, size({ padding: c2, apply({ availableWidth: P2, availableHeight: d2, elements: M2 }) {
    Object.assign(M2.floating.style, { overflow: "auto", maxWidth: `${P2}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${d2}px)` });
  } })].filter(Boolean), whileElementsMounted: autoUpdate }), [w2 = a3, V2 = p2] = g2.placement.split("-");
  a3 === "selection" && (w2 = "selection");
  let G2 = useMemo(() => ({ anchor: [w2, V2].filter(Boolean).join(" ") }), [w2, V2]), K2 = useInnerOffset(g2, { overflowRef: u2, onChange: o4 }), { getReferenceProps: Q2, getFloatingProps: X2 } = useInteractions([K2]), Y = o$6((P2) => {
    s2(P2), b2.setFloating(P2);
  });
  return React.createElement($.Provider, { value: r2 }, React.createElement(y.Provider, { value: { setFloating: Y, setReference: b2.setReference, styles: S2, getReferenceProps: Q2, getFloatingProps: X2, slot: G2 } }, e2));
}
function ce(e2) {
  n$6(() => {
    if (!e2) return;
    let t2 = new MutationObserver(() => {
      let n2 = window.getComputedStyle(e2).maxHeight, r2 = parseFloat(n2);
      if (isNaN(r2)) return;
      let l2 = parseInt(n2);
      isNaN(l2) || r2 !== l2 && (e2.style.maxHeight = `${Math.ceil(r2)}px`);
    });
    return t2.observe(e2, { attributes: true, attributeFilter: ["style"] }), () => {
      t2.disconnect();
    };
  }, [e2]);
}
function ge(e2, t2) {
  var o4, u2, f2;
  let n2 = O$1((o4 = e2 == null ? void 0 : e2.gap) != null ? o4 : "var(--anchor-gap, 0)", t2), r2 = O$1((u2 = e2 == null ? void 0 : e2.offset) != null ? u2 : "var(--anchor-offset, 0)", t2), l2 = O$1((f2 = e2 == null ? void 0 : e2.padding) != null ? f2 : "var(--anchor-padding, 0)", t2);
  return { ...e2, gap: n2, offset: r2, padding: l2 };
}
function O$1(e2, t2, n2 = void 0) {
  let r2 = p$4(), l2 = o$6((s2, i2) => {
    if (s2 == null) return [n2, null];
    if (typeof s2 == "number") return [s2, null];
    if (typeof s2 == "string") {
      if (!i2) return [n2, null];
      let F2 = J$1(s2, i2);
      return [F2, (E3) => {
        let A2 = q$1(s2);
        {
          let c2 = A2.map((h2) => window.getComputedStyle(i2).getPropertyValue(h2));
          r2.requestAnimationFrame(function h2() {
            r2.nextFrame(h2);
            let a3 = false;
            for (let [b2, S2] of A2.entries()) {
              let g2 = window.getComputedStyle(i2).getPropertyValue(S2);
              if (c2[b2] !== g2) {
                c2[b2] = g2, a3 = true;
                break;
              }
            }
            if (!a3) return;
            let p2 = J$1(s2, i2);
            F2 !== p2 && (E3(p2), F2 = p2);
          });
        }
        return r2.dispose;
      }];
    }
    return [n2, null];
  }), o4 = useMemo(() => l2(e2, t2)[0], [e2, t2]), [u2 = o4, f2] = useState();
  return n$6(() => {
    let [s2, i2] = l2(e2, t2);
    if (f2(s2), !!i2) return i2(f2);
  }, [e2, t2]), u2;
}
function q$1(e2) {
  let t2 = /var\((.*)\)/.exec(e2);
  if (t2) {
    let n2 = t2[1].indexOf(",");
    if (n2 === -1) return [t2[1]];
    let r2 = t2[1].slice(0, n2).trim(), l2 = t2[1].slice(n2 + 1).trim();
    return l2 ? [r2, ...q$1(l2)] : [r2];
  }
  return [];
}
function J$1(e2, t2) {
  let n2 = document.createElement("div");
  t2.appendChild(n2), n2.style.setProperty("margin-top", "0px", "important"), n2.style.setProperty("margin-top", e2, "important");
  let r2 = parseFloat(window.getComputedStyle(n2).marginTop) || 0;
  return t2.removeChild(n2), r2;
}
function f$1({ children: o4, freeze: e2 }) {
  let n2 = l$1(e2, o4);
  return React__default.createElement(React__default.Fragment, null, n2);
}
function l$1(o4, e2) {
  let [n2, t2] = useState(e2);
  return !o4 && n2 !== e2 && t2(e2), o4 ? n2 : e2;
}
let n$1 = createContext(null);
n$1.displayName = "OpenClosedContext";
var i = ((e2) => (e2[e2.Open = 1] = "Open", e2[e2.Closed = 2] = "Closed", e2[e2.Closing = 4] = "Closing", e2[e2.Opening = 8] = "Opening", e2))(i || {});
function u$2() {
  return useContext(n$1);
}
function c$4({ value: o4, children: t2 }) {
  return React__default.createElement(n$1.Provider, { value: o4 }, t2);
}
function t(n2) {
  function e2() {
    document.readyState !== "loading" && (n2(), document.removeEventListener("DOMContentLoaded", e2));
  }
  typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e2), e2());
}
let n = [];
t(() => {
  function e2(t2) {
    if (!i$4(t2.target) || t2.target === document.body || n[0] === t2.target) return;
    let r2 = t2.target;
    r2 = r2.closest(f$4), n.unshift(r2 != null ? r2 : t2.target), n = n.filter((o4) => o4 != null && o4.isConnected), n.splice(10);
  }
  window.addEventListener("click", e2, { capture: true }), window.addEventListener("mousedown", e2, { capture: true }), window.addEventListener("focus", e2, { capture: true }), document.body.addEventListener("click", e2, { capture: true }), document.body.addEventListener("mousedown", e2, { capture: true }), document.body.addEventListener("focus", e2, { capture: true });
});
function u$1(l2) {
  throw new Error("Unexpected object: " + l2);
}
var c$3 = ((i2) => (i2[i2.First = 0] = "First", i2[i2.Previous = 1] = "Previous", i2[i2.Next = 2] = "Next", i2[i2.Last = 3] = "Last", i2[i2.Specific = 4] = "Specific", i2[i2.Nothing = 5] = "Nothing", i2))(c$3 || {});
function f(l2, n2) {
  let t2 = n2.resolveItems();
  if (t2.length <= 0) return null;
  let r2 = n2.resolveActiveIndex(), s2 = r2 != null ? r2 : -1;
  switch (l2.focus) {
    case 0: {
      for (let e2 = 0; e2 < t2.length; ++e2) if (!n2.resolveDisabled(t2[e2], e2, t2)) return e2;
      return r2;
    }
    case 1: {
      s2 === -1 && (s2 = t2.length);
      for (let e2 = s2 - 1; e2 >= 0; --e2) if (!n2.resolveDisabled(t2[e2], e2, t2)) return e2;
      return r2;
    }
    case 2: {
      for (let e2 = s2 + 1; e2 < t2.length; ++e2) if (!n2.resolveDisabled(t2[e2], e2, t2)) return e2;
      return r2;
    }
    case 3: {
      for (let e2 = t2.length - 1; e2 >= 0; --e2) if (!n2.resolveDisabled(t2[e2], e2, t2)) return e2;
      return r2;
    }
    case 4: {
      for (let e2 = 0; e2 < t2.length; ++e2) if (n2.resolveId(t2[e2], e2, t2) === l2.id) return e2;
      return r2;
    }
    case 5:
      return null;
    default:
      u$1(l2);
  }
}
var g$1 = ((f2) => (f2[f2.Left = 0] = "Left", f2[f2.Right = 2] = "Right", f2))(g$1 || {});
function c$2(t2) {
  let r2 = o$6(t2), e2 = useRef(false);
  useEffect(() => (e2.current = false, () => {
    e2.current = true, t$5(() => {
      e2.current && r2();
    });
  }), [r2]);
}
function s() {
  let r2 = typeof document == "undefined";
  return "useSyncExternalStore" in React ? ((o4) => o4.useSyncExternalStore)(React)(() => () => {
  }, () => false, () => !r2) : false;
}
function l() {
  let r2 = s(), [e2, n2] = React.useState(s$6.isHandoffComplete);
  return e2 && s$6.isHandoffComplete === false && n2(false), React.useEffect(() => {
    e2 !== true && n2(true);
  }, [e2]), React.useEffect(() => s$6.handoff(), []), r2 ? false : e2;
}
let e = createContext(false);
function a2() {
  return useContext(e);
}
function I$1(e2) {
  let l2 = a2(), o4 = useContext(H$1), [r2, u2] = useState(() => {
    var i2;
    if (!l2 && o4 !== null) return (i2 = o4.current) != null ? i2 : null;
    if (s$6.isServer) return null;
    let t2 = e2 == null ? void 0 : e2.getElementById("headlessui-portal-root");
    if (t2) return t2;
    if (e2 === null) return null;
    let a3 = e2.createElement("div");
    return a3.setAttribute("id", "headlessui-portal-root"), e2.body.appendChild(a3);
  });
  return useEffect(() => {
    r2 !== null && (e2 != null && e2.body.contains(r2) || e2 == null || e2.body.appendChild(r2));
  }, [r2, e2]), useEffect(() => {
    l2 || o4 !== null && u2(o4.current);
  }, [o4, u2, l2]), r2;
}
let M$1 = Fragment$1, D$1 = K(function(l$12, o4) {
  let { ownerDocument: r2 = null, ...u2 } = l$12, t2 = useRef(null), a3 = y$5(T$3((s2) => {
    t2.current = s2;
  }), o4), i2 = n$2(t2), f2 = r2 != null ? r2 : i2, p2 = I$1(f2), [n2] = useState(() => {
    var s2;
    return s$6.isServer ? null : (s2 = f2 == null ? void 0 : f2.createElement("div")) != null ? s2 : null;
  }), P2 = useContext(g), O2 = l();
  n$6(() => {
    !p2 || !n2 || p2.contains(n2) || (n2.setAttribute("data-headlessui-portal", ""), p2.appendChild(n2));
  }, [p2, n2]), n$6(() => {
    if (n2 && P2) return P2.register(n2);
  }, [P2, n2]), c$2(() => {
    var s2;
    !p2 || !n2 || (o$4(n2) && p2.contains(n2) && p2.removeChild(n2), p2.childNodes.length <= 0 && ((s2 = p2.parentElement) == null || s2.removeChild(p2)));
  });
  let b2 = L$3();
  return O2 ? !p2 || !n2 ? null : createPortal(b2({ ourProps: { ref: a3 }, theirProps: u2, slot: {}, defaultTag: M$1, name: "Portal" }), n2) : null;
});
function J(e2, l2) {
  let o4 = y$5(l2), { enabled: r2 = true, ownerDocument: u2, ...t2 } = e2, a3 = L$3();
  return r2 ? React__default.createElement(D$1, { ...t2, ownerDocument: u2, ref: o4 }) : a3({ ourProps: { ref: o4 }, theirProps: t2, slot: {}, defaultTag: M$1, name: "Portal" });
}
let X = Fragment$1, H$1 = createContext(null);
function k(e2, l2) {
  let { target: o4, ...r2 } = e2, t2 = { ref: y$5(l2) }, a3 = L$3();
  return React__default.createElement(H$1.Provider, { value: o4 }, a3({ ourProps: t2, theirProps: r2, defaultTag: X, name: "Popover.Group" }));
}
let g = createContext(null);
let B = K(J), q = K(k), ne = Object.assign(B, { Group: q });
var S = Object.defineProperty;
var I = (t2, i2, e2) => i2 in t2 ? S(t2, i2, { enumerable: true, configurable: true, writable: true, value: e2 }) : t2[i2] = e2;
var c$1 = (t2, i2, e2) => (I(t2, typeof i2 != "symbol" ? i2 + "" : i2, e2), e2);
var C = ((e2) => (e2[e2.Open = 0] = "Open", e2[e2.Closed = 1] = "Closed", e2))(C || {}), M = ((e2) => (e2[e2.Single = 0] = "Single", e2[e2.Multi = 1] = "Multi", e2))(M || {}), F = ((n2) => (n2[n2.Pointer = 0] = "Pointer", n2[n2.Focus = 1] = "Focus", n2[n2.Other = 2] = "Other", n2))(F || {}), _$1 = ((l2) => (l2[l2.OpenCombobox = 0] = "OpenCombobox", l2[l2.CloseCombobox = 1] = "CloseCombobox", l2[l2.GoToOption = 2] = "GoToOption", l2[l2.SetTyping = 3] = "SetTyping", l2[l2.RegisterOption = 4] = "RegisterOption", l2[l2.UnregisterOption = 5] = "UnregisterOption", l2[l2.DefaultToFirstOption = 6] = "DefaultToFirstOption", l2[l2.SetActivationTrigger = 7] = "SetActivationTrigger", l2[l2.UpdateVirtualConfiguration = 8] = "UpdateVirtualConfiguration", l2[l2.SetInputElement = 9] = "SetInputElement", l2[l2.SetButtonElement = 10] = "SetButtonElement", l2[l2.SetOptionsElement = 11] = "SetOptionsElement", l2))(_$1 || {});
function T(t2, i2 = (e2) => e2) {
  let e2 = t2.activeOptionIndex !== null ? t2.options[t2.activeOptionIndex] : null, n2 = i2(t2.options.slice()), o4 = n2.length > 0 && n2[0].dataRef.current.order !== null ? n2.sort((u2, a3) => u2.dataRef.current.order - a3.dataRef.current.order) : P(n2, (u2) => u2.dataRef.current.domRef.current), r2 = e2 ? o4.indexOf(e2) : null;
  return r2 === -1 && (r2 = null), { options: o4, activeOptionIndex: r2 };
}
let D = { [1](t2) {
  var i2;
  return (i2 = t2.dataRef.current) != null && i2.disabled || t2.comboboxState === 1 ? t2 : { ...t2, activeOptionIndex: null, comboboxState: 1, isTyping: false, activationTrigger: 2, __demoMode: false };
}, [0](t2) {
  var i2, e2;
  if ((i2 = t2.dataRef.current) != null && i2.disabled || t2.comboboxState === 0) return t2;
  if ((e2 = t2.dataRef.current) != null && e2.value) {
    let n2 = t2.dataRef.current.calculateIndex(t2.dataRef.current.value);
    if (n2 !== -1) return { ...t2, activeOptionIndex: n2, comboboxState: 0, __demoMode: false };
  }
  return { ...t2, comboboxState: 0, __demoMode: false };
}, [3](t2, i2) {
  return t2.isTyping === i2.isTyping ? t2 : { ...t2, isTyping: i2.isTyping };
}, [2](t2, i2) {
  var r2, u2, a3, d2;
  if ((r2 = t2.dataRef.current) != null && r2.disabled || t2.optionsElement && !((u2 = t2.dataRef.current) != null && u2.optionsPropsRef.current.static) && t2.comboboxState === 1) return t2;
  if (t2.virtual) {
    let { options: p2, disabled: s2 } = t2.virtual, b2 = i2.focus === c$3.Specific ? i2.idx : f(i2, { resolveItems: () => p2, resolveActiveIndex: () => {
      var v, m2;
      return (m2 = (v = t2.activeOptionIndex) != null ? v : p2.findIndex((y2) => !s2(y2))) != null ? m2 : null;
    }, resolveDisabled: s2, resolveId() {
      throw new Error("Function not implemented.");
    } }), l2 = (a3 = i2.trigger) != null ? a3 : 2;
    return t2.activeOptionIndex === b2 && t2.activationTrigger === l2 ? t2 : { ...t2, activeOptionIndex: b2, activationTrigger: l2, isTyping: false, __demoMode: false };
  }
  let e2 = T(t2);
  if (e2.activeOptionIndex === null) {
    let p2 = e2.options.findIndex((s2) => !s2.dataRef.current.disabled);
    p2 !== -1 && (e2.activeOptionIndex = p2);
  }
  let n2 = i2.focus === c$3.Specific ? i2.idx : f(i2, { resolveItems: () => e2.options, resolveActiveIndex: () => e2.activeOptionIndex, resolveId: (p2) => p2.id, resolveDisabled: (p2) => p2.dataRef.current.disabled }), o4 = (d2 = i2.trigger) != null ? d2 : 2;
  return t2.activeOptionIndex === n2 && t2.activationTrigger === o4 ? t2 : { ...t2, ...e2, isTyping: false, activeOptionIndex: n2, activationTrigger: o4, __demoMode: false };
}, [4]: (t2, i2) => {
  var r2, u2, a3, d2;
  if ((r2 = t2.dataRef.current) != null && r2.virtual) return { ...t2, options: [...t2.options, i2.payload] };
  let e2 = i2.payload, n2 = T(t2, (p2) => (p2.push(e2), p2));
  t2.activeOptionIndex === null && (a3 = (u2 = t2.dataRef.current).isSelected) != null && a3.call(u2, i2.payload.dataRef.current.value) && (n2.activeOptionIndex = n2.options.indexOf(e2));
  let o4 = { ...t2, ...n2, activationTrigger: 2 };
  return (d2 = t2.dataRef.current) != null && d2.__demoMode && t2.dataRef.current.value === void 0 && (o4.activeOptionIndex = 0), o4;
}, [5]: (t2, i2) => {
  var n2;
  if ((n2 = t2.dataRef.current) != null && n2.virtual) return { ...t2, options: t2.options.filter((o4) => o4.id !== i2.id) };
  let e2 = T(t2, (o4) => {
    let r2 = o4.findIndex((u2) => u2.id === i2.id);
    return r2 !== -1 && o4.splice(r2, 1), o4;
  });
  return { ...t2, ...e2, activationTrigger: 2 };
}, [6]: (t2, i2) => t2.defaultToFirstOption === i2.value ? t2 : { ...t2, defaultToFirstOption: i2.value }, [7]: (t2, i2) => t2.activationTrigger === i2.trigger ? t2 : { ...t2, activationTrigger: i2.trigger }, [8]: (t2, i2) => {
  var n2, o4;
  if (t2.virtual === null) return { ...t2, virtual: { options: i2.options, disabled: (n2 = i2.disabled) != null ? n2 : () => false } };
  if (t2.virtual.options === i2.options && t2.virtual.disabled === i2.disabled) return t2;
  let e2 = t2.activeOptionIndex;
  if (t2.activeOptionIndex !== null) {
    let r2 = i2.options.indexOf(t2.virtual.options[t2.activeOptionIndex]);
    r2 !== -1 ? e2 = r2 : e2 = null;
  }
  return { ...t2, activeOptionIndex: e2, virtual: { options: i2.options, disabled: (o4 = i2.disabled) != null ? o4 : () => false } };
}, [9]: (t2, i2) => t2.inputElement === i2.element ? t2 : { ...t2, inputElement: i2.element }, [10]: (t2, i2) => t2.buttonElement === i2.element ? t2 : { ...t2, buttonElement: i2.element }, [11]: (t2, i2) => t2.optionsElement === i2.element ? t2 : { ...t2, optionsElement: i2.element } };
class O extends E$2 {
  constructor(e2) {
    super(e2);
    c$1(this, "actions", { onChange: (e3) => {
      let { onChange: n2, compare: o4, mode: r2, value: u2 } = this.state.dataRef.current;
      return u$a(r2, { [0]: () => n2 == null ? void 0 : n2(e3), [1]: () => {
        let a3 = u2.slice(), d2 = a3.findIndex((p2) => o4(p2, e3));
        return d2 === -1 ? a3.push(e3) : a3.splice(d2, 1), n2 == null ? void 0 : n2(a3);
      } });
    }, registerOption: (e3, n2) => (this.send({ type: 4, payload: { id: e3, dataRef: n2 } }), () => {
      this.state.activeOptionIndex === this.state.dataRef.current.calculateIndex(n2.current.value) && this.send({ type: 6, value: true }), this.send({ type: 5, id: e3 });
    }), goToOption: (e3, n2) => (this.send({ type: 6, value: false }), this.send({ type: 2, ...e3, trigger: n2 })), setIsTyping: (e3) => {
      this.send({ type: 3, isTyping: e3 });
    }, closeCombobox: () => {
      var e3, n2;
      this.send({ type: 1 }), this.send({ type: 6, value: false }), (n2 = (e3 = this.state.dataRef.current).onClose) == null || n2.call(e3);
    }, openCombobox: () => {
      this.send({ type: 0 }), this.send({ type: 6, value: true });
    }, setActivationTrigger: (e3) => {
      this.send({ type: 7, trigger: e3 });
    }, selectActiveOption: () => {
      let e3 = this.selectors.activeOptionIndex(this.state);
      if (e3 !== null) {
        if (this.actions.setIsTyping(false), this.state.virtual) this.actions.onChange(this.state.virtual.options[e3]);
        else {
          let { dataRef: n2 } = this.state.options[e3];
          this.actions.onChange(n2.current.value);
        }
        this.actions.goToOption({ focus: c$3.Specific, idx: e3 });
      }
    }, setInputElement: (e3) => {
      this.send({ type: 9, element: e3 });
    }, setButtonElement: (e3) => {
      this.send({ type: 10, element: e3 });
    }, setOptionsElement: (e3) => {
      this.send({ type: 11, element: e3 });
    } });
    c$1(this, "selectors", { activeDescendantId: (e3) => {
      var o4, r2;
      let n2 = this.selectors.activeOptionIndex(e3);
      if (n2 !== null) return e3.virtual ? (r2 = e3.options.find((u2) => !u2.dataRef.current.disabled && e3.dataRef.current.compare(u2.dataRef.current.value, e3.virtual.options[n2]))) == null ? void 0 : r2.id : (o4 = e3.options[n2]) == null ? void 0 : o4.id;
    }, activeOptionIndex: (e3) => {
      if (e3.defaultToFirstOption && e3.activeOptionIndex === null && (e3.virtual ? e3.virtual.options.length > 0 : e3.options.length > 0)) {
        if (e3.virtual) {
          let { options: o4, disabled: r2 } = e3.virtual, u2 = o4.findIndex((a3) => {
            var d2;
            return !((d2 = r2 == null ? void 0 : r2(a3)) != null && d2);
          });
          if (u2 !== -1) return u2;
        }
        let n2 = e3.options.findIndex((o4) => !o4.dataRef.current.disabled);
        if (n2 !== -1) return n2;
      }
      return e3.activeOptionIndex;
    }, activeOption: (e3) => {
      var o4, r2;
      let n2 = this.selectors.activeOptionIndex(e3);
      return n2 === null ? null : e3.virtual ? e3.virtual.options[n2 != null ? n2 : 0] : (r2 = (o4 = e3.options[n2]) == null ? void 0 : o4.dataRef.current.value) != null ? r2 : null;
    }, isActive: (e3, n2, o4) => {
      var u2;
      let r2 = this.selectors.activeOptionIndex(e3);
      return r2 === null ? false : e3.virtual ? r2 === e3.dataRef.current.calculateIndex(n2) : ((u2 = e3.options[r2]) == null ? void 0 : u2.id) === o4;
    }, shouldScrollIntoView: (e3, n2, o4) => !(e3.virtual || e3.__demoMode || e3.comboboxState !== 0 || e3.activationTrigger === 0 || !this.selectors.isActive(e3, n2, o4)) });
    {
      let n2 = this.state.id, o4 = x$1.get(null);
      this.disposables.add(o4.on(k$3.Push, (r2) => {
        !o4.selectors.isTop(r2, n2) && this.state.comboboxState === 0 && this.actions.closeCombobox();
      })), this.on(0, () => o4.actions.push(n2)), this.on(1, () => o4.actions.pop(n2));
    }
  }
  static new({ id: e2, virtual: n2 = null, __demoMode: o4 = false }) {
    var r2;
    return new O({ id: e2, dataRef: { current: {} }, comboboxState: o4 ? 0 : 1, isTyping: false, options: [], virtual: n2 ? { options: n2.options, disabled: (r2 = n2.disabled) != null ? r2 : () => false } : null, activeOptionIndex: null, activationTrigger: 2, inputElement: null, buttonElement: null, optionsElement: null, __demoMode: o4 });
  }
  reduce(e2, n2) {
    return u$a(n2.type, D, e2, n2);
  }
}
const u = createContext(null);
function p(n2) {
  let o4 = useContext(u);
  if (o4 === null) {
    let e2 = new Error(`<${n2} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(e2, b), e2;
  }
  return o4;
}
function b({ id: n2, virtual: o4 = null, __demoMode: e2 = false }) {
  let t2 = useMemo(() => O.new({ id: n2, virtual: o4, __demoMode: e2 }), []);
  return c$2(() => t2.dispose()), t2;
}
let de = createContext(null);
de.displayName = "ComboboxDataContext";
function ae(C2) {
  let h2 = useContext(de);
  if (h2 === null) {
    let e2 = new Error(`<${C2} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(e2, ae), e2;
  }
  return h2;
}
let Me = createContext(null);
function vo(C2) {
  let h2 = p("VirtualProvider"), e2 = ae("VirtualProvider"), { options: o4 } = e2.virtual, A2 = S$2(h2, (a3) => a3.optionsElement), [R2, v] = useMemo(() => {
    let a3 = A2;
    if (!a3) return [0, 0];
    let u2 = window.getComputedStyle(a3);
    return [parseFloat(u2.paddingBlockStart || u2.paddingTop), parseFloat(u2.paddingBlockEnd || u2.paddingBottom)];
  }, [A2]), T2 = useVirtualizer({ enabled: o4.length !== 0, scrollPaddingStart: R2, scrollPaddingEnd: v, count: o4.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return h2.state.optionsElement;
  }, overscan: 12 }), [I2, m2] = useState(0);
  n$6(() => {
    m2((a3) => a3 + 1);
  }, [o4]);
  let g2 = T2.getVirtualItems(), n2 = S$2(h2, (a3) => a3.activationTrigger === F.Pointer), f2 = S$2(h2, h2.selectors.activeOptionIndex);
  return g2.length === 0 ? null : React__default.createElement(Me.Provider, { value: T2 }, React__default.createElement("div", { style: { position: "relative", width: "100%", height: `${T2.getTotalSize()}px` }, ref: (a3) => {
    a3 && (n2 || f2 !== null && o4.length > f2 && T2.scrollToIndex(f2));
  } }, g2.map((a3) => {
    var u2;
    return React__default.createElement(Fragment$1, { key: a3.key }, React__default.cloneElement((u2 = C2.children) == null ? void 0 : u2.call(C2, { ...C2.slot, option: o4[a3.index] }), { key: `${I2}-${a3.key}`, "data-index": a3.index, "aria-setsize": o4.length, "aria-posinset": a3.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${a3.start}px)`, overflowAnchor: "none" } }));
  })));
}
let Po = Fragment$1;
function Eo(C$12, h2) {
  let e2 = useId$1(), o4 = a$a(), { value: A2, defaultValue: R2, onChange: v, form: T2, name: I2, by: m2, invalid: g2 = false, disabled: n2 = o4 || false, onClose: f2, __demoMode: a3 = false, multiple: u$12 = false, immediate: S2 = false, virtual: d2 = null, nullable: k2, ...W2 } = C$12, y2 = l$5(R2), [x2 = u$12 ? [] : void 0, P2] = T$4(A2, v, y2), b$12 = b({ id: e2, virtual: d2, __demoMode: a3 }), G2 = useRef({ static: false, hold: false }), _2 = u$6(m2), z = o$6((s2) => d2 ? m2 === null ? d2.options.indexOf(s2) : d2.options.findIndex((c2) => _2(c2, s2)) : b$12.state.options.findIndex((c2) => _2(c2.dataRef.current.value, s2))), U2 = useCallback((s2) => u$a(r2.mode, { [M.Multi]: () => x2.some((c2) => _2(c2, s2)), [M.Single]: () => _2(x2, s2) }), [x2]), w2 = S$2(b$12, (s2) => s2.virtual), J2 = o$6(() => f2 == null ? void 0 : f2()), r2 = useMemo(() => ({ __demoMode: a3, immediate: S2, optionsPropsRef: G2, value: x2, defaultValue: y2, disabled: n2, invalid: g2, mode: u$12 ? M.Multi : M.Single, virtual: d2 ? w2 : null, onChange: P2, isSelected: U2, calculateIndex: z, compare: _2, onClose: J2 }), [x2, y2, n2, g2, u$12, P2, U2, a3, b$12, d2, w2, J2]);
  n$6(() => {
    var s2;
    d2 && b$12.send({ type: _$1.UpdateVirtualConfiguration, options: d2.options, disabled: (s2 = d2.disabled) != null ? s2 : null });
  }, [d2, d2 == null ? void 0 : d2.options, d2 == null ? void 0 : d2.disabled]), n$6(() => {
    b$12.state.dataRef.current = r2;
  }, [r2]);
  let [M$12, X2, i$12, H2] = S$2(b$12, (s2) => [s2.comboboxState, s2.buttonElement, s2.inputElement, s2.optionsElement]), j2 = x$1.get(null), q2 = S$2(j2, useCallback((s2) => j2.selectors.isTop(s2, e2), [j2, e2]));
  k$2(q2, [X2, i$12, H2], () => b$12.actions.closeCombobox());
  let Q$1 = S$2(b$12, b$12.selectors.activeOptionIndex), $2 = S$2(b$12, b$12.selectors.activeOption), be = useMemo(() => ({ open: M$12 === C.Open, disabled: n2, invalid: g2, activeIndex: Q$1, activeOption: $2, value: x2 }), [r2, n2, x2, g2, $2, M$12]), [Y, te] = Q(), t2 = h2 === null ? {} : { ref: h2 }, B2 = useCallback(() => {
    if (y2 !== void 0) return P2 == null ? void 0 : P2(y2);
  }, [P2, y2]), E3 = L$3();
  return React__default.createElement(te, { value: Y, props: { htmlFor: i$12 == null ? void 0 : i$12.id }, slot: { open: M$12 === C.Open, disabled: n2 } }, React__default.createElement(Ae, null, React__default.createElement(de.Provider, { value: r2 }, React__default.createElement(u.Provider, { value: b$12 }, React__default.createElement(c$4, { value: u$a(M$12, { [C.Open]: i.Open, [C.Closed]: i.Closed }) }, I2 != null && React__default.createElement(j$3, { disabled: n2, data: x2 != null ? { [I2]: x2 } : {}, form: T2, onReset: B2 }), E3({ ourProps: t2, theirProps: W2, slot: be, defaultTag: Po, name: "Combobox" }))))));
}
let Oo = "input";
function ho(C$12, h2) {
  var Y, te;
  let e2 = p("Combobox.Input"), o4 = ae("Combobox.Input"), A2 = useId$1(), R2 = u$9(), { id: v = R2 || `headlessui-combobox-input-${A2}`, onChange: T2, displayValue: I2, disabled: m$12 = o4.disabled || false, autoFocus: g2 = false, type: n$12 = "text", ...f2 } = C$12, [a3] = S$2(e2, (t2) => [t2.inputElement]), u2 = useRef(null), S2 = y$5(u2, h2, Fe(), e2.actions.setInputElement), d2 = n$2(a3), [k2, W2] = S$2(e2, (t2) => [t2.comboboxState, t2.isTyping]), y2 = p$4(), x2 = o$6(() => {
    e2.actions.onChange(null), e2.state.optionsElement && (e2.state.optionsElement.scrollTop = 0), e2.actions.goToOption({ focus: c$3.Nothing });
  }), P2 = useMemo(() => {
    var t2;
    return typeof I2 == "function" && o4.value !== void 0 ? (t2 = I2(o4.value)) != null ? t2 : "" : typeof o4.value == "string" ? o4.value : "";
  }, [o4.value, I2]);
  m(([t2, B2], [E3, s2]) => {
    if (e2.state.isTyping) return;
    let c2 = u2.current;
    c2 && ((s2 === C.Open && B2 === C.Closed || t2 !== E3) && (c2.value = t2), requestAnimationFrame(() => {
      if (e2.state.isTyping || !c2 || (d2 == null ? void 0 : d2.activeElement) !== c2) return;
      let { selectionStart: p2, selectionEnd: ne2 } = c2;
      Math.abs((ne2 != null ? ne2 : 0) - (p2 != null ? p2 : 0)) === 0 && p2 === 0 && c2.setSelectionRange(c2.value.length, c2.value.length);
    }));
  }, [P2, k2, d2, W2]), m(([t2], [B2]) => {
    if (t2 === C.Open && B2 === C.Closed) {
      if (e2.state.isTyping) return;
      let E3 = u2.current;
      if (!E3) return;
      let s2 = E3.value, { selectionStart: c2, selectionEnd: p2, selectionDirection: ne2 } = E3;
      E3.value = "", E3.value = s2, ne2 !== null ? E3.setSelectionRange(c2, p2, ne2) : E3.setSelectionRange(c2, p2);
    }
  }, [k2]);
  let b2 = useRef(false), G2 = o$6(() => {
    b2.current = true;
  }), _2 = o$6(() => {
    y2.nextFrame(() => {
      b2.current = false;
    });
  }), z = o$6((t2) => {
    switch (e2.actions.setIsTyping(true), t2.key) {
      case o$3.Enter:
        if (e2.state.comboboxState !== C.Open || b2.current) return;
        if (t2.preventDefault(), t2.stopPropagation(), e2.selectors.activeOptionIndex(e2.state) === null) {
          e2.actions.closeCombobox();
          return;
        }
        e2.actions.selectActiveOption(), o4.mode === M.Single && e2.actions.closeCombobox();
        break;
      case o$3.ArrowDown:
        return t2.preventDefault(), t2.stopPropagation(), u$a(e2.state.comboboxState, { [C.Open]: () => e2.actions.goToOption({ focus: c$3.Next }), [C.Closed]: () => e2.actions.openCombobox() });
      case o$3.ArrowUp:
        return t2.preventDefault(), t2.stopPropagation(), u$a(e2.state.comboboxState, { [C.Open]: () => e2.actions.goToOption({ focus: c$3.Previous }), [C.Closed]: () => {
          flushSync(() => e2.actions.openCombobox()), o4.value || e2.actions.goToOption({ focus: c$3.Last });
        } });
      case o$3.Home:
        if (t2.shiftKey) break;
        return t2.preventDefault(), t2.stopPropagation(), e2.actions.goToOption({ focus: c$3.First });
      case o$3.PageUp:
        return t2.preventDefault(), t2.stopPropagation(), e2.actions.goToOption({ focus: c$3.First });
      case o$3.End:
        if (t2.shiftKey) break;
        return t2.preventDefault(), t2.stopPropagation(), e2.actions.goToOption({ focus: c$3.Last });
      case o$3.PageDown:
        return t2.preventDefault(), t2.stopPropagation(), e2.actions.goToOption({ focus: c$3.Last });
      case o$3.Escape:
        return e2.state.comboboxState !== C.Open ? void 0 : (t2.preventDefault(), e2.state.optionsElement && !o4.optionsPropsRef.current.static && t2.stopPropagation(), o4.mode === M.Single && o4.value === null && x2(), e2.actions.closeCombobox());
      case o$3.Tab:
        if (e2.state.comboboxState !== C.Open) return;
        o4.mode === M.Single && e2.state.activationTrigger !== F.Focus && e2.actions.selectActiveOption(), e2.actions.closeCombobox();
        break;
    }
  }), U2 = o$6((t2) => {
    T2 == null || T2(t2), o4.mode === M.Single && t2.target.value === "" && x2(), e2.actions.openCombobox();
  }), w2 = o$6((t2) => {
    var E3, s2, c2;
    let B2 = (E3 = t2.relatedTarget) != null ? E3 : n.find((p2) => p2 !== t2.currentTarget);
    if (!((s2 = e2.state.optionsElement) != null && s2.contains(B2)) && !((c2 = e2.state.buttonElement) != null && c2.contains(B2)) && e2.state.comboboxState === C.Open) return t2.preventDefault(), o4.mode === M.Single && o4.value === null && x2(), e2.actions.closeCombobox();
  }), J2 = o$6((t2) => {
    var E3, s2, c2;
    let B2 = (E3 = t2.relatedTarget) != null ? E3 : n.find((p2) => p2 !== t2.currentTarget);
    (s2 = e2.state.buttonElement) != null && s2.contains(B2) || (c2 = e2.state.optionsElement) != null && c2.contains(B2) || o4.disabled || o4.immediate && e2.state.comboboxState !== C.Open && y2.microTask(() => {
      flushSync(() => e2.actions.openCombobox()), e2.actions.setActivationTrigger(F.Focus);
    });
  }), r2 = N(), M$12 = U$1(), { isFocused: X2, focusProps: i2 } = $f7dceffc5ad7768b$export$4e328f61c538687f({ autoFocus: g2 }), { isHovered: H2, hoverProps: j2 } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled: m$12 }), q2 = S$2(e2, (t2) => t2.optionsElement), Q2 = useMemo(() => ({ open: k2 === C.Open, disabled: m$12, invalid: o4.invalid, hover: H2, focus: X2, autofocus: g2 }), [o4, H2, X2, g2, m$12, o4.invalid]), $2 = _$3({ ref: S2, id: v, role: "combobox", type: n$12, "aria-controls": q2 == null ? void 0 : q2.id, "aria-expanded": k2 === C.Open, "aria-activedescendant": S$2(e2, e2.selectors.activeDescendantId), "aria-labelledby": r2, "aria-describedby": M$12, "aria-autocomplete": "list", defaultValue: (te = (Y = C$12.defaultValue) != null ? Y : o4.defaultValue !== void 0 ? I2 == null ? void 0 : I2(o4.defaultValue) : null) != null ? te : o4.defaultValue, disabled: m$12 || void 0, autoFocus: g2, onCompositionStart: G2, onCompositionEnd: _2, onKeyDown: z, onChange: U2, onFocus: J2, onBlur: w2 }, i2, j2);
  return L$3()({ ourProps: $2, theirProps: f2, slot: Q2, defaultTag: Oo, name: "Combobox.Input" });
}
let Ao = "button";
function Io(C$12, h2) {
  let e2 = p("Combobox.Button"), o4 = ae("Combobox.Button"), [A2, R2] = useState(null), v = y$5(h2, R2, e2.actions.setButtonElement), T2 = useId$1(), { id: I2 = `headlessui-combobox-button-${T2}`, disabled: m2 = o4.disabled || false, autoFocus: g2 = false, ...n2 } = C$12, [f2, a3, u2] = S$2(e2, (r2) => [r2.comboboxState, r2.inputElement, r2.optionsElement]), S2 = f$3(a3), d2 = f2 === C.Open;
  k$1(d2, { trigger: A2, action: useCallback((r2) => {
    if (A2 != null && A2.contains(r2.target)) return g$2.Ignore;
    if (a3 != null && a3.contains(r2.target)) return g$2.Ignore;
    let M2 = r2.target.closest('[role="option"]:not([data-disabled])');
    return n$5(M2) ? g$2.Select(M2) : u2 != null && u2.contains(r2.target) ? g$2.Ignore : g$2.Close;
  }, [A2, a3, u2]), close: e2.actions.closeCombobox, select: e2.actions.selectActiveOption });
  let k2 = o$6((r2) => {
    switch (r2.key) {
      case o$3.Space:
      case o$3.Enter:
        r2.preventDefault(), r2.stopPropagation(), e2.state.comboboxState === C.Closed && flushSync(() => e2.actions.openCombobox()), S2();
        return;
      case o$3.ArrowDown:
        r2.preventDefault(), r2.stopPropagation(), e2.state.comboboxState === C.Closed && (flushSync(() => e2.actions.openCombobox()), e2.state.dataRef.current.value || e2.actions.goToOption({ focus: c$3.First })), S2();
        return;
      case o$3.ArrowUp:
        r2.preventDefault(), r2.stopPropagation(), e2.state.comboboxState === C.Closed && (flushSync(() => e2.actions.openCombobox()), e2.state.dataRef.current.value || e2.actions.goToOption({ focus: c$3.Last })), S2();
        return;
      case o$3.Escape:
        if (e2.state.comboboxState !== C.Open) return;
        r2.preventDefault(), e2.state.optionsElement && !o4.optionsPropsRef.current.static && r2.stopPropagation(), flushSync(() => e2.actions.closeCombobox()), S2();
        return;
      default:
        return;
    }
  }), W2 = o$6((r2) => {
    r2.preventDefault(), !s$3(r2.currentTarget) && (r2.button === g$1.Left && (e2.state.comboboxState === C.Open ? e2.actions.closeCombobox() : e2.actions.openCombobox()), S2());
  }), y2 = N([I2]), { isFocusVisible: x2, focusProps: P2 } = $f7dceffc5ad7768b$export$4e328f61c538687f({ autoFocus: g2 }), { isHovered: b2, hoverProps: G2 } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled: m2 }), { pressed: _2, pressProps: z } = w$2({ disabled: m2 }), U2 = useMemo(() => ({ open: f2 === C.Open, active: _2 || f2 === C.Open, disabled: m2, invalid: o4.invalid, value: o4.value, hover: b2, focus: x2 }), [o4, b2, x2, _2, m2, f2]), w2 = _$3({ ref: v, id: I2, type: e$1(C$12, A2), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": u2 == null ? void 0 : u2.id, "aria-expanded": f2 === C.Open, "aria-labelledby": y2, disabled: m2 || void 0, autoFocus: g2, onPointerDown: W2, onKeyDown: k2 }, P2, G2, z);
  return L$3()({ ourProps: w2, theirProps: n2, slot: U2, defaultTag: Ao, name: "Combobox.Button" });
}
let Ro = "div", Do = O$2.RenderStrategy | O$2.Static;
function _o(C$12, h2) {
  var E3, s2, c2;
  let e2 = useId$1(), { id: o4 = `headlessui-combobox-options-${e2}`, hold: A2 = false, anchor: R$1, portal: v = false, modal: T2 = true, transition: I2 = false, ...m2 } = C$12, g2 = p("Combobox.Options"), n2 = ae("Combobox.Options"), f2 = ye(R$1);
  f2 && (v = true);
  let [a3, u2] = Re(f2), [S2, d2] = useState(null), k2 = Te(), W2 = y$5(h2, f2 ? a3 : null, g2.actions.setOptionsElement, d2), [y2, x$12, P2, b2, G2] = S$2(g2, (p2) => [p2.comboboxState, p2.inputElement, p2.buttonElement, p2.optionsElement, p2.activationTrigger]), _2 = n$2(x$12 || P2), z = n$2(b2), U2 = u$2(), [w2, J2] = x(I2, S2, U2 !== null ? (U2 & i.Open) === i.Open : y2 === C.Open);
  p$1(w2, x$12, g2.actions.closeCombobox);
  let r2 = n2.__demoMode ? false : T2 && y2 === C.Open;
  f$2(r2, z);
  let M$12 = n2.__demoMode ? false : T2 && y2 === C.Open;
  y$2(M$12, { allowed: useCallback(() => [x$12, P2, b2], [x$12, P2, b2]) }), n$6(() => {
    var p2;
    n2.optionsPropsRef.current.static = (p2 = C$12.static) != null ? p2 : false;
  }, [n2.optionsPropsRef, C$12.static]), n$6(() => {
    n2.optionsPropsRef.current.hold = A2;
  }, [n2.optionsPropsRef, A2]), F$1(y2 === C.Open, { container: b2, accept(p2) {
    return p2.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : p2.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(p2) {
    p2.setAttribute("role", "none");
  } });
  let X2 = N([P2 == null ? void 0 : P2.id]), i$12 = useMemo(() => ({ open: y2 === C.Open, option: void 0 }), [y2]), H2 = o$6(() => {
    g2.actions.setActivationTrigger(F.Pointer);
  }), j2 = o$6((p2) => {
    p2.preventDefault(), g2.actions.setActivationTrigger(F.Pointer);
  }), q2 = _$3(f2 ? k2() : {}, { "aria-labelledby": X2, role: "listbox", "aria-multiselectable": n2.mode === M.Multi ? true : void 0, id: o4, ref: W2, style: { ...m2.style, ...u2, "--input-width": d$2(x$12, true).width, "--button-width": d$2(P2, true).width }, onWheel: G2 === F.Pointer ? void 0 : H2, onMouseDown: j2, ...R(J2) }), Q2 = w2 && y2 === C.Closed, $2 = l$1(Q2, (E3 = n2.virtual) == null ? void 0 : E3.options), be = l$1(Q2, n2.value), Y = o$6((p2) => n2.compare(be, p2)), te = useMemo(() => {
    if (!n2.virtual) return n2;
    if ($2 === void 0) throw new Error("Missing `options` in virtual mode");
    return $2 !== n2.virtual.options ? { ...n2, virtual: { ...n2.virtual, options: $2 } } : n2;
  }, [n2, $2, (s2 = n2.virtual) == null ? void 0 : s2.options]);
  n2.virtual && Object.assign(m2, { children: React__default.createElement(de.Provider, { value: te }, React__default.createElement(vo, { slot: i$12 }, m2.children)) });
  let t2 = L$3(), B2 = useMemo(() => n2.mode === M.Multi ? n2 : { ...n2, isSelected: Y }, [n2, Y]);
  return React__default.createElement(ne, { enabled: v ? C$12.static || w2 : false, ownerDocument: _2 }, React__default.createElement(de.Provider, { value: B2 }, t2({ ourProps: q2, theirProps: { ...m2, children: React__default.createElement(f$1, { freeze: Q2 }, typeof m2.children == "function" ? (c2 = m2.children) == null ? void 0 : c2.call(m2, i$12) : m2.children) }, slot: i$12, defaultTag: Ro, features: Do, visible: w2, name: "Combobox.Options" })));
}
let Fo = "div";
function So(C2, h2) {
  var r2, M$12, X2;
  let e2 = ae("Combobox.Option"), o4 = p("Combobox.Option"), A2 = useId$1(), { id: R2 = `headlessui-combobox-option-${A2}`, value: v, disabled: T2 = (X2 = (M$12 = (r2 = e2.virtual) == null ? void 0 : r2.disabled) == null ? void 0 : M$12.call(r2, v)) != null ? X2 : false, order: I2 = null, ...m2 } = C2, [g2] = S$2(o4, (i2) => [i2.inputElement]), n2 = f$3(g2), f2 = S$2(o4, useCallback((i2) => o4.selectors.isActive(i2, v, R2), [v, R2])), a3 = e2.isSelected(v), u2 = useRef(null), S2 = s$5({ disabled: T2, value: v, domRef: u2, order: I2 }), d2 = useContext(Me), k2 = y$5(h2, u2, d2 ? d2.measureElement : null), W2 = o$6(() => {
    o4.actions.setIsTyping(false), o4.actions.onChange(v);
  });
  n$6(() => o4.actions.registerOption(R2, S2), [S2, R2]);
  let y2 = S$2(o4, useCallback((i2) => o4.selectors.shouldScrollIntoView(i2, v, R2), [v, R2]));
  n$6(() => {
    if (y2) return o$7().requestAnimationFrame(() => {
      var i2, H2;
      (H2 = (i2 = u2.current) == null ? void 0 : i2.scrollIntoView) == null || H2.call(i2, { block: "nearest" });
    });
  }, [y2, u2]);
  let x2 = o$6((i2) => {
    i2.preventDefault(), i2.button === g$1.Left && (T2 || (W2(), n$3() || requestAnimationFrame(() => n2()), e2.mode === M.Single && o4.actions.closeCombobox()));
  }), P2 = o$6(() => {
    if (T2) return o4.actions.goToOption({ focus: c$3.Nothing });
    let i2 = e2.calculateIndex(v);
    o4.actions.goToOption({ focus: c$3.Specific, idx: i2 });
  }), b2 = u$3(), G2 = o$6((i2) => b2.update(i2)), _2 = o$6((i2) => {
    if (!b2.wasMoved(i2) || T2 || f2) return;
    let H2 = e2.calculateIndex(v);
    o4.actions.goToOption({ focus: c$3.Specific, idx: H2 }, F.Pointer);
  }), z = o$6((i2) => {
    b2.wasMoved(i2) && (T2 || f2 && (e2.optionsPropsRef.current.hold || o4.actions.goToOption({ focus: c$3.Nothing })));
  }), U2 = useMemo(() => ({ active: f2, focus: f2, selected: a3, disabled: T2 }), [f2, a3, T2]), w2 = { id: R2, ref: k2, role: "option", tabIndex: T2 === true ? void 0 : -1, "aria-disabled": T2 === true ? true : void 0, "aria-selected": a3, disabled: void 0, onMouseDown: x2, onFocus: P2, onPointerEnter: G2, onMouseEnter: G2, onPointerMove: _2, onMouseMove: _2, onPointerLeave: z, onMouseLeave: z };
  return L$3()({ ourProps: w2, theirProps: m2, slot: U2, defaultTag: Fo, name: "Combobox.Option" });
}
let Mo = K(Eo), Lo = K(Io), Vo = K(ho), wo = V, Bo = K(_o), No = K(So), wt = Object.assign(Mo, { Input: Vo, Button: Lo, Label: wo, Options: Bo, Option: No });
let _ = "div";
function c(d2, l2) {
  let t2 = `headlessui-control-${useId$1()}`, [s2, p2] = Q(), [n2, a3] = w$1(), m2 = a$a(), { disabled: e2 = m2 || false, ...i2 } = d2, o4 = useMemo(() => ({ disabled: e2 }), [e2]), F2 = { ref: l2, disabled: e2 || void 0, "aria-disabled": e2 || void 0 }, T2 = L$3();
  return React__default.createElement(l$6, { value: e2 }, React__default.createElement(p2, { value: s2 }, React__default.createElement(a3, { value: n2 }, React__default.createElement(f$9, { id: t2 }, T2({ ourProps: F2, theirProps: { ...i2, children: React__default.createElement(W, null, typeof i2.children == "function" ? i2.children(o4) : i2.children) }, slot: o4, defaultTag: _, name: "Field" })))));
}
let H = K(c);
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var reservedModifierKeywords = ["shift", "alt", "meta", "mod", "ctrl"];
var mappedKeys = {
  esc: "escape",
  "return": "enter",
  ".": "period",
  ",": "comma",
  "-": "slash",
  " ": "space",
  "`": "backquote",
  "#": "backslash",
  "+": "bracketright",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function mapKey(key) {
  return (mappedKeys[key] || key).trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function isHotkeyModifier(key) {
  return reservedModifierKeywords.includes(key);
}
function parseKeysHookInput(keys, splitKey) {
  if (splitKey === void 0) {
    splitKey = ",";
  }
  return keys.split(splitKey);
}
function parseHotkey(hotkey, combinationKey, description) {
  if (combinationKey === void 0) {
    combinationKey = "+";
  }
  var keys = hotkey.toLocaleLowerCase().split(combinationKey).map(function(k2) {
    return mapKey(k2);
  });
  var modifiers = {
    alt: keys.includes("alt"),
    ctrl: keys.includes("ctrl") || keys.includes("control"),
    shift: keys.includes("shift"),
    meta: keys.includes("meta"),
    mod: keys.includes("mod")
  };
  var singleCharKeys = keys.filter(function(k2) {
    return !reservedModifierKeywords.includes(k2);
  });
  return _extends({}, modifiers, {
    keys: singleCharKeys,
    description
  });
}
(function() {
  if (typeof document !== "undefined") {
    document.addEventListener("keydown", function(e2) {
      if (e2.key === void 0) {
        return;
      }
      pushToCurrentlyPressedKeys([mapKey(e2.key), mapKey(e2.code)]);
    });
    document.addEventListener("keyup", function(e2) {
      if (e2.key === void 0) {
        return;
      }
      removeFromCurrentlyPressedKeys([mapKey(e2.key), mapKey(e2.code)]);
    });
  }
  if (typeof window !== "undefined") {
    window.addEventListener("blur", function() {
      currentlyPressedKeys.clear();
    });
  }
})();
var currentlyPressedKeys = /* @__PURE__ */ new Set();
function isReadonlyArray(value) {
  return Array.isArray(value);
}
function isHotkeyPressed(key, splitKey) {
  if (splitKey === void 0) {
    splitKey = ",";
  }
  var hotkeyArray = isReadonlyArray(key) ? key : key.split(splitKey);
  return hotkeyArray.every(function(hotkey) {
    return currentlyPressedKeys.has(hotkey.trim().toLowerCase());
  });
}
function pushToCurrentlyPressedKeys(key) {
  var hotkeyArray = Array.isArray(key) ? key : [key];
  if (currentlyPressedKeys.has("meta")) {
    currentlyPressedKeys.forEach(function(key2) {
      return !isHotkeyModifier(key2) && currentlyPressedKeys["delete"](key2.toLowerCase());
    });
  }
  hotkeyArray.forEach(function(hotkey) {
    return currentlyPressedKeys.add(hotkey.toLowerCase());
  });
}
function removeFromCurrentlyPressedKeys(key) {
  var hotkeyArray = Array.isArray(key) ? key : [key];
  if (key === "meta") {
    currentlyPressedKeys.clear();
  } else {
    hotkeyArray.forEach(function(hotkey) {
      return currentlyPressedKeys["delete"](hotkey.toLowerCase());
    });
  }
}
function maybePreventDefault(e2, hotkey, preventDefault2) {
  if (typeof preventDefault2 === "function" && preventDefault2(e2, hotkey) || preventDefault2 === true) {
    e2.preventDefault();
  }
}
function isHotkeyEnabled(e2, hotkey, enabled) {
  if (typeof enabled === "function") {
    return enabled(e2, hotkey);
  }
  return enabled === true || enabled === void 0;
}
function isKeyboardEventTriggeredByInput(ev) {
  return isHotkeyEnabledOnTag(ev, ["input", "textarea", "select"]);
}
function isHotkeyEnabledOnTag(_ref, enabledOnTags) {
  var target = _ref.target;
  if (enabledOnTags === void 0) {
    enabledOnTags = false;
  }
  var targetTagName = target && target.tagName;
  if (isReadonlyArray(enabledOnTags)) {
    return Boolean(targetTagName && enabledOnTags && enabledOnTags.some(function(tag) {
      return tag.toLowerCase() === targetTagName.toLowerCase();
    }));
  }
  return Boolean(targetTagName && enabledOnTags && enabledOnTags === true);
}
function isScopeActive(activeScopes, scopes) {
  if (activeScopes.length === 0 && scopes) {
    console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>');
    return true;
  }
  if (!scopes) {
    return true;
  }
  return activeScopes.some(function(scope) {
    return scopes.includes(scope);
  }) || activeScopes.includes("*");
}
var isHotkeyMatchingKeyboardEvent = function isHotkeyMatchingKeyboardEvent2(e2, hotkey, ignoreModifiers) {
  if (ignoreModifiers === void 0) {
    ignoreModifiers = false;
  }
  var alt = hotkey.alt, meta = hotkey.meta, mod = hotkey.mod, shift2 = hotkey.shift, ctrl = hotkey.ctrl, keys = hotkey.keys;
  var pressedKeyUppercase = e2.key, code = e2.code, ctrlKey = e2.ctrlKey, metaKey = e2.metaKey, shiftKey = e2.shiftKey, altKey = e2.altKey;
  var keyCode = mapKey(code);
  var pressedKey = pressedKeyUppercase.toLowerCase();
  if (!(keys != null && keys.includes(keyCode)) && !(keys != null && keys.includes(pressedKey)) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(keyCode)) {
    return false;
  }
  if (!ignoreModifiers) {
    if (alt === !altKey && pressedKey !== "alt") {
      return false;
    }
    if (shift2 === !shiftKey && pressedKey !== "shift") {
      return false;
    }
    if (mod) {
      if (!metaKey && !ctrlKey) {
        return false;
      }
    } else {
      if (meta === !metaKey && pressedKey !== "meta" && pressedKey !== "os") {
        return false;
      }
      if (ctrl === !ctrlKey && pressedKey !== "ctrl" && pressedKey !== "control") {
        return false;
      }
    }
  }
  if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) {
    return true;
  } else if (keys) {
    return isHotkeyPressed(keys);
  } else if (!keys) {
    return true;
  }
  return false;
};
var BoundHotkeysProxyProvider = /* @__PURE__ */ createContext(void 0);
var useBoundHotkeysProxy = function useBoundHotkeysProxy2() {
  return useContext(BoundHotkeysProxyProvider);
};
function deepEqual(x2, y2) {
  return x2 && y2 && typeof x2 === "object" && typeof y2 === "object" ? Object.keys(x2).length === Object.keys(y2).length && //@ts-ignore
  Object.keys(x2).reduce(function(isEqual, key) {
    return isEqual && deepEqual(x2[key], y2[key]);
  }, true) : x2 === y2;
}
var HotkeysContext = /* @__PURE__ */ createContext({
  hotkeys: [],
  enabledScopes: [],
  toggleScope: function toggleScope() {
  },
  enableScope: function enableScope() {
  },
  disableScope: function disableScope() {
  }
});
var useHotkeysContext = function useHotkeysContext2() {
  return useContext(HotkeysContext);
};
function useDeepEqualMemo(value) {
  var ref = useRef(void 0);
  if (!deepEqual(ref.current, value)) {
    ref.current = value;
  }
  return ref.current;
}
var stopPropagation = function stopPropagation2(e2) {
  e2.stopPropagation();
  e2.preventDefault();
  e2.stopImmediatePropagation();
};
var useSafeLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function useHotkeys(keys, callback, options, dependencies) {
  var ref = useRef(null);
  var hasTriggeredRef = useRef(false);
  var _options = !(options instanceof Array) ? options : !(dependencies instanceof Array) ? dependencies : void 0;
  var _keys = isReadonlyArray(keys) ? keys.join(_options == null ? void 0 : _options.splitKey) : keys;
  var _deps = options instanceof Array ? options : dependencies instanceof Array ? dependencies : void 0;
  var memoisedCB = useCallback(callback, _deps != null ? _deps : []);
  var cbRef = useRef(memoisedCB);
  if (_deps) {
    cbRef.current = memoisedCB;
  } else {
    cbRef.current = callback;
  }
  var memoisedOptions = useDeepEqualMemo(_options);
  var _useHotkeysContext = useHotkeysContext(), enabledScopes = _useHotkeysContext.enabledScopes;
  var proxy = useBoundHotkeysProxy();
  useSafeLayoutEffect(function() {
    if ((memoisedOptions == null ? void 0 : memoisedOptions.enabled) === false || !isScopeActive(enabledScopes, memoisedOptions == null ? void 0 : memoisedOptions.scopes)) {
      return;
    }
    var listener = function listener2(e2, isKeyUp) {
      var _e$target;
      if (isKeyUp === void 0) {
        isKeyUp = false;
      }
      if (isKeyboardEventTriggeredByInput(e2) && !isHotkeyEnabledOnTag(e2, memoisedOptions == null ? void 0 : memoisedOptions.enableOnFormTags)) {
        return;
      }
      if (ref.current !== null) {
        var rootNode = ref.current.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement !== ref.current && !ref.current.contains(rootNode.activeElement)) {
          stopPropagation(e2);
          return;
        }
      }
      if ((_e$target = e2.target) != null && _e$target.isContentEditable && !(memoisedOptions != null && memoisedOptions.enableOnContentEditable)) {
        return;
      }
      parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
        var _hotkey$keys;
        var hotkey = parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey);
        if (isHotkeyMatchingKeyboardEvent(e2, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.ignoreModifiers) || (_hotkey$keys = hotkey.keys) != null && _hotkey$keys.includes("*")) {
          if (memoisedOptions != null && memoisedOptions.ignoreEventWhen != null && memoisedOptions.ignoreEventWhen(e2)) {
            return;
          }
          if (isKeyUp && hasTriggeredRef.current) {
            return;
          }
          maybePreventDefault(e2, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.preventDefault);
          if (!isHotkeyEnabled(e2, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.enabled)) {
            stopPropagation(e2);
            return;
          }
          cbRef.current(e2, hotkey);
          if (!isKeyUp) {
            hasTriggeredRef.current = true;
          }
        }
      });
    };
    var handleKeyDown = function handleKeyDown2(event) {
      if (event.key === void 0) {
        return;
      }
      pushToCurrentlyPressedKeys(mapKey(event.code));
      if ((memoisedOptions == null ? void 0 : memoisedOptions.keydown) === void 0 && (memoisedOptions == null ? void 0 : memoisedOptions.keyup) !== true || memoisedOptions != null && memoisedOptions.keydown) {
        listener(event);
      }
    };
    var handleKeyUp = function handleKeyUp2(event) {
      if (event.key === void 0) {
        return;
      }
      removeFromCurrentlyPressedKeys(mapKey(event.code));
      hasTriggeredRef.current = false;
      if (memoisedOptions != null && memoisedOptions.keyup) {
        listener(event, true);
      }
    };
    var domNode = ref.current || (_options == null ? void 0 : _options.document) || document;
    domNode.addEventListener("keyup", handleKeyUp);
    domNode.addEventListener("keydown", handleKeyDown);
    if (proxy) {
      parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
        return proxy.addHotkey(parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
      });
    }
    return function() {
      domNode.removeEventListener("keyup", handleKeyUp);
      domNode.removeEventListener("keydown", handleKeyDown);
      if (proxy) {
        parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
          return proxy.removeHotkey(parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
        });
      }
    };
  }, [_keys, memoisedOptions, enabledScopes]);
  return ref;
}
const SelectFieldDropdown = ({
  children,
  isEmpty,
  offset: offset2 = -12,
  className = clsx("ui:min-w-(--button-width)")
}) => {
  return /* @__PURE__ */ jsx(
    Bo,
    {
      portal: true,
      anchor: { to: "bottom start", gap: 6, offset: offset2, padding: 8 },
      className: clsx(
        "ui:flex ui:max-w-(--ui-breakpoint-lg) ui:flex-col ui:empty:hidden",
        "ui:z-30 ui:rounded-lg ui:border ui:border-primary ui:bg-primary ui:shadow-dropdown-lg",
        className
      ),
      children: isEmpty ? null : /* @__PURE__ */ jsx(ScrollArea, { className: "ui:max-h-80 ui:min-h-0", children })
    }
  );
};
const SelectFieldOption = ({
  item,
  multiple,
  depth = 0,
  className
}) => {
  return /* @__PURE__ */ jsx(
    No,
    {
      value: item.value,
      disabled: item.disabled,
      className: clsx(
        "ui:cursor-pointer ui:px-3.5 ui:py-2.5 ui:text-paragraph-200-regular ui:text-primary",
        "ui:data-focus:bg-secondary ui:dark:data-focus:bg-app-header-hover",
        "ui:data-disabled:cursor-default ui:data-disabled:text-tertiary",
        className
      ),
      children: ({ selected }) => /* @__PURE__ */ jsxs("div", { className: "ui:flex ui:gap-2", style: { paddingLeft: depth * 8 }, children: [
        multiple && /* @__PURE__ */ jsx(
          Checkbox,
          {
            as: "div",
            size: "sm",
            checked: selected,
            className: "ui:mt-0.5"
          }
        ),
        item.displayLabel ?? item.label,
        !multiple && selected && /* @__PURE__ */ jsx(CheckIcon, { className: "ui:ml-auto ui:text-icon-brand" })
      ] })
    }
  );
};
const SelectFieldItemsList = ({
  items,
  multiple,
  depth = 0,
  itemClassName: itemClassName2
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: items.map((item) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(
      SelectFieldOption,
      {
        item,
        multiple,
        depth,
        className: itemClassName2
      }
    ),
    item.items && /* @__PURE__ */ jsx(
      SelectFieldItemsList,
      {
        items: item.items,
        multiple,
        depth: depth + 1
      }
    )
  ] }, String(item.value))) });
};
const SearchField = ({
  className,
  label,
  errorMessage,
  description,
  tooltip,
  results,
  value,
  onValueChange,
  onResultSelect,
  hotkey = "mod+k",
  placeholder,
  autoFocus
}) => {
  const inputRef = useRef(null);
  const triggerSearch = useCallback(() => {
    var _a;
    (_a = inputRef.current) == null ? void 0 : _a.focus();
  }, []);
  const handleSelect = useCallback(
    (value2) => {
      if (value2 != null) {
        onResultSelect(value2);
      }
    },
    [onResultSelect]
  );
  useHotkeys(hotkey, triggerSearch, {
    preventDefault: true,
    enabled: !!hotkey
  });
  const modifierKey = useMemo(() => {
    if (navigator.platform.startsWith("Mac") || navigator.platform === "iPhone") {
      return "⌘";
    }
    return "^";
  }, []);
  return /* @__PURE__ */ jsxs(H, { className, children: [
    /* @__PURE__ */ jsx(V, { as: FieldLabel, label, tooltip }),
    /* @__PURE__ */ jsxs(wt, { immediate: true, value: "", onChange: handleSelect, children: [
      /* @__PURE__ */ jsx(
        Vo,
        {
          ref: inputRef,
          as: FieldInput,
          value,
          onChange: (event) => onValueChange(event.currentTarget.value),
          placeholder,
          autoFocus,
          leadingSlot: /* @__PURE__ */ jsx(MagnifyingGlassIcon, { className: "ui:text-icon-secondary" }),
          trailingSlot: /* @__PURE__ */ jsx(Lo, { className: "ui:flex ui:h-5 ui:min-w-5 ui:items-center ui:justify-center ui:rounded ui:bg-secondary ui:px-0.5 ui:text-paragraph-200-regular ui:text-icon-secondary", children: value ? /* @__PURE__ */ jsx(XIcon, {}) : hotkey.replace(/\+/g, "").replace("mod", modifierKey).toUpperCase() })
        }
      ),
      /* @__PURE__ */ jsx(
        SelectFieldDropdown,
        {
          offset: -24,
          className: "ui:w-[calc(var(--input-width)+var(--button-width)+28px)]",
          isEmpty: results.every((result) => result.items.length === 0),
          children: results.map(
            (result) => result.items.length === 0 ? null : /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("div", { className: "ui:border-b ui:border-primary ui:bg-secondary ui:p-3 ui:text-label-100 ui:text-secondary", children: result.title }),
              /* @__PURE__ */ jsx(
                SelectFieldItemsList,
                {
                  items: result.items.map((item) => ({
                    ...item,
                    displayLabel: /* @__PURE__ */ jsxs("div", { children: [
                      /* @__PURE__ */ jsx("div", { className: "ui:text-paragraph-200-medium", children: item.label }),
                      /* @__PURE__ */ jsx("div", { className: "ui:line-clamp-2 ui:text-secondary", children: item.description })
                    ] })
                  }))
                }
              )
            ] }, result.title)
          )
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      H$3,
      {
        as: FieldInfo,
        errorMessage,
        description
      }
    )
  ] });
};
const SelectFieldActiveOption = ({
  selectValue,
  items,
  selectAllItem,
  renderSelectedValue,
  placeholder
}) => {
  const activeItem = selectAllItem && (selectAllItem.value ?? null) === selectValue ? selectAllItem : items.find((item) => (item.value ?? null) === selectValue);
  const placeholderEl = /* @__PURE__ */ jsx("span", { className: "ui:text-tertiary", children: placeholder });
  return selectValue === void 0 ? placeholderEl : (renderSelectedValue == null ? void 0 : renderSelectedValue(selectValue, items)) ?? (activeItem == null ? void 0 : activeItem.displayLabel) ?? (activeItem == null ? void 0 : activeItem.label) ?? placeholderEl;
};
const sizeClassNames$1 = {
  sm: clsx("ui:h-6.5 ui:px-2.5 ui:text-paragraph-100-regular"),
  md: clsx("ui:h-[38px] ui:px-3 ui:text-paragraph-200-regular")
};
const SelectFieldButton = ({
  className,
  search,
  setSearch,
  searchable,
  children,
  onFocus,
  placeholder,
  size: size2 = "md"
}) => {
  return /* @__PURE__ */ jsxs(
    Lo,
    {
      as: "div",
      className: clsx(
        "ui:group/button ui:relative ui:flex ui:cursor-default ui:overflow-hidden",
        "ui:rounded-lg ui:border ui:border-primary ui:bg-input ui:text-secondary ui:transition",
        "ui:hover:border-input-hover ui:hover:bg-input-hover",
        "ui:aria-expanded:border-brand ui:aria-expanded:bg-input-hover",
        "ui:data-disabled:bg-secondary ui:data-disabled:text-tertiary",
        searchable && "ui:aria-expanded:min-w-22",
        // a min width to display input placeholder
        sizeClassNames$1[size2],
        className
      ),
      onFocus,
      children: [
        /* @__PURE__ */ jsx(
          Vo,
          {
            className: clsx(
              "ui:w-0 ui:min-w-0 ui:appearance-none ui:border-0 ui:bg-transparent ui:text-inherit ui:outline-hidden",
              "ui:absolute ui:inset-y-0",
              searchable && "ui:aria-expanded:w-[calc(100%-40px)]"
              // 40px is the width of the chevron
            ),
            value: search,
            onChange: (event) => setSearch(event.currentTarget.value),
            onKeyDown: (event) => event.stopPropagation(),
            readOnly: !searchable,
            placeholder,
            size: (placeholder == null ? void 0 : placeholder.length) ?? void 0
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx(
              "ui:flex ui:min-w-0 ui:grow ui:items-center",
              searchable && "ui:group-aria-expanded/button:invisible"
            ),
            children: /* @__PURE__ */ jsx("span", { className: "ui:truncate", children })
          }
        ),
        /* @__PURE__ */ jsx(
          CaretDownIcon,
          {
            className: clsx(
              "ui:shrink-0 ui:self-center ui:text-icon-secondary",
              "ui:group-data-disabled/button:text-icon-tertiary",
              size2 === "sm" ? "ui:ml-1" : "ui:ml-2"
            )
          }
        )
      ]
    }
  );
};
const useComboboxValue = ({
  multiple,
  selectValue,
  items,
  onSelect
}) => {
  const comboboxValue = multiple && Array.isArray(selectValue) ? expandValues(selectValue, items) : selectValue;
  const setComboboxValue = (selection) => {
    if (multiple) {
      onSelect(
        collapseValues(
          Array.isArray(selection) ? selection : [],
          Array.isArray(comboboxValue) ? comboboxValue : [],
          items
        )
      );
    } else if (selection !== selectValue && selection != null) {
      onSelect(selection);
    }
  };
  return { comboboxValue, setComboboxValue };
};
const getSelectableItems = (items) => items.filter((item) => !item.disabled);
const expandValues = (values, items) => {
  return items.flatMap((item) => {
    if (item.disabled) {
      return [];
    }
    const selectableItems = item.items ? getSelectableItems(item.items) : [];
    const selected = values.includes(item.value) || selectableItems.length > 0 && selectableItems.every((item2) => values.includes(item2.value));
    if (!item.items) {
      return selected ? [item.value] : [];
    }
    if (!selected) {
      return expandValues(values, item.items);
    }
    const childrenValues = selectableItems.map((item2) => item2.value);
    return [item.value, ...expandValues(childrenValues, item.items)];
  });
};
const collapseValues = (values, prevValues, items) => {
  return items.flatMap((item) => {
    if (item.disabled) {
      return [];
    }
    const selected = values.includes(item.value);
    const prevSelected = prevValues.includes(item.value);
    if (!item.items || prevSelected !== selected) {
      if (item.value === void 0) {
        return selected ? getSelectableItems(item.items ?? []).map((item2) => item2.value) : [];
      }
      return selected ? [item.value] : [];
    }
    const childrenValues = collapseValues(values, prevValues, item.items);
    const selectableItems = getSelectableItems(item.items);
    const allChildrenSelected = selectableItems.length > 0 && childrenValues.length === selectableItems.length;
    if (allChildrenSelected) {
      return item.value === void 0 ? childrenValues : [item.value];
    }
    return childrenValues;
  });
};
const useSelectItems = ({
  items,
  selectAllItem,
  search
}) => {
  const nestedItems = useMemo(
    () => selectAllItem ? [{ ...selectAllItem, items }] : items,
    [items, selectAllItem]
  );
  const flatItems = useMemo(() => flattenItems(nestedItems), [nestedItems]);
  const normalizedSearch = search.trim().toLowerCase();
  const isFiltered = !!normalizedSearch;
  const filteredItems = useMemo(
    () => isFiltered ? flatItems.filter(
      (item) => item.label.toLowerCase().includes(normalizedSearch)
    ) : nestedItems,
    [flatItems, nestedItems, isFiltered, normalizedSearch]
  );
  return {
    nestedItems,
    filteredItems,
    isFiltered: normalizedSearch,
    isEmpty: filteredItems.length === 0
  };
};
const flattenItems = (items) => {
  return items.flatMap(({ items: items2, ...item }) => {
    return items2 ? [item, ...flattenItems(items2)] : item;
  });
};
const SelectField = ({
  value,
  multiselect: multiple,
  defaultValue,
  items,
  selectAllItem,
  label,
  tooltip,
  errorMessage,
  description,
  placeholder = "Select",
  className,
  buttonClassName: buttonClassName2,
  itemClassName: itemClassName2,
  dropdownClassName,
  disabled,
  searchable = true,
  size: size2,
  onSelect,
  onSearch,
  onClose,
  onOpen,
  renderSelectedValue
}) => {
  const emptyValue = multiple ? [] : null;
  const [search, setSearch] = useState("");
  const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
  const { filteredItems, nestedItems, isFiltered, isEmpty } = useSelectItems({
    items,
    selectAllItem,
    search
  });
  const localValue = value !== void 0 ? value : uncontrolledValue !== void 0 ? uncontrolledValue : emptyValue;
  const { comboboxValue, setComboboxValue } = useComboboxValue({
    selectValue: localValue,
    multiple,
    items: nestedItems,
    onSelect: (value2) => {
      setUncontrolledValue(value2);
      onSelect == null ? void 0 : onSelect(value2);
    }
  });
  const handleSetSearch = (search2) => {
    setSearch(search2);
    onSearch == null ? void 0 : onSearch(search2);
  };
  const handleClose = () => {
    handleSetSearch("");
    onClose == null ? void 0 : onClose();
  };
  return /* @__PURE__ */ jsxs(H, { className, disabled, children: [
    /* @__PURE__ */ jsx(V, { as: FieldLabel, label, tooltip }),
    /* @__PURE__ */ jsxs(
      wt,
      {
        immediate: true,
        multiple,
        value: comboboxValue,
        onClose: handleClose,
        onChange: setComboboxValue,
        children: [
          /* @__PURE__ */ jsx(
            SelectFieldButton,
            {
              className: buttonClassName2,
              size: size2,
              search,
              setSearch: handleSetSearch,
              searchable,
              onFocus: onOpen,
              placeholder,
              children: /* @__PURE__ */ jsx(
                SelectFieldActiveOption,
                {
                  items,
                  selectAllItem,
                  placeholder,
                  renderSelectedValue,
                  selectValue: localValue
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(SelectFieldDropdown, { isEmpty, className: dropdownClassName, children: isFiltered ? /* @__PURE__ */ jsx(SelectFieldItemsList, { items: filteredItems, multiple }) : (
            // use items directly instead of using the nestedItems to show selectAllItem without nesting
            /* @__PURE__ */ jsxs(Fragment, { children: [
              selectAllItem && /* @__PURE__ */ jsx(
                SelectFieldOption,
                {
                  item: selectAllItem,
                  multiple,
                  className: itemClassName2
                }
              ),
              /* @__PURE__ */ jsx(
                SelectFieldItemsList,
                {
                  items,
                  multiple,
                  itemClassName: itemClassName2
                }
              )
            ] })
          ) })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      H$3,
      {
        as: FieldInfo,
        errorMessage,
        description
      }
    )
  ] });
};
const inputWrapperClassName = clsx(
  "ui:flex ui:border ui:border-primary ui:bg-input ui:transition",
  "ui:rounded-lg ui:text-paragraph-200-regular",
  "ui:data-[disabled=true]:bg-secondary",
  "ui:hover:border-input-hover ui:hover:bg-input-hover",
  "ui:focus-within:border-brand ui:focus-within:bg-input-hover ui:focus-within:shadow-none ui:focus-within:hover:border-brand",
  "ui:data-[invalid=true]:border-critical"
);
const inputClassName = clsx(
  "ui:block ui:w-full ui:bg-transparent ui:p-3 ui:text-ellipsis ui:text-secondary ui:outline-hidden",
  "ui:placeholder:text-tertiary",
  "ui:disabled:text-tertiary",
  "ui:resize-none"
);
const FieldTextarea = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-disabled": props.disabled,
        "data-invalid": props["aria-invalid"],
        className: clsx(className, inputWrapperClassName),
        children: /* @__PURE__ */ jsx("textarea", { ref, className: inputClassName, ...props })
      }
    );
  }
);
const textFieldClassName$1 = clsx("ui:flex ui:flex-col");
const TextAreaField = forwardRef(
  ({
    className,
    label,
    tooltip,
    description,
    errorMessage,
    inputContainerClassName,
    ...props
  }, ref) => {
    const labelId = useId$1();
    const inputId = useId$1();
    const infoId = useId$1();
    return /* @__PURE__ */ jsxs("div", { className: clsx(className, textFieldClassName$1), children: [
      /* @__PURE__ */ jsx(
        FieldLabel,
        {
          label,
          tooltip,
          htmlFor: inputId,
          id: labelId
        }
      ),
      /* @__PURE__ */ jsx(
        FieldTextarea,
        {
          ...props,
          id: inputId,
          ref,
          className: inputContainerClassName,
          "aria-invalid": !!errorMessage,
          "aria-labelledby": label ? labelId : void 0,
          "aria-describedby": errorMessage || description ? infoId : void 0
        }
      ),
      /* @__PURE__ */ jsx(FieldInfo, { errorMessage, description })
    ] });
  }
);
const textFieldClassName = clsx("ui:flex ui:flex-col");
const TextField = forwardRef(
  ({ className, label, tooltip, description, errorMessage, ...props }, ref) => {
    const labelId = useId$1();
    const inputId = useId$1();
    const infoId = useId$1();
    return /* @__PURE__ */ jsxs("div", { className: clsx(className, textFieldClassName), children: [
      /* @__PURE__ */ jsx(
        FieldLabel,
        {
          label,
          tooltip,
          htmlFor: inputId,
          id: labelId
        }
      ),
      /* @__PURE__ */ jsx(
        FieldInput,
        {
          ...props,
          id: inputId,
          ref,
          "aria-invalid": !!errorMessage,
          "aria-labelledby": label ? labelId : void 0,
          "aria-describedby": errorMessage || description ? infoId : void 0
        }
      ),
      /* @__PURE__ */ jsx(FieldInfo, { errorMessage, description })
    ] });
  }
);
const linkClassName = clsx(
  "ui:-m-0.5 ui:cursor-pointer ui:rounded ui:p-0.5 ui:outline-hidden ui:transition ui:focus-visible:shadow-focus",
  "ui:text-link-200 ui:font-medium ui:underline ui:hover:no-underline"
);
const AnnouncementBannerLink = ({ as: Component = "a", className, ...props }) => {
  return /* @__PURE__ */ jsx(Component, { ...props, className: clsx(linkClassName, className) });
};
const bannerClassName = clsx(
  "ui:group ui:flex ui:items-start ui:gap-2 ui:rounded-lg ui:border ui:px-4 ui:py-2 ui:text-center ui:text-paragraph-200-regular"
);
const intentClassName = {
  default: clsx("ui:border-primary ui:bg-secondary ui:text-primary"),
  info: clsx("ui:border-brand ui:bg-informative-subtle ui:text-informative"),
  warning: clsx("ui:border-warning ui:bg-warning-subtle ui:text-warning"),
  error: clsx("ui:border-critical ui:bg-critical-subtle ui:text-critical")
};
const contentClassName = clsx("ui:flex-1");
const AnnouncementBanner = ({
  className,
  intent = "default",
  children,
  onDismiss,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...props,
      className: clsx(bannerClassName, intentClassName[intent], className),
      role: "banner",
      children: [
        /* @__PURE__ */ jsx("div", { className: contentClassName, children }),
        onDismiss ? /* @__PURE__ */ jsx(IconButton, { padding: "sm", onClick: onDismiss, children: /* @__PURE__ */ jsx(XIcon, { "aria-label": "Close" }) }) : null
      ]
    }
  );
};
AnnouncementBanner.Link = AnnouncementBannerLink;
const StepperStepButton = ({ children, isActive }) => {
  const buttonRef = useRef(null);
  useEffect(() => {
    if (!isActive || !buttonRef.current) {
      return;
    }
    buttonRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [isActive]);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      disabled: true,
      ref: buttonRef,
      className: "ui:group ui:relative ui:mr-8 ui:px-2 ui:py-2.5 ui:text-center ui:last:mr-0",
      children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: clsx(
              "ui:text-label-300 ui:whitespace-nowrap",
              isActive ? "ui:text-brand" : "ui:text-tertiary"
            ),
            children
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "ui:absolute ui:top-1/2 ui:left-full ui:-mt-px ui:ml-4 ui:w-10 ui:border ui:border-primary ui:group-last:hidden" })
      ]
    }
  );
};
const Stepper = ({ className, steps, activeValue }) => {
  return /* @__PURE__ */ jsx(ScrollArea, { scrollBarClassName: "ui:hidden", children: /* @__PURE__ */ jsx("div", { className: clsx("ui:flex", className), children: /* @__PURE__ */ jsx("div", { className: "ui:mx-auto ui:grid ui:w-fit ui:grid-flow-col ui:gap-10", children: steps.map((step, index2) => /* @__PURE__ */ jsxs(
    StepperStepButton,
    {
      isActive: activeValue === step.value,
      children: [
        index2 + 1,
        ". ",
        step.label
      ]
    },
    String(step.value)
  )) }) }) });
};
const baseTableBodyClassName = clsx(
  "ui:table-row-group",
  "ui:dark:[&>tr:first-child:hover>td]:border-t-white/10"
);
const TableBody = ({
  as: Component = "tbody",
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Component,
    {
      role: "rowgroup",
      ...props,
      className: clsx(baseTableBodyClassName, className)
    }
  );
};
const baseTableCellClassName = clsx(
  "ui:table-cell ui:px-3 ui:align-middle",
  "ui:border-t ui:border-primary ui:text-paragraph-200-regular",
  "ui:first:group-last:rounded-bl-[7px] ui:last:group-last:rounded-br-[7px]",
  "ui:first:pl-4 ui:last:pr-4"
);
const fullWidthClassName = clsx("ui:max-w-0");
const sizeClassNames = {
  sm: clsx("ui:py-2"),
  md: clsx("ui:py-3"),
  lg: clsx("ui:py-5")
};
const TableCell = ({
  as: Component = "td",
  className,
  fullWidth,
  size: size2 = "md",
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Component,
    {
      role: "gridcell",
      colSpan: fullWidth ? 100 : void 0,
      ...props,
      className: clsx(
        baseTableCellClassName,
        sizeClassNames[size2],
        fullWidth ? fullWidthClassName : null,
        className
      )
    }
  );
};
const baseTableColumnClassName = clsx(
  "ui:table-cell ui:p-3",
  "ui:bg-secondary ui:text-start ui:text-label-200 ui:text-secondary",
  "ui:first:group-first:rounded-tl-[inherit] ui:last:group-first:rounded-tr-[inherit]",
  "ui:first:pl-4 ui:last:pr-4"
);
const sortButtonClassName = clsx(
  "ui:group/sort ui:-mx-2 ui:-my-0.5 ui:flex ui:gap-0.5 ui:rounded ui:px-2 ui:py-0.5"
);
const sortIconClassName = clsx(
  "ui:group-hover/sort:visible",
  "ui:mt-0.5 ui:-mr-1"
);
const invisibleClassName = clsx("ui:invisible");
const TableColumn = ({
  as: Component = "th",
  className,
  sort,
  onSort,
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Component,
    {
      role: "columnheader",
      ...props,
      className: clsx(baseTableColumnClassName, className),
      children: onSort ? /* @__PURE__ */ jsxs(
        Command,
        {
          background: "none",
          className: sortButtonClassName,
          onClick: () => onSort(
            sort === TableSortOrder.Asc ? TableSortOrder.Desc : TableSortOrder.Asc
          ),
          children: [
            children,
            /* @__PURE__ */ jsx("div", { className: clsx(!sort && invisibleClassName, sortIconClassName), children: sort && sort === TableSortOrder.Asc ? /* @__PURE__ */ jsx(CaretUpIcon, {}) : /* @__PURE__ */ jsx(CaretDownIcon, {}) })
          ]
        }
      ) : children
    }
  );
};
const baseTableHeaderClassName = clsx("ui:table-header-group");
const TableHeader = ({
  as: Component = "thead",
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Component,
    {
      role: "rowgroup",
      ...props,
      className: clsx(baseTableHeaderClassName, className)
    }
  );
};
const baseTableRowClassName = clsx(
  "ui:group ui:table-row ui:bg-card ui:outline-hidden ui:focus-visible:shadow-focus"
);
const interactiveTableRowClassName = clsx(
  "ui:transition-colors ui:hover:bg-brand-subtle ui:dark:hover:bg-secondary"
);
const TableRow = ({
  as: Component = "tr",
  className,
  interactive,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Component,
    {
      role: "row",
      ...props,
      className: clsx(
        baseTableRowClassName,
        { [interactiveTableRowClassName]: interactive },
        className
      )
    }
  );
};
var TableSortOrder = /* @__PURE__ */ ((TableSortOrder2) => {
  TableSortOrder2["Asc"] = "asc";
  TableSortOrder2["Desc"] = "desc";
  return TableSortOrder2;
})(TableSortOrder || {});
const tableScrollClassName = clsx(
  "ui:overflow-hidden ui:rounded-lg ui:border ui:border-primary ui:text-secondary"
);
const tableGridClassName = clsx("ui:table ui:w-full");
const Table = ({
  as: Component = "table",
  className,
  children
}) => {
  return /* @__PURE__ */ jsx(ScrollArea, { className: clsx(tableScrollClassName, className), size: "sm", children: /* @__PURE__ */ jsx(Component, { role: "grid", className: tableGridClassName, children }) });
};
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Column = TableColumn;
Table.Row = TableRow;
Table.Cell = TableCell;
const getVariableValue = (variable) => {
  const styles2 = getComputedStyle(document.documentElement);
  return styles2.getPropertyValue(variable);
};
const BREAKPOINTS = ["sm", "md", "lg", "xl", "2xl", "3xl"];
const initialActiveBreakpoints = Object.fromEntries(
  BREAKPOINTS.map((breakpoint) => [breakpoint, false])
);
const useBreakpoint = () => {
  const [activeBreakpoints, setActiveBreakpoints] = useState(
    initialActiveBreakpoints
  );
  const breakpointMedias = useMemo(
    () => Object.fromEntries(
      BREAKPOINTS.map((breakpoint) => [
        breakpoint,
        `(min-width: ${getVariableValue(`--breakpoint-${breakpoint}`)})`
      ])
    ),
    []
  );
  useEffect(() => {
    const listener = (event) => {
      const currentMatch = event.currentTarget;
      const breakpoints = BREAKPOINTS.filter(
        (breakpoint) => breakpointMedias[breakpoint] === currentMatch.media
      );
      if (breakpoints.length === 0) {
        return;
      }
      setActiveBreakpoints((activeBreakpoints2) => ({
        ...activeBreakpoints2,
        ...Object.fromEntries(
          breakpoints.map((name) => [name, currentMatch.matches])
        )
      }));
    };
    const matches = Object.entries(breakpointMedias).map(
      ([breakpoint, media]) => {
        const match = window.matchMedia(media);
        match.addEventListener("change", listener);
        setActiveBreakpoints((breakpoints) => ({
          ...breakpoints,
          [breakpoint]: match.matches
        }));
        return match;
      }
    );
    return () => {
      matches.forEach((match) => {
        match.removeEventListener("change", listener);
      });
    };
  }, [breakpointMedias]);
  const currentBreakpoint = [...BREAKPOINTS].reverse().find((breakpoint) => activeBreakpoints[breakpoint]);
  return currentBreakpoint;
};
const useBreakpointValue = (values) => {
  const breakpoint = useBreakpoint();
  const breakpointIndex = breakpoint ? BREAKPOINTS.indexOf(breakpoint) : -1;
  const activeBreakpoints = BREAKPOINTS.slice(0, breakpointIndex + 1);
  const activeBreakpointValue = [...activeBreakpoints].reverse().find((name) => Object.prototype.hasOwnProperty.call(values, name));
  return values[activeBreakpointValue || "base"];
};
var toggleSelection;
var hasRequiredToggleSelection;
function requireToggleSelection() {
  if (hasRequiredToggleSelection) return toggleSelection;
  hasRequiredToggleSelection = 1;
  toggleSelection = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) {
      return function() {
      };
    }
    var active = document.activeElement;
    var ranges = [];
    for (var i2 = 0; i2 < selection.rangeCount; i2++) {
      ranges.push(selection.getRangeAt(i2));
    }
    switch (active.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        active.blur();
        break;
      default:
        active = null;
        break;
    }
    selection.removeAllRanges();
    return function() {
      selection.type === "Caret" && selection.removeAllRanges();
      if (!selection.rangeCount) {
        ranges.forEach(function(range) {
          selection.addRange(range);
        });
      }
      active && active.focus();
    };
  };
  return toggleSelection;
}
var copyToClipboard$1;
var hasRequiredCopyToClipboard;
function requireCopyToClipboard() {
  if (hasRequiredCopyToClipboard) return copyToClipboard$1;
  hasRequiredCopyToClipboard = 1;
  var deselectCurrent = requireToggleSelection();
  var clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
  };
  var defaultMessage = "Copy to clipboard: #{key}, Enter";
  function format2(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
  }
  function copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) {
      options = {};
    }
    debug = options.debug || false;
    try {
      reselectPrevious = deselectCurrent();
      range = document.createRange();
      selection = document.getSelection();
      mark = document.createElement("span");
      mark.textContent = text;
      mark.ariaHidden = "true";
      mark.style.all = "unset";
      mark.style.position = "fixed";
      mark.style.top = 0;
      mark.style.clip = "rect(0, 0, 0, 0)";
      mark.style.whiteSpace = "pre";
      mark.style.webkitUserSelect = "text";
      mark.style.MozUserSelect = "text";
      mark.style.msUserSelect = "text";
      mark.style.userSelect = "text";
      mark.addEventListener("copy", function(e2) {
        e2.stopPropagation();
        if (options.format) {
          e2.preventDefault();
          if (typeof e2.clipboardData === "undefined") {
            debug && console.warn("unable to use e.clipboardData");
            debug && console.warn("trying IE specific stuff");
            window.clipboardData.clearData();
            var format3 = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
            window.clipboardData.setData(format3, text);
          } else {
            e2.clipboardData.clearData();
            e2.clipboardData.setData(options.format, text);
          }
        }
        if (options.onCopy) {
          e2.preventDefault();
          options.onCopy(e2.clipboardData);
        }
      });
      document.body.appendChild(mark);
      range.selectNodeContents(mark);
      selection.addRange(range);
      var successful = document.execCommand("copy");
      if (!successful) {
        throw new Error("copy command was unsuccessful");
      }
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using execCommand: ", err);
      debug && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(options.format || "text", text);
        options.onCopy && options.onCopy(window.clipboardData);
        success = true;
      } catch (err2) {
        debug && console.error("unable to copy using clipboardData: ", err2);
        debug && console.error("falling back to prompt");
        message = format2("message" in options ? options.message : defaultMessage);
        window.prompt(message, text);
      }
    } finally {
      if (selection) {
        if (typeof selection.removeRange == "function") {
          selection.removeRange(range);
        } else {
          selection.removeAllRanges();
        }
      }
      if (mark) {
        document.body.removeChild(mark);
      }
      reselectPrevious();
    }
    return success;
  }
  copyToClipboard$1 = copy;
  return copyToClipboard$1;
}
var copyToClipboardExports = requireCopyToClipboard();
const copyToClipboard = /* @__PURE__ */ getDefaultExportFromCjs(copyToClipboardExports);
function useCopyToClipboard({ timeout = 1500 } = {}) {
  const [isCopiedToClipboard, setIsCopiedToClipboard] = useState(false);
  const copyTimeoutRef = useRef(void 0);
  const cleanupTimeout = () => {
    if (copyTimeoutRef.current) {
      clearTimeout(copyTimeoutRef.current);
    }
  };
  const handleCopyToClipboard = (value) => {
    cleanupTimeout();
    copyToClipboard(value);
    setIsCopiedToClipboard(true);
    copyTimeoutRef.current = setTimeout(
      () => setIsCopiedToClipboard(false),
      timeout
    );
  };
  useEffect(() => {
    return () => cleanupTimeout();
  }, []);
  return { handleCopyToClipboard, isCopiedToClipboard };
}
const useScrollAreaShadows = ({
  threshold = 0,
  enabled = true
} = {}) => {
  const scrollAreaRef = useRef(null);
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const scrollAreaElement = scrollAreaRef.current;
    const scrollContentsElement = scrollAreaElement == null ? void 0 : scrollAreaElement.children[0];
    if (!scrollAreaElement || !scrollContentsElement) {
      throw new Error(
        "Make sure to pass scrollAreaRef to ScrollArea component."
      );
    }
    const handleScroll = () => {
      const topScrolled = scrollAreaElement.scrollTop > threshold;
      const bottomScrolled = scrollAreaElement.scrollTop < scrollAreaElement.scrollHeight - scrollAreaElement.offsetHeight - threshold;
      setShowTopShadow(topScrolled);
      setShowBottomShadow(bottomScrolled);
    };
    scrollAreaElement.addEventListener("scroll", handleScroll);
    const observer = new ResizeObserver(handleScroll);
    observer.observe(scrollContentsElement);
    return () => {
      scrollAreaElement.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, [threshold, enabled]);
  return {
    scrollAreaRef,
    showTopShadow,
    showBottomShadow
  };
};
export {
  AnalyticsCard,
  AnnouncementBanner,
  Avatar,
  Badge,
  Button,
  Card,
  Checkbox,
  CodeBox,
  CodeBoxHighlighter,
  CodeBoxJson,
  Command,
  CopyButton,
  CopyField,
  CopyTextButton,
  Disclosure,
  DropdownMenu,
  ErrorView,
  ExploreCard,
  FeatureCard,
  FieldInfo,
  FieldInput,
  FieldLabel,
  IconButton,
  InlineAlert,
  InlineSnippet,
  Link,
  Loading,
  LowOpacityButton,
  Modal,
  ReferralButton as PillButton,
  Radio,
  ScrollArea,
  SearchField,
  SelectField,
  Skeleton,
  Stepper,
  Table,
  TableSortOrder,
  Tabs,
  TextAreaField,
  TextField,
  Toggle,
  Tooltip,
  useBreakpoint,
  useBreakpointValue,
  useCopyToClipboard,
  useScrollAreaShadows
};
